const dataStoreL = [
  {
    "value": [
      {
        "@odata.etag": "W/\"JzIwOzEwNDEwMDE2NjA4MjU0MTk3NzUwMTswMDsn\"",
        "no": "C10004",
        "name": "ByNord",
        "eMail": "info@bynord.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Lange Hofstraat 16-a",
        "postCode": "7201 HV",
        "city": "Zutphen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-13",
        "homepage": "https://www.bynord.nl/nl/",
        "latitude": 52.1406191,
        "longitude": 6.1953342,
        "customAddr": "Lange Hofstraat 16-a, Zutphen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ1MDM3MzQ5ODM4NDIwMzE4OTExOzAwOyc=\"",
        "no": "C10005",
        "name": "Tokoloco",
        "eMail": "info@toko-loco.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Bierstraat 1",
        "postCode": "7241 AG",
        "city": "Lochem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.1612297,
        "longitude": 6.41639,
        "customAddr": "Bierstraat 1, Lochem, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2OTU0MDA3MDE1OTEzNjQ4MDMwMTswMDsn\"",
        "no": "C10006",
        "name": "De Vuursche Schaapskooi",
        "eMail": "info@devuurscheschaapskooi.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Hoge Vuurseweg 1-b",
        "postCode": "3749 AB",
        "city": "Lage Vuursche",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.1816098,
        "longitude": 5.22538,
        "customAddr": "Hoge Vuurseweg 1-b, Lage Vuursche, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzIyMTQ2NTQwNDUzNTUzMjM2MjMxOzAwOyc=\"",
        "no": "C10007",
        "name": "elena clothing",
        "eMail": "info@jphstore.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Jan Pieter Heijestraat 79-81",
        "postCode": "1053 GM",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3641728,
        "longitude": 4.8632744,
        "customAddr": "Jan Pieter Heijestraat 79-81, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg0ODE1MTU1ODk0Mzg5ODUxNTMxOzAwOyc=\"",
        "no": "C10008",
        "name": "Wolboerderij De Wildakker",
        "eMail": "info@dewildakker.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kanaal Zuid 196",
        "postCode": "7364 AH",
        "city": "Lieren",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-18",
        "homepage": "https://www.dewildakker.nl/",
        "latitude": 52.1781083,
        "longitude": 5.9930417,
        "customAddr": "Kanaal Zuid 196, Lieren, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgzMjA1Nzg1NzU5MjUzMzE5MjcxOzAwOyc=\"",
        "no": "C10009",
        "name": "Lab. Baarn BV",
        "eMail": "info@labbaarn.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Laanstraat 24",
        "postCode": "3743 BG",
        "city": "Baarn",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.labshopinshop.nl/nl/",
        "latitude": 52.2116943,
        "longitude": 5.2890868,
        "customAddr": "Laanstraat 24, Baarn, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc5OTk0MDM3NzE2OTk2MzY3NTYxOzAwOyc=\"",
        "no": "C10010",
        "name": "Flotte",
        "eMail": "info@flotte.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Grote Overstraat 77",
        "postCode": "7411 JB",
        "city": "Deventer",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.2520963,
        "longitude": 6.159665,
        "customAddr": "Grote Overstraat 77, Deventer, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU3OTY1MDgxNjEzMzkzMjcwOTYxOzAwOyc=\"",
        "no": "C10011",
        "name": "Natuurdrogist Nijmegen",
        "eMail": "denatuurdrogistbeuningen@hotmail.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Stikke Hezelstraat 81",
        "postCode": "6511 JW",
        "city": "Nijmegen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-06-04",
        "homepage": "",
        "latitude": 51.8474375,
        "longitude": 5.861912299999999,
        "customAddr": "Stikke Hezelstraat 81, Nijmegen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQwNTgzOTE1NzAxMTA1MDg3NjUxOzAwOyc=\"",
        "no": "C10013",
        "name": "Schoenmode Jeannette",
        "eMail": "info@schoenmodejeannette.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Hoofdstraat 41",
        "postCode": "7011AC",
        "city": "Gaanderen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9326199,
        "longitude": 6.347755299999999,
        "customAddr": "Hoofdstraat 41, Gaanderen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg2OTI3OTc4ODA2NTM0MTkwOTgxOzAwOyc=\"",
        "no": "C10014",
        "name": "De Kleine Parade Amsterdam BV",
        "eMail": "info@dekleineparade.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Gerard Doustraat 144",
        "postCode": "1073 VX",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.dekleineparade.com/nl/",
        "latitude": 52.35606199999999,
        "longitude": 4.8939591,
        "customAddr": "Gerard Doustraat 144, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NDYwMjA1NDE0NTI1NzU3MjczMTswMDsn\"",
        "no": "C10015",
        "name": "Kleine planeet",
        "eMail": "kleineplaneetconcept@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Botermarkt 25",
        "postCode": "2311 EN",
        "city": "Leiden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://kleineplaneet.nl/",
        "latitude": 52.15675539999999,
        "longitude": 4.4930999,
        "customAddr": "Botermarkt 25, Leiden, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3Nzg0OTc4NDg2Mjk0NTE2ODY1MTswMDsn\"",
        "no": "C10016",
        "name": "Meet Mister Fred / spruiy",
        "eMail": "info@meetmisterfred-shop.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Nachtegaalstraat 17",
        "postCode": "8916 BA",
        "city": "Leeuwarden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.2057899,
        "longitude": 5.7828893,
        "customAddr": "Nachtegaalstraat 17, Leeuwarden, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3NzQyMzI5NDAzODEwMDU3OTMyMTswMDsn\"",
        "no": "C10017",
        "name": "Wonder for kids",
        "eMail": "facturen@wonderforkids.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Houtstraat 46",
        "postCode": "6511 JP",
        "city": "Nijmegen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.wonderforkids.nl/",
        "latitude": 51.8472496,
        "longitude": 5.861721699999999,
        "customAddr": "Houtstraat 46, Nijmegen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzczNTkyMzIzMjQ4MjcwNzUwMDYxOzAwOyc=\"",
        "no": "C10018",
        "name": "THE CHILDHOOD COLLECTIVE",
        "eMail": "yarajongejan@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Mosagaat 42",
        "postCode": "1703 BR",
        "city": "Heerhugowaard",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.6625587,
        "longitude": 4.816362199999999,
        "customAddr": "Mosagaat 42, Heerhugowaard, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzY3MTMwMzkxNTU5MjYwODkyOTQxOzAwOyc=\"",
        "no": "C10019",
        "name": "Atelier de Schapekop",
        "eMail": "schapekop@zeelandnet.nl",
        "customerGroup": "PHYSICAL",
        "address": "Kerkstraat 3",
        "postCode": "4351 AK",
        "city": "Veere",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.5485064,
        "longitude": 3.6680783,
        "customAddr": "Kerkstraat 3, Veere, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2MDkwOTE0MzgyMzQzMjk2MjIzMTswMDsn\"",
        "no": "C10020",
        "name": "Mirle and Tess",
        "eMail": "hello@mirle-and-tess.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Droogmakerij 42a",
        "postCode": "1851 LX",
        "city": "Santpoort Zuid",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.419708,
        "longitude": 4.630381499999999,
        "customAddr": "Droogmakerij 42a, Santpoort Zuid, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ0NjY3OTY2NTczODMyNTQzMTYxOzAwOyc=\"",
        "no": "C10021",
        "name": "A Lot Of",
        "eMail": "connect@alotof.eu",
        "customerGroup": "PHYSICAL",
        "address": "Burgemeester Cortenstraat 4a3",
        "postCode": "6226 GV",
        "city": "Maastricht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.8438294,
        "longitude": 5.7277917,
        "customAddr": "Burgemeester Cortenstraat 4a3, Maastricht, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzcyODQzNTYwODcwMjMxNzc1NzMxOzAwOyc=\"",
        "no": "C10022",
        "name": "Texelana BV",
        "eMail": "frida@texelana.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Heemskerckstraat 8",
        "postCode": "1792 AB",
        "city": "Oudeschild",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.0395976,
        "longitude": 4.8479652,
        "customAddr": "Heemskerckstraat 8, Oudeschild, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ0MzYzNjYyMjYzNTUzMjc3MjkxOzAwOyc=\"",
        "no": "C10023",
        "name": "Mijn Hemeltje",
        "eMail": "info@mijnhemeltje.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Frits Ruysstraat 54",
        "postCode": "3061 MG",
        "city": "Rotterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.mijnhemeltje.nl/",
        "latitude": 51.926509,
        "longitude": 4.5020323,
        "customAddr": "Frits Ruysstraat 54, Rotterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzI1NzM0MDQyNzk5MzYwMzkyMjAxOzAwOyc=\"",
        "no": "C10025",
        "name": "Kikkerkoning",
        "eMail": "kikkerkoning@live.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Aert van der Goesstraat 48",
        "postCode": "2582 AL",
        "city": "Den-Haag",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-04-03",
        "homepage": "https://dekikkerkoning.com/",
        "latitude": 52.08796710000001,
        "longitude": 4.2776577,
        "customAddr": "Aert van der Goesstraat 48, Den-Haag, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4NDEwOTAyNTUwNzY3MjM0ODgwMTswMDsn\"",
        "no": "C10026",
        "name": "Studio Play",
        "eMail": "hello@studioplay.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Kammenstraat 72",
        "postCode": "2000 BE",
        "city": "Antwerpen",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.studioplay.be/",
        "latitude": 51.2160872,
        "longitude": 4.4016487,
        "customAddr": "Kammenstraat 72, Antwerpen, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzEyMjc3MDY3MDIxOTIxMDI0ODUxOzAwOyc=\"",
        "no": "C10028",
        "name": "De Texelse Schaapjeskraam",
        "eMail": "silvia@diversionista.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Carmenstraat 1",
        "postCode": "1827 RS",
        "city": "Alkmaar",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.6718353,
        "longitude": 4.7730389,
        "customAddr": "Carmenstraat 1, Alkmaar, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk3OTM3NTA4MjAzNzYyODA2MzUxOzAwOyc=\"",
        "no": "C10029",
        "name": "Nordhomestore",
        "eMail": "info@nordhomestore.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Cliffe High St 11",
        "postCode": "BN7 2AH",
        "city": "Lewes",
        "countryRegionCode": "GB",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.874299,
        "longitude": 0.0172266,
        "customAddr": "Cliffe High St 11, Lewes, GB"
      },
      {
        "@odata.etag": "W/\"JzE5OzY3Mjc4NDMwNTc3MjU3ODMwMDUxOzAwOyc=\"",
        "no": "C10030",
        "name": "Textielmuseum",
        "eMail": "bep.haans@textielmuseum.nl",
        "customerGroup": "PHYSICAL",
        "address": "Goirkestraat 96",
        "postCode": "5046 GN",
        "city": "Tilburg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.5708175,
        "longitude": 5.079518,
        "customAddr": "Goirkestraat 96, Tilburg, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzczNTM3NzYzMTg3NDkzNDc1OTMxOzAwOyc=\"",
        "no": "C10031",
        "name": "Knotsknetter",
        "eMail": "info@knotsknetter.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Jan Evertsenstraat 100-h",
        "postCode": "1056EH",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-28",
        "homepage": "https://www.knotsknetter.nl/",
        "latitude": 52.3707256,
        "longitude": 4.853116,
        "customAddr": "Jan Evertsenstraat 100-h, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMzUwNTgzNDA3MDk4NTM5NDY3MTswMDsn\"",
        "no": "C10032",
        "name": "Calzoni",
        "eMail": "info@calzoni.nl",
        "customerGroup": "PHYSICAL",
        "address": "Woldstraat 27",
        "postCode": "7941LE",
        "city": "Meppel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.6980313,
        "longitude": 6.1918906,
        "customAddr": "Woldstraat 27, Meppel, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNzcyOTI5NDk4MzgwNDU4ODk3MTswMDsn\"",
        "no": "C10033",
        "name": "Dragen in Schagen",
        "eMail": "info@drageninschagen.nl",
        "customerGroup": "ONLINE",
        "address": "Lepelaar 37",
        "postCode": "1742 KV",
        "city": "Schagen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://drageninschagen.nl/",
        "latitude": 52.7803741,
        "longitude": 4.7835844,
        "customAddr": "Lepelaar 37, Schagen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNjYzMTcwOTUwMjMwNzM4MTIzMTswMDsn\"",
        "no": "C10034",
        "name": "Esel & Elg",
        "eMail": "info@eselenelg.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Herenstraat 14",
        "postCode": "3911JE",
        "city": "Rhenen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-14",
        "homepage": "https://www.eselenelg.nl/",
        "latitude": 51.9574398,
        "longitude": 5.5670708,
        "customAddr": "Herenstraat 14, Rhenen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMzOTY0OTIyNDcxNzQ0ODI3ODUxOzAwOyc=\"",
        "no": "C10035",
        "name": "Willemse Schoenen",
        "eMail": "info@willemseschoenen.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Euterpeplein 39",
        "postCode": "3816 NP",
        "city": "Amersfoort",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.willemseschoenen.nl/",
        "latitude": 52.15126170000001,
        "longitude": 5.4063323,
        "customAddr": "Euterpeplein 39, Amersfoort, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQyNzg5ODAxMTYzODQzNzg2MzExOzAwOyc=\"",
        "no": "C10036",
        "name": "Gray-Label",
        "eMail": "ida@gray-label.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Bosboom Toussaintstr 35 hs",
        "postCode": "1054 AN",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3654698,
        "longitude": 4.8761569,
        "customAddr": "Bosboom Toussaintstr 35 hs, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzY3NDg2MDI3MTQxNTIyMzIzMjIxOzAwOyc=\"",
        "no": "C10037",
        "name": "Orangeola by Math",
        "eMail": "orangeolabymath@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Avenue Laboulle 48",
        "postCode": "4130",
        "city": "Tilff",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-29",
        "homepage": "",
        "latitude": 50.568265,
        "longitude": 5.5823497,
        "customAddr": "Avenue Laboulle 48, Tilff, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1Nzg5MDQ3MDI0MjYwMDU4Mzk5MTswMDsn\"",
        "no": "C10038",
        "name": "Blur",
        "eMail": "hello@bluryourlife.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Mooierstraat 18",
        "postCode": "3811 EB",
        "city": "Amersfoort",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.1544039,
        "longitude": 5.3893097,
        "customAddr": "Mooierstraat 18, Amersfoort, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU3NzkzOTA5Mzc5MDM3NzM1ODkxOzAwOyc=\"",
        "no": "C10040",
        "name": "Monchou Kids",
        "eMail": "info@monchoukids.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Sint Pieterstraat 2",
        "postCode": "6211 JN",
        "city": "Maastricht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-30",
        "homepage": "https://www.monchoukids.nl/",
        "latitude": 50.846218,
        "longitude": 5.6920309,
        "customAddr": "Sint Pieterstraat 2, Maastricht, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg2NDcyOTI3ODQ3MTY3NTYxNTIxOzAwOyc=\"",
        "no": "C10041",
        "name": "HYGGE BV",
        "eMail": "info@hyggekids.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Mechelsesteenweg 92",
        "postCode": "2018",
        "city": "Antwerpen",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.2078682,
        "longitude": 4.4090325,
        "customAddr": "Mechelsesteenweg 92, Antwerpen, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2MDE5MTc4NzIxODYxNDc1NzcwMTswMDsn\"",
        "no": "C10042",
        "name": "NYNstyles",
        "eMail": "nynstyles@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Vlasstraat 11",
        "postCode": "9101MX",
        "city": "Dokkum",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.3244506,
        "longitude": 5.9981725,
        "customAddr": "Vlasstraat 11, Dokkum, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNDA3NDI0MTc2MTI4MzY4NTU3MTswMDsn\"",
        "no": "C10043",
        "name": "Tutte Belle",
        "eMail": "info@tutte-belle.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kleine Kerkstraat 16",
        "postCode": "8911DM",
        "city": "Leeuwarden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.2021175,
        "longitude": 5.7916515,
        "customAddr": "Kleine Kerkstraat 16, Leeuwarden, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzE2MjI1MTQ1NjkxMDE4NDM2ODYxOzAwOyc=\"",
        "no": "C10044",
        "name": "Elvis & Otis (wienke Trading bv)",
        "eMail": "info@elvisandotis.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Prins Hendrikstraat 124",
        "postCode": "2518HX",
        "city": "Den Haag",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0809331,
        "longitude": 4.291358199999999,
        "customAddr": "Prins Hendrikstraat 124, Den Haag, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzNjMwNDIwMzY1NTE4MTU1NDc0MTswMDsn\"",
        "no": "C10046",
        "name": "Mase ",
        "eMail": "info@maseconceptstore.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Bergstraat 12",
        "postCode": "5611 JZ",
        "city": "Eindhoven",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.maseconceptstore.com/",
        "latitude": 51.4368784,
        "longitude": 5.4760366,
        "customAddr": "Bergstraat 12, Eindhoven, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3OTcyMDMzMDc4MzU2Mzg2MTAzMTswMDsn\"",
        "no": "C10047",
        "name": "Ala Collection",
        "eMail": "laura@a-la.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Nieuwe Gracht 5-a",
        "postCode": "2011 NB",
        "city": "Haarlem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3846303,
        "longitude": 4.637658099999999,
        "customAddr": "Nieuwe Gracht 5-a, Haarlem, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk1Mjc4NDE1MjI0NDU0MjM1MjAxOzAwOyc=\"",
        "no": "C10048",
        "name": "Store of Wolfie",
        "eMail": "info@storeofwolfie.com",
        "customerGroup": "ONLINE",
        "address": "Van der Duinstraat 139",
        "postCode": "5161 BN",
        "city": "Sprang-Capelle",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.6693375,
        "longitude": 5.031045499999999,
        "customAddr": "Van der Duinstraat 139, Sprang-Capelle, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ1MjMwMTIzMzYzNDY1ODExMzUxOzAwOyc=\"",
        "no": "C10049",
        "name": "MiniMarkt",
        "eMail": "josien@minimarkt-store.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Beethovenstraat 5-a",
        "postCode": "1077HK",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.minimarkt-store.com/",
        "latitude": 52.3499917,
        "longitude": 4.8785716,
        "customAddr": "Beethovenstraat 5-a, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzcxMDc3OTc0NzkzODE2NjE0NDkxOzAwOyc=\"",
        "no": "C10050",
        "name": "Prinses en erwtje",
        "eMail": "prinses_erwtje@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Oudegracht 220",
        "postCode": "3511NT",
        "city": "Utrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-05",
        "homepage": "https://www.prinsesenerwtje.nl/",
        "latitude": 52.0883907,
        "longitude": 5.1218749,
        "customAddr": "Oudegracht 220, Utrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMzI4MDcwODg1NzYwNjkyNzk4MTswMDsn\"",
        "no": "C10051",
        "name": "Pluk & Paloma",
        "eMail": "anca@plukandpaloma.com",
        "customerGroup": "PHYSANDDIG",
        "address": "2e Schuytstraat 168",
        "postCode": "2517 TP",
        "city": "Den Haag",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0836882,
        "longitude": 4.2881277,
        "customAddr": "2e Schuytstraat 168, Den Haag, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMDM1NjAyODE3OTEzNTI5MDQ2MTswMDsn\"",
        "no": "C10052",
        "name": "4 baby en kids",
        "eMail": "info@4babyenkids.nl",
        "customerGroup": "ONLINE",
        "address": "Boskraai 70",
        "postCode": "7827JV",
        "city": "Emmen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.7482548,
        "longitude": 6.895098699999999,
        "customAddr": "Boskraai 70, Emmen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NTY0MzI5MjAxNDc5NDAzODY2MTswMDsn\"",
        "no": "C10053",
        "name": "Minipop",
        "eMail": "info@minipop.nl",
        "customerGroup": "ONLINE",
        "address": "Voorstraat 112",
        "postCode": "9291CN",
        "city": "Kollum",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-15",
        "homepage": "https://www.minipop.nl/",
        "latitude": 53.2801741,
        "longitude": 6.1529028,
        "customAddr": "Voorstraat 112, Kollum, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg3ODY3MDI0MDA3NDk2NjU1OTAxOzAwOyc=\"",
        "no": "C10054",
        "name": "Kind Collectables",
        "eMail": "hello@kindcollectables.nl",
        "customerGroup": "ONLINE",
        "address": "Staringplein 5-h",
        "postCode": "1054VJ",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3611571,
        "longitude": 4.8631251,
        "customAddr": "Staringplein 5-h, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU0MjkwMTUzMzg3MDEwNzc1MDQxOzAwOyc=\"",
        "no": "C10055",
        "name": "WWW.SMASPOR.NO",
        "eMail": "hei@smaspor.no",
        "customerGroup": "PHYSANDDIG",
        "address": "Breigata 10",
        "postCode": "4006",
        "city": "Stavanger",
        "countryRegionCode": "NO",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 58.9723452,
        "longitude": 5.7332785,
        "customAddr": "Breigata 10, Stavanger, NO"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1MTA5Mzc1NDk3NDI5OTEyNTY1MTswMDsn\"",
        "no": "C10056",
        "name": "Spruit kids conceptstore",
        "eMail": "info@spruitkidsconceptstore.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Stationsstraat 5",
        "postCode": "5751HA",
        "city": "Deurne",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.4632326,
        "longitude": 5.7937344,
        "customAddr": "Stationsstraat 5, Deurne, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNzc5NjM3ODA2NDM5NTM1ODg1MTswMDsn\"",
        "no": "C10057",
        "name": "Deem Design",
        "eMail": "info@deemdesign.nl",
        "customerGroup": "ONLINE",
        "address": "Waalstraat 22-h",
        "postCode": "1078BT",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.347311,
        "longitude": 4.8998779,
        "customAddr": "Waalstraat 22-h, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1NTM0MDY5NjU2MzcyMzkyMjQwMTswMDsn\"",
        "no": "C10058",
        "name": "Little Things",
        "eMail": "info@littlethingsonline.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kerkstraat 41",
        "postCode": "6811 DM",
        "city": "Arnhem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-17",
        "homepage": "https://www.littlethingsonline.nl/",
        "latitude": 51.9806876,
        "longitude": 5.9092464,
        "customAddr": "Kerkstraat 41, Arnhem, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc1Mjg5NjkyMTE3NDAwODUwMDcxOzAwOyc=\"",
        "no": "C10059",
        "name": "Zoofs conceptstore",
        "eMail": "info@zoofs.nl",
        "customerGroup": "PHYSICAL",
        "address": "Stationsstraat 33",
        "postCode": "5281 GA",
        "city": "Boxtel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.5880455,
        "longitude": 5.3227569,
        "customAddr": "Stationsstraat 33, Boxtel, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMyODA1NzQ3ODg0MjM5OTk4MzYxOzAwOyc=\"",
        "no": "C10060",
        "name": "Kids department",
        "eMail": "brenda@kidsdepartment.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Herenstraat 71-a",
        "postCode": "2291BC",
        "city": "Wateringen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.kidsdepartment.nl/",
        "latitude": 52.02422319999999,
        "longitude": 4.279483,
        "customAddr": "Herenstraat 71-a, Wateringen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyODM5NTg0OTUxMDQyMzEyNzg0MTswMDsn\"",
        "no": "C10061",
        "name": "Milck",
        "eMail": "info@milck.nl",
        "customerGroup": "ONLINE",
        "address": "Stationsweg 78",
        "postCode": "1851LM",
        "city": "HEILOO",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-04-12",
        "homepage": "https://www.milck.nl/nl/",
        "latitude": 52.6000696,
        "longitude": 4.702744099999999,
        "customAddr": "Stationsweg 78, HEILOO, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzE4NzAxNTM2MzUwNDA5OTUyOTE7MDA7Jw==\"",
        "no": "C10062",
        "name": "Pommeloe",
        "eMail": "info@pommeloe.nl",
        "customerGroup": "ONLINE",
        "address": "Marie Curiestraat 5",
        "postCode": "5223AR",
        "city": "s-Hertogenbosch",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.pommeloe.nl/",
        "latitude": 51.6956615,
        "longitude": 5.2912211,
        "customAddr": "Marie Curiestraat 5, s-Hertogenbosch, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc2MzgxOTczNjQyMzY3Mzk5NzAxOzAwOyc=\"",
        "no": "C10064",
        "name": "Kersvers",
        "eMail": "info@kersversalphen.nl",
        "customerGroup": "PHYSICAL",
        "address": "Raadhuisstraat 412",
        "postCode": "2406LE",
        "city": "Alphen aan den Rijn",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://kersversalphen.nl/",
        "latitude": 52.1283792,
        "longitude": 4.6634885,
        "customAddr": "Raadhuisstraat 412, Alphen aan den Rijn, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzNjM1NDQwMjcwMDYwNjUxNTY5MTswMDsn\"",
        "no": "C10065",
        "name": "Sistersbylaw",
        "eMail": "info@sistersbylaw.nl",
        "customerGroup": "PHYSICAL",
        "address": "Heuvelstraat 86",
        "postCode": "9673BD",
        "city": "Winschoten",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.1363992,
        "longitude": 7.0257504,
        "customAddr": "Heuvelstraat 86, Winschoten, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNjg4OTcxNzY5ODU4MTIwOTMwMTswMDsn\"",
        "no": "C10066",
        "name": "Leven zonder afval",
        "eMail": "levenzonderafval@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Tolweg 3",
        "postCode": "3741LM",
        "city": "Baarn",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.2156202,
        "longitude": 5.3008112,
        "customAddr": "Tolweg 3, Baarn, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzYxODAzMDU5NTcxNjQxMzExODAxOzAwOyc=\"",
        "no": "C10067",
        "name": "ZENZ",
        "eMail": "info@ditiszenz.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Keiweg 9a",
        "postCode": "4901 JD",
        "city": "Oosterhout",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.64337270000001,
        "longitude": 4.860280599999999,
        "customAddr": "Keiweg 9a, Oosterhout, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyODY0MzAyODMxMzI4MDExNzEzMTswMDsn\"",
        "no": "C10068",
        "name": "Little Department Store",
        "eMail": "brigitte@littledepartmentstore.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kleiweg 97a",
        "postCode": "3051GK",
        "city": "Rotterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.littledepartmentstore.nl/",
        "latitude": 51.9454583,
        "longitude": 4.479297799999999,
        "customAddr": "Kleiweg 97a, Rotterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2MDY4MTQ5ODUwOTQ1OTMwNzE5MTswMDsn\"",
        "no": "C10070",
        "name": "Bvba Bonnie P // The Wonder Years",
        "eMail": "hello@thewonderyears.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Serpentstraat 6",
        "postCode": "9000",
        "city": "Gent",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.thewonderyears.be/",
        "latitude": 51.0559471,
        "longitude": 3.7256487,
        "customAddr": "Serpentstraat 6, Gent, BE"
      },
      {
        "@odata.etag": "W/\"JzE4OzMzODc2NDA4NDU2MjA3NDEyMzE7MDA7Jw==\"",
        "no": "C10071",
        "name": "De Familiefabriek v.o.f.",
        "eMail": "familiefabriek@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Tulpstraat 19",
        "postCode": "4101 GJ",
        "city": "Culemborg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9563327,
        "longitude": 5.2303364,
        "customAddr": "Tulpstraat 19, Culemborg, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg3NjUwNjYwNTcyNTA3MTQ5ODIxOzAwOyc=\"",
        "no": "C10073",
        "name": "Pipamae bv",
        "eMail": "info@pipamae.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Lange Lozanastraat 81",
        "postCode": "2018",
        "city": "Antwerpen",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://pipamae.com/nl/",
        "latitude": 51.2042776,
        "longitude": 4.4048372,
        "customAddr": "Lange Lozanastraat 81, Antwerpen, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NDAxNjA3MzQ1NjEwNzIwOTYzMTswMDsn\"",
        "no": "C10074",
        "name": "Hedgehog & Deer",
        "eMail": "info@hedgehoganddeer.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Deventerstraat 1B",
        "postCode": "7311BH",
        "city": "Apeldoorn",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-14",
        "homepage": "https://www.hedgehoganddeer.nl/",
        "latitude": 52.215494,
        "longitude": 5.961615999999999,
        "customAddr": "Deventerstraat 1B, Apeldoorn, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ1MTE4ODA4NzIzNzcyODIxNjExOzAwOyc=\"",
        "no": "C10075",
        "name": "Bobby en Beer",
        "eMail": "info@bobbyenbeer.nl",
        "customerGroup": "ONLINE",
        "address": "Van Nijenrodestraat 49",
        "postCode": "2597RK",
        "city": "Den Haag",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://bobbyenbeer.nl/",
        "latitude": 52.0982308,
        "longitude": 4.3135387,
        "customAddr": "Van Nijenrodestraat 49, Den Haag, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMyODE2OTY3NTU0NjQ4Njc5MzkxOzAwOyc=\"",
        "no": "C10076",
        "name": "t Gadehuis / Kathootje",
        "eMail": "k.j.s.gademan@live.nl",
        "customerGroup": "PHYSICAL",
        "address": "Kampweg 11-a",
        "postCode": "3941HC",
        "city": "Doorn",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.gadehuis.nl/",
        "latitude": 52.035534,
        "longitude": 5.3443861,
        "customAddr": "Kampweg 11-a, Doorn, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgxMzE1NTY2MzQyNDIwMTg3MzkxOzAwOyc=\"",
        "no": "C10078",
        "name": "HLvo nv",
        "eMail": "karolien@hetlandvanooit.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Koningin Astridlaan 82 C",
        "postCode": "2550",
        "city": "Kontich",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://hetlandvanooit.be/",
        "latitude": 51.1365865,
        "longitude": 4.4583495,
        "customAddr": "Koningin Astridlaan 82 C, Kontich, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1NTE4MDkxNDc3MjEwMzQ3NDkxMTswMDsn\"",
        "no": "C10079",
        "name": "Confetti",
        "eMail": "confettimaastricht@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Boschstraat 68",
        "postCode": "6211 AX",
        "city": "Maastricht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.853541,
        "longitude": 5.689745,
        "customAddr": "Boschstraat 68, Maastricht, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgwOTg3NTg1NDUzMDY1MDIwNjgxOzAwOyc=\"",
        "no": "C10081",
        "name": "Pearls & Swines",
        "eMail": "info@pearlsandswines.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Pireaushaven 55",
        "postCode": "1448 KG",
        "city": "Purmerend",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://pearlsandswines.com/",
        "latitude": 52.5070922,
        "longitude": 4.939820999999999,
        "customAddr": "Pireaushaven 55, Purmerend, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzI4OTc5NTgxOTY2NTg5MzQ0OTYxOzAwOyc=\"",
        "no": "C10082",
        "name": "yellow flamingo",
        "eMail": "yellow-flamingo@hotmail.com",
        "customerGroup": "ONLINE",
        "address": "525 route des bois d'alix lachassagne",
        "postCode": "69480",
        "city": "rhone",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.9255635,
        "longitude": 4.6792339,
        "customAddr": "525 route des bois d'alix lachassagne, rhone, FR"
      },
      {
        "@odata.etag": "W/\"JzE5OzI5MDc5ODEzNDgwMTExMTQ3ODExOzAwOyc=\"",
        "no": "C10083",
        "name": "Charlys",
        "eMail": "claire@charlys.nl",
        "customerGroup": "ONLINE",
        "address": "Maasstraat 72a2",
        "postCode": "1078HL",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-29",
        "homepage": "https://www.charlys.nl/",
        "latitude": 52.3449555,
        "longitude": 4.8947097,
        "customAddr": "Maasstraat 72a2, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1MDQwNTU1MTI2NDE5MDExNjQxMTswMDsn\"",
        "no": "C10084",
        "name": "Watoto BV",
        "eMail": "info@watoto.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Leopoldstraat 55",
        "postCode": "2330",
        "city": "MERKSPLAS",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.watoto.be/",
        "latitude": 51.3548528,
        "longitude": 4.8649483,
        "customAddr": "Leopoldstraat 55, MERKSPLAS, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzUxMjk3NjY4NTAzMjA0NDU5ODIxOzAwOyc=\"",
        "no": "C10085",
        "name": "W&M Concepts",
        "eMail": "info@9up9down.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Weverstraat 11",
        "postCode": "6811EL",
        "city": "Arnhem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-14",
        "homepage": "https://www.9up9down.nl/",
        "latitude": 51.9806268,
        "longitude": 5.906832899999999,
        "customAddr": "Weverstraat 11, Arnhem, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1NjgyMTY1MTU5NTIxOTk5NDkwMTswMDsn\"",
        "no": "C10087",
        "name": "Olive & Mint",
        "eMail": "info@oliveandmint.eu",
        "customerGroup": "ONLINE",
        "address": "Kempenlandstraat 43-a",
        "postCode": "5262GK",
        "city": "Vught",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.6393255,
        "longitude": 5.2935778,
        "customAddr": "Kempenlandstraat 43-a, Vught, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk4MzQwOTYwNTU5MTk3Mzg3MTExOzAwOyc=\"",
        "no": "C10088",
        "name": "Edzy for the littles",
        "eMail": "info@edzyforthelittles.com",
        "customerGroup": "ONLINE",
        "address": "Germenzeel 318",
        "postCode": "5403XC",
        "city": "Uden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.6648149,
        "longitude": 5.637334099999999,
        "customAddr": "Germenzeel 318, Uden, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNjEyOTE0NDMwNzYwMzg3NTY5MTswMDsn\"",
        "no": "C10089",
        "name": "My little Sunshine",
        "eMail": "info@mylittlesunshine.nl",
        "customerGroup": "PHYSICAL",
        "address": "Jonneveen 36",
        "postCode": "3755XC",
        "city": "Utrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.2565338,
        "longitude": 5.2538594,
        "customAddr": "Jonneveen 36, Utrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MDMzNTcwMzI0MDE5NjA1NDQxMTswMDsn\"",
        "no": "C10090",
        "name": "Donsaapje",
        "eMail": "info@donsaapje.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Halstraat 28",
        "postCode": "4811HX",
        "city": "Breda",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.donsaapje.nl/",
        "latitude": 51.5867625,
        "longitude": 4.7772777,
        "customAddr": "Halstraat 28, Breda, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzE1NTg2MDc0MDEwNzU5NTY5NDUxOzAwOyc=\"",
        "no": "C10091",
        "name": "We Go Eco ",
        "eMail": "info@wegoeco.nl",
        "customerGroup": "ONLINE",
        "address": "Karel Doormanlaan 34",
        "postCode": "2665 AT",
        "city": "Bleiswijk",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0138839,
        "longitude": 4.5295918,
        "customAddr": "Karel Doormanlaan 34, Bleiswijk, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMzNDU5OTA3Mjk4NDk5Nzg2NTUxOzAwOyc=\"",
        "no": "C10092",
        "name": "Natural Mom",
        "eMail": "info@naturalmom.nl",
        "customerGroup": "ONLINE",
        "address": "Karturf 11",
        "postCode": "9202MC",
        "city": "Drachten",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.naturalmom.nl/",
        "latitude": 53.1005259,
        "longitude": 6.1149822,
        "customAddr": "Karturf 11, Drachten, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3NjA1MzE1MDI2NzM3ODUxODg3MTswMDsn\"",
        "no": "C10093",
        "name": "Kids & So",
        "eMail": "info@kidsandso.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Voorstraat 33",
        "postCode": "3201 BA",
        "city": "Spijkenisse",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8504759,
        "longitude": 4.3269307,
        "customAddr": "Voorstraat 33, Spijkenisse, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQyNDAzOTkxODY2ODU1Mzg1MTcxOzAwOyc=\"",
        "no": "C10094",
        "name": "Ontwerperie",
        "eMail": "info@liefenleukkraamkado.nl",
        "customerGroup": "ONLINE",
        "address": "Putterweg 220",
        "postCode": "3851VG",
        "city": "Ermelo",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.27841859999999,
        "longitude": 5.620423499999999,
        "customAddr": "Putterweg 220, Ermelo, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MTcyMzY2MjA1NzYwOTkyODIxMTswMDsn\"",
        "no": "C10095",
        "name": "Heezen Mode",
        "eMail": "heezenmode@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Spoorstraat 16-18",
        "postCode": "7051 CJ",
        "city": "Varsseveld",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9426518,
        "longitude": 6.461428,
        "customAddr": "Spoorstraat 16-18, Varsseveld, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4NDE1NDM1MzA3MjM3Mjg3MjM3MTswMDsn\"",
        "no": "C10096",
        "name": "BabyRoomBoom",
        "eMail": "babyroomboombv@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Saxenburgerdwarsstraat 13-2",
        "postCode": "1054 KS",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://babyroomboom.nl/",
        "latitude": 52.3588575,
        "longitude": 4.861803999999999,
        "customAddr": "Saxenburgerdwarsstraat 13-2, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgxMTQ1MzU4ODUzMTMzNTc0MDUxOzAwOyc=\"",
        "no": "C10097",
        "name": "Boefboef.com",
        "eMail": "info@boefboef.com",
        "customerGroup": "ONLINE",
        "address": "Ny Carlsberg Vej 17",
        "postCode": "1760",
        "city": "Copenhagen V",
        "countryRegionCode": "DK",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-24",
        "homepage": "",
        "latitude": 55.6656572,
        "longitude": 12.54502,
        "customAddr": "Ny Carlsberg Vej 17, Copenhagen V, DK"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4Mzg4Mzk1MDg0NzkwODE0NzYxMTswMDsn\"",
        "no": "C10098",
        "name": "Minilabel",
        "eMail": "hello@minilabel.be",
        "customerGroup": "ONLINE",
        "address": "Krimperslaan 4-e",
        "postCode": "9140",
        "city": "Temse",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.1197035,
        "longitude": 4.201225099999999,
        "customAddr": "Krimperslaan 4-e, Temse, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzUwNjYwNzUyNzYxOTYwNjEwNTUxOzAwOyc=\"",
        "no": "C10099",
        "name": "Moms ",
        "eMail": "info@momsbymar.nl",
        "customerGroup": "PHYSICAL",
        "address": "Kerrieweg 25",
        "postCode": "3541RM",
        "city": "Utrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0919164,
        "longitude": 5.0677412,
        "customAddr": "Kerrieweg 25, Utrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzI1ODM1MzIyMjkwMzY0MzM5NjIxOzAwOyc=\"",
        "no": "C10100",
        "name": "Liefste Fashion",
        "eMail": "info@liefste-fashion.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Snellestraat 16",
        "postCode": "5211EN",
        "city": "s-Hertogenbosch",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.liefste-fashion.nl/",
        "latitude": 51.68815799999999,
        "longitude": 5.3015023,
        "customAddr": "Snellestraat 16, s-Hertogenbosch, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0OTczMjc1MzAzMjUwMTY5NTc3MTswMDsn\"",
        "no": "C10101",
        "name": "Hurkmans Design",
        "eMail": "hurkmansnina@gmail.com",
        "customerGroup": "ONLINE",
        "address": "industrieweg 16",
        "postCode": "5066 XJ",
        "city": "Moergestel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.5509666,
        "longitude": 5.1764849,
        "customAddr": "industrieweg 16, Moergestel, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg2NTgzNzI0OTE2NDQyMDc1NTgxOzAwOyc=\"",
        "no": "C10102",
        "name": "Leerlantijntjes",
        "eMail": "gonnie_vaas@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Jan Bogtstrastraat 15",
        "postCode": "8801VH",
        "city": "Franeker",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.leerlantijntjes.nl/",
        "latitude": 53.1834769,
        "longitude": 5.5345513,
        "customAddr": "Jan Bogtstrastraat 15, Franeker, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMwMTY0MjAzNTAxMjIyMzU3ODYxOzAwOyc=\"",
        "no": "C10103",
        "name": "van Buren Bolsward",
        "eMail": "info@gritta.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kleine Palen 4",
        "postCode": "8601AB",
        "city": "Sneek",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.0294622,
        "longitude": 5.661576999999999,
        "customAddr": "Kleine Palen 4, Sneek, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwOTQxOTM5MDkzNDcyOTY0NDQxMTswMDsn\"",
        "no": "C10104",
        "name": "Pudilo",
        "eMail": "info@pudilo.nl",
        "customerGroup": "ONLINE",
        "address": "Kerkstraat 38",
        "postCode": "5154AP",
        "city": "Elshout",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-06",
        "homepage": "https://pudilo.nl/",
        "latitude": 51.7014206,
        "longitude": 5.136753,
        "customAddr": "Kerkstraat 38, Elshout, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzkxMTg2MzE2MDgzODE2NTM1MTAxOzAwOyc=\"",
        "no": "C10105",
        "name": "Anna van Elteren verloskundige",
        "eMail": "moniquevanelteren@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Willem Alexanderstraat 12",
        "postCode": "4751BB",
        "city": "OUD GASTEL",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.5956224,
        "longitude": 4.4582983,
        "customAddr": "Willem Alexanderstraat 12, OUD GASTEL, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExOTUxNzE4NjY2MjYyMzQ4NDU2MTswMDsn\"",
        "no": "C10106",
        "name": "Leff! Kinderkleding ",
        "eMail": "info@leff-kinderkleding.nl",
        "customerGroup": "PHYSICAL",
        "address": "Hof 88-a",
        "postCode": "5571 CC",
        "city": "Bergeijk",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.3223947,
        "longitude": 5.358471499999999,
        "customAddr": "Hof 88-a, Bergeijk, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg0OTc1NjYxNzc1MjExMTIyNDYxOzAwOyc=\"",
        "no": "C10108",
        "name": "Welovedeco",
        "eMail": "procurement@welovedeco.nl",
        "customerGroup": "ONLINE",
        "address": "Pieter Zeemanweg 131",
        "postCode": "3316 GZ",
        "city": "Dordrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-30",
        "homepage": "",
        "latitude": 51.7744265,
        "longitude": 4.6372106,
        "customAddr": "Pieter Zeemanweg 131, Dordrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExODUyMjcyMjMzNTg5Njc1MTM2MTswMDsn\"",
        "no": "C10109",
        "name": "QLS Fulfilment/ Kinder Wonderland",
        "eMail": "info@kinderwonderland.nl",
        "customerGroup": "ONLINE",
        "address": "Taxandrialaan 57B",
        "postCode": "6021 XW",
        "city": "Budel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-07-29",
        "homepage": "https://kinderwonderland.nl/",
        "latitude": 51.26634139999999,
        "longitude": 5.570843399999999,
        "customAddr": "Taxandrialaan 57B, Budel, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3Njg5MDgzMzgyNDYwNzk1NzE5MTswMDsn\"",
        "no": "C10110",
        "name": "Wow Kidsconceptstore",
        "eMail": "anouk@wowkids.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Zuivelplein 3-a",
        "postCode": "4611NX",
        "city": "Bergen op Zoom ",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.4949167,
        "longitude": 4.2897272,
        "customAddr": "Zuivelplein 3-a, Bergen op Zoom , NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0ODk2MzI5MjYwNjIyMzMwOTYyMTswMDsn\"",
        "no": "C10111",
        "name": "Little folks",
        "eMail": "info@littlefolks.nl",
        "customerGroup": "PHYSICAL",
        "address": "Billie Holidaystraat 7",
        "postCode": "3543EJ",
        "city": "Utrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.101858,
        "longitude": 5.0441819,
        "customAddr": "Billie Holidaystraat 7, Utrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ4NzE3MzUxMTMyMzIzMjg4NDAxOzAwOyc=\"",
        "no": "C10112",
        "name": "Van den Berge Basic Lifestyle",
        "eMail": "info@basic-lifestyle.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Bebouwdendam 5",
        "postCode": "4691 EH",
        "city": "Tholen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://basic-lifestyle.nl/",
        "latitude": 51.53315019999999,
        "longitude": 4.2227963,
        "customAddr": "Bebouwdendam 5, Tholen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzYyNTEyOTU1NTA4MDI3ODA3MDgxOzAwOyc=\"",
        "no": "C10114",
        "name": "Cenza VOF",
        "eMail": "joyce@cenza-mode.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Voorstraat 19",
        "postCode": "3441 CC",
        "city": "Woerden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0873064,
        "longitude": 4.8846246,
        "customAddr": "Voorstraat 19, Woerden, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyOTcwMzUyNTk5NjYyMTgwMTgzMTswMDsn\"",
        "no": "C10116",
        "name": "Senang",
        "eMail": "marti_vanduijn@hotmail.nl",
        "customerGroup": "ONLINE",
        "address": "Zeereepstraat 7",
        "postCode": "2225MG",
        "city": "Katwijk aan zee ",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.1992805,
        "longitude": 4.3901467,
        "customAddr": "Zeereepstraat 7, Katwijk aan zee , NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMDc2NjUyMjYxMTI4NzQyNjAzMTswMDsn\"",
        "no": "C10117",
        "name": "Roomrosie ",
        "eMail": "info@roomrosie.be",
        "customerGroup": "ONLINE",
        "address": "Heinzestraat 13",
        "postCode": "1071 SK",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.35255799999999,
        "longitude": 4.876571999999999,
        "customAddr": "Heinzestraat 13, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg4OTU3ODAyMzQ3NzAwODgyNDkxOzAwOyc=\"",
        "no": "C10118",
        "name": "Bij Suuz",
        "eMail": "bijsuuz@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Burgemeester Reedekerstraat 7",
        "postCode": "8881BZ",
        "city": "West Terschelling ",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-01",
        "homepage": "",
        "latitude": 53.3604344,
        "longitude": 5.2164012,
        "customAddr": "Burgemeester Reedekerstraat 7, West Terschelling , NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk5NTgxNjQzNTUzNzE3NjczODQxOzAwOyc=\"",
        "no": "C10119",
        "name": "Frouwkje Lifestylewinkel",
        "eMail": "frouwkjelifestyle@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Oudestraat 150",
        "postCode": "8260CZ",
        "city": "Kampen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.5592834,
        "longitude": 5.9160058,
        "customAddr": "Oudestraat 150, Kampen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc0MTcxMDIwMDI5OTUyNzgzNjAxOzAwOyc=\"",
        "no": "C10120",
        "name": "My cup of tea",
        "eMail": "info@mcot.nl",
        "customerGroup": "PHYSICAL",
        "address": "Zandbank 1",
        "postCode": "4354NR",
        "city": "Vrouwenpolder",
        "countryRegionCode": "NL",
        "noOfQuotes": 2,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-21",
        "homepage": "https://mcot.nl/mcot/",
        "latitude": 51.5833582,
        "longitude": 3.6197532,
        "customAddr": "Zandbank 1, Vrouwenpolder, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2ODM4NzUwMjY1MzU5NjQ0MTEzMTswMDsn\"",
        "no": "C10122",
        "name": "Brasserie de cuyper ",
        "eMail": "brigitte_faber@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Dracht 8",
        "postCode": "8442BP",
        "city": "Heerenveen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.9599251,
        "longitude": 5.9227941,
        "customAddr": "Dracht 8, Heerenveen, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzYyNDk3MTU2MDUyMzkwNTAxMzE7MDA7Jw==\"",
        "no": "C10124",
        "name": "Fidelite",
        "eMail": "fidelitebruidsmode@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Wethouder Jan Feterisstraat 12",
        "postCode": "5321RZ",
        "city": "Hedel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.74600770000001,
        "longitude": 5.2600561,
        "customAddr": "Wethouder Jan Feterisstraat 12, Hedel, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNzc2MTAzOTY4MDE2NDM1NTcyMTswMDsn\"",
        "no": "C10125",
        "name": "Geluk22",
        "eMail": "info@geluk22.nl",
        "customerGroup": "ONLINE",
        "address": "Vogelzand 2206",
        "postCode": "1788GA",
        "city": "Julianadorp",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.geluk22.nl/",
        "latitude": 52.8977517,
        "longitude": 4.7410131,
        "customAddr": "Vogelzand 2206, Julianadorp, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNTE5NTY4NDA3NTI2MzAyNjk1MTswMDsn\"",
        "no": "C10126",
        "name": "Nouri kids",
        "eMail": "info@nourikids.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Vaalbeekstraat 37",
        "postCode": "3050",
        "city": "Oud-Heverlee",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.83538369999999,
        "longitude": 4.6674913,
        "customAddr": "Vaalbeekstraat 37, Oud-Heverlee, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNDY4NzQ4OTI0ODA4MzE3NTQ4MTswMDsn\"",
        "no": "C10127",
        "name": "KDkes",
        "eMail": "collecties@kdkes.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Tolpoortstraat 64",
        "postCode": "9800",
        "city": "Deinze",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.98070860000001,
        "longitude": 3.5298971,
        "customAddr": "Tolpoortstraat 64, Deinze, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3ODAzMjIwODc4ODg3ODgxOTgwMTswMDsn\"",
        "no": "C10128",
        "name": "HOERA! Kinderschoenen",
        "eMail": "info@hoerakinderschoenen.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kromstraat 12a",
        "postCode": "5504 BC",
        "city": "Veldhoven",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.4038259,
        "longitude": 5.3954275,
        "customAddr": "Kromstraat 12a, Veldhoven, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU3NzgxMTY1MTY5NDA4NDQ1MjMxOzAwOyc=\"",
        "no": "C10129",
        "name": "Maarten.FIT",
        "eMail": "stephanie.marinus@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "korte Nieuwstraat 23",
        "postCode": "2960",
        "city": "brecht",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.2964855,
        "longitude": 4.5721067,
        "customAddr": "korte Nieuwstraat 23, brecht, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMDExOTE5MjcyMDQ0MTE5OTU0MTswMDsn\"",
        "no": "C10130",
        "name": "MAHOE",
        "eMail": "anouk@hoekschemama.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Oostdijk 43",
        "postCode": "3261 KC",
        "city": "Oud Beijerland",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-09",
        "homepage": "https://mahoe.nl/",
        "latitude": 51.8264788,
        "longitude": 4.4137027,
        "customAddr": "Oostdijk 43, Oud Beijerland, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk5MjMxMDk3NzgzMjc3MTY0NDkxOzAwOyc=\"",
        "no": "C10131",
        "name": "LoSt BV",
        "eMail": "lore@atelierbebe.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Blindestraat 24",
        "postCode": "2800",
        "city": "Mechelen",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.00619289999999,
        "longitude": 4.4871849,
        "customAddr": "Blindestraat 24, Mechelen, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzE5MDkzNTQwODQ2ODk3OTU2NjcxOzAwOyc=\"",
        "no": "C10132",
        "name": "Mama Roos",
        "eMail": "hallo@mamaroos.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Welgelegenstraat 9",
        "postCode": "2548SE",
        "city": "Den Haag",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0259077,
        "longitude": 4.2927481,
        "customAddr": "Welgelegenstraat 9, Den Haag, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzYxMDYxMzU1MDQwNjkwNzQ1NDMxOzAwOyc=\"",
        "no": "C10133",
        "name": "Sil& Juul",
        "eMail": "jessicaruissen@live.nl",
        "customerGroup": "ONLINE",
        "address": "Weelweg 15",
        "postCode": "4414AW",
        "city": "waarde",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.4159041,
        "longitude": 4.0726985,
        "customAddr": "Weelweg 15, waarde, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzM4MzY3MjY1NTMxODIyMDM5ODYxOzAwOyc=\"",
        "no": "C10134",
        "name": "Ai and Mi",
        "eMail": "info@aiandmi.com",
        "customerGroup": "ONLINE",
        "address": "E. van Dintelstraat 24",
        "postCode": "3201 KX",
        "city": "Spijkenisse",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.aiandmi.com/",
        "latitude": 51.84898459999999,
        "longitude": 4.313858199999999,
        "customAddr": "E. van Dintelstraat 24, Spijkenisse, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzY5NDA2MTIzMTgwMDUyOTg5MTAxOzAwOyc=\"",
        "no": "C10135",
        "name": "Beer en Schaap",
        "eMail": "info@beerenschaap.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Mooierstraat 4-6",
        "postCode": "3811 EB",
        "city": "Amersfoort",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-06",
        "homepage": "https://www.beerenschaap.nl/",
        "latitude": 52.1546007,
        "longitude": 5.3898069,
        "customAddr": "Mooierstraat 4-6, Amersfoort, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMDY2NjM2MTc3Nzk1MTIwMTQ4MTswMDsn\"",
        "no": "C10136",
        "name": "Babymeys",
        "eMail": "info@babymeys.nl",
        "customerGroup": "ONLINE",
        "address": "Jellingelant 10",
        "postCode": "1722LJ",
        "city": "Zuid-Scharwoude",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.6830158,
        "longitude": 4.7894616,
        "customAddr": "Jellingelant 10, Zuid-Scharwoude, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzYwMzk1NDk5ODE0MzI1NDA4MjExOzAwOyc=\"",
        "no": "C10137",
        "name": "De Zandvoetjes bvba",
        "eMail": "dezandvoetjes@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Leopold 2 Laan 213 GV06",
        "postCode": "8670",
        "city": "Oostduinkerke",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-07",
        "homepage": "http://dezandvoetjes.be/",
        "latitude": 51.1301593,
        "longitude": 2.6726351,
        "customAddr": "Leopold 2 Laan 213 GV06, Oostduinkerke, BE"
      },
      {
        "@odata.etag": "W/\"JzE4OzYwNzI5MDQyMDA3Nzg1NzMxMzE7MDA7Jw==\"",
        "no": "C10138",
        "name": "mustik.ch",
        "eMail": "welcome@mustik.ch",
        "customerGroup": "ONLINE",
        "address": "Wattenwylweg 21 1 floor",
        "postCode": "3006",
        "city": "Bern",
        "countryRegionCode": "CH",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://mustik.ch/",
        "latitude": 46.9475703,
        "longitude": 7.4639236,
        "customAddr": "Wattenwylweg 21 1 floor, Bern, CH"
      },
      {
        "@odata.etag": "W/\"JzE5OzU5Njg1NjQ2ODI0NjYzMDE5OTQxOzAwOyc=\"",
        "no": "C10139",
        "name": "Minion",
        "eMail": "minionconcept@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "PLACE DES JARDINS DE BASEILLES 9",
        "postCode": "5101",
        "city": "ERPENT",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.4410056,
        "longitude": 4.9048621,
        "customAddr": "PLACE DES JARDINS DE BASEILLES 9, ERPENT, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzcxNTc1Nzg2MjUxMzIyMzE1ODIxOzAwOyc=\"",
        "no": "C10140",
        "name": "Soofiez",
        "eMail": "soofznl@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Kuipers-rietbergkwartier 5",
        "postCode": "4333 EJ",
        "city": "Middelburg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.soofiez.nl/",
        "latitude": 51.50869729999999,
        "longitude": 3.6123555,
        "customAddr": "Kuipers-rietbergkwartier 5, Middelburg, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzQxMzAzMzQ3MjQxNDMyMjg3NTE7MDA7Jw==\"",
        "no": "C10141",
        "name": "Kroost kids concept store ",
        "eMail": "info@kroostconceptstore.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Bergstraat 17",
        "postCode": "6041 ES",
        "city": "Roermond",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-12",
        "homepage": "https://www.kroostconceptstore.nl/",
        "latitude": 51.19468500000001,
        "longitude": 5.9856959,
        "customAddr": "Bergstraat 17, Roermond, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk3MzI1MzU4NTMzMTA0MzY3MjAxOzAwOyc=\"",
        "no": "C10142",
        "name": "Mae-Lou",
        "eMail": "info@mae-lou.nl",
        "customerGroup": "ONLINE",
        "address": "Pottenbakkerstraat 28",
        "postCode": "9403 VX",
        "city": "Assen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://mae-lou.nl/",
        "latitude": 53.00877750000001,
        "longitude": 6.5934553,
        "customAddr": "Pottenbakkerstraat 28, Assen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk0ODM5MTU0NzA3MTI1MTIwNTExOzAwOyc=\"",
        "no": "C10143",
        "name": "Jackie OO",
        "eMail": "lore@jackie-oo.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Dorp 81",
        "postCode": "2820",
        "city": "Bonheiden",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.0230428,
        "longitude": 4.5454641,
        "customAddr": "Dorp 81, Bonheiden, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNzcxMTI3MjU5MDYzNjEzMDcxMTswMDsn\"",
        "no": "C10144",
        "name": "Little Minimalist ",
        "eMail": "tara@littleminimalist.ca",
        "customerGroup": "ONLINE",
        "address": "10 PROMENADE RONALD SUITE E",
        "postCode": "H4X 1M8",
        "city": "MONTREAL-OUEST",
        "countryRegionCode": "CA",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.4502673,
        "longitude": -73.63681729999999,
        "customAddr": "10 PROMENADE RONALD SUITE E, MONTREAL-OUEST, CA"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MDYzNjc2MzI5NTU2MTkwMTEzMTswMDsn\"",
        "no": "C10145",
        "name": "La la land",
        "eMail": "lalaland.kids.store@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Kapelstraat 3",
        "postCode": "3590",
        "city": "Diepenbeek",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.9090803,
        "longitude": 5.4188896,
        "customAddr": "Kapelstraat 3, Diepenbeek, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MDM1NzI1ODYyMzQ5MDA0NDY3MTswMDsn\"",
        "no": "C10146",
        "name": "Biggles",
        "eMail": "sabrine@bigglesamsterdam.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Middenweg 55a",
        "postCode": "1098 AD",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3540978,
        "longitude": 4.9303037,
        "customAddr": "Middenweg 55a, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU3NzM1MDg4Mzk1OTA1MDg0MTYxOzAwOyc=\"",
        "no": "C10147",
        "name": "Kidooz BV",
        "eMail": "hello@kidooz.nl",
        "customerGroup": "ONLINE",
        "address": "Neerloopweg 35",
        "postCode": "4814 RS",
        "city": "Breda",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-24",
        "homepage": "https://www.kidooz.nl/",
        "latitude": 51.5917279,
        "longitude": 4.739479999999999,
        "customAddr": "Neerloopweg 35, Breda, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMzUzMDU1MjM5NjU4NjkzNjkzMTswMDsn\"",
        "no": "C10148",
        "name": "Kev & Mee Kidsstore",
        "eMail": "info@mammiesfashion.nl",
        "customerGroup": "PHYSICAL",
        "address": "Hoofdstraat 100",
        "postCode": "3901 AX",
        "city": "Veenendaal",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.kevenmeekidsstore.nl/",
        "latitude": 52.0285156,
        "longitude": 5.5572113,
        "customAddr": "Hoofdstraat 100, Veenendaal, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMzYzMjE0MjE1MzM5OTk2OTI5MTswMDsn\"",
        "no": "C10149",
        "name": "Top babyShop",
        "eMail": "info@topbabyshop.nl",
        "customerGroup": "ONLINE",
        "address": "A.commandeurlaan 91",
        "postCode": "1715AG",
        "city": "Spanbroek",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.7001106,
        "longitude": 4.9603845,
        "customAddr": "A.commandeurlaan 91, Spanbroek, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NTM3NjA1NDAwMTIyMzQ4NDk1MTswMDsn\"",
        "no": "C10150",
        "name": "SA",
        "eMail": "info@desagnemotions.rocks",
        "customerGroup": "ONLINE",
        "address": "Vliegplein 81",
        "postCode": "2270",
        "city": "Herenthout",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.gangbysa.rocks/",
        "latitude": 51.1385969,
        "longitude": 4.7665612,
        "customAddr": "Vliegplein 81, Herenthout, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MzYxMzM0NjkzMzEzNDA2MDU3MTswMDsn\"",
        "no": "C10151",
        "name": "Skjonn Concept Store",
        "eMail": "post@skjonn.no",
        "customerGroup": "PHYSANDDIG",
        "address": "Hegrenesveien 36",
        "postCode": "5042",
        "city": "Begren",
        "countryRegionCode": "NO",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 60.4166842,
        "longitude": 5.3050603,
        "customAddr": "Hegrenesveien 36, Begren, NO"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ0OTgzODc2OTM1NTQ5MTE0ODkxOzAwOyc=\"",
        "no": "C10152",
        "name": "Mio Meraki",
        "eMail": "info@miomeraki.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Kapelstraat 13",
        "postCode": "1404HT",
        "city": "Bussum",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-12",
        "homepage": "https://www.miomeraki.com/",
        "latitude": 52.2745038,
        "longitude": 5.1647795,
        "customAddr": "Kapelstraat 13, Bussum, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzIyNTE5NTg1ODE2OTY4MDU0ODExOzAwOyc=\"",
        "no": "C10153",
        "name": "Lilla Nanook",
        "eMail": "kontakt@lillananook.se",
        "customerGroup": "ONLINE",
        "address": "Mellomgården 604",
        "postCode": "44195",
        "city": "ALINGSÅS",
        "countryRegionCode": "SE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 57.9419974,
        "longitude": 12.6990672,
        "customAddr": "Mellomgården 604, ALINGSÅS, SE"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc5NDkyNTM0NzEzOTA0MDU1NTIxOzAwOyc=\"",
        "no": "C10154",
        "name": "Salon Stijl",
        "eMail": "info@salonstijl.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Langebuurt 2-a",
        "postCode": "1911AV",
        "city": "Uitgeest",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.528806,
        "longitude": 4.714928,
        "customAddr": "Langebuurt 2-a, Uitgeest, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1MTgzOTIyNDk0MjI2NTU0MzI0MTswMDsn\"",
        "no": "C10155",
        "name": "Hart van Texel",
        "eMail": "anitamuilwijk7@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Gravenstraat 6",
        "postCode": "1791CK",
        "city": "Den burg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.0540809,
        "longitude": 4.796112100000001,
        "customAddr": "Gravenstraat 6, Den burg, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ1MjY0NjEwODc3MTA1NzA5NTgxOzAwOyc=\"",
        "no": "C10156",
        "name": "Little Laurent",
        "eMail": "lizanne@bosmawonen.nl",
        "customerGroup": "ONLINE",
        "address": "Papierbaan 1-b",
        "postCode": "9672 BG",
        "city": "Winschoten",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.1496205,
        "longitude": 7.0497402,
        "customAddr": "Papierbaan 1-b, Winschoten, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MTQ3NTkwNTU5NjEzMDkyNDk0MTswMDsn\"",
        "no": "C10157",
        "name": "Love Neutral Store",
        "eMail": "hello@loveneutralstore.com",
        "customerGroup": "ONLINE",
        "address": "Feithlaan 3",
        "postCode": "1985 GJ",
        "city": "Driehuis",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://loveneutralstore.com/",
        "latitude": 52.4473943,
        "longitude": 4.6351537,
        "customAddr": "Feithlaan 3, Driehuis, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzYyNzI0Mzg3NjM2MTk2NTY3MDcxOzAwOyc=\"",
        "no": "C10158",
        "name": "Poespas",
        "eMail": "info@poespas.nl",
        "customerGroup": "ONLINE",
        "address": "Oldenzaalsestraat 125",
        "postCode": "7514 DP",
        "city": "Enschede",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.2260072,
        "longitude": 6.8993723,
        "customAddr": "Oldenzaalsestraat 125, Enschede, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk5MjEzMzk4MTgwNzUyMjY3ODcxOzAwOyc=\"",
        "no": "C10159",
        "name": "Luna e Stelle",
        "eMail": "info@luna-e-stelle.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Burg. van Hofwegensingel 55",
        "postCode": "3362 NM",
        "city": "Sliedrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://luna-e-stelle.nl/",
        "latitude": 51.8197998,
        "longitude": 4.790344900000001,
        "customAddr": "Burg. van Hofwegensingel 55, Sliedrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzU5MjI1MDIxODYwODkzNTM0MzE7MDA7Jw==\"",
        "no": "C10160",
        "name": "Big & Belg",
        "eMail": "bigenbelg@bigenbelg.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Ferdinand Bolstraat 168",
        "postCode": "1072 LT",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.35176389999999,
        "longitude": 4.8912175,
        "customAddr": "Ferdinand Bolstraat 168, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzIzNzg1MTA4NjI1OTE4MDM1NDExOzAwOyc=\"",
        "no": "C10161",
        "name": "Hønemor Studios AS ",
        "eMail": "tonje@honemor.co",
        "customerGroup": "PHYSANDDIG",
        "address": "Lindemans Gate 4A",
        "postCode": "0267",
        "city": "Oslo",
        "countryRegionCode": "NO",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 59.9218738,
        "longitude": 10.7034464,
        "customAddr": "Lindemans Gate 4A, Oslo, NO"
      },
      {
        "@odata.etag": "W/\"JzE4Ozg5ODYwNjI4NTUwMzQ2ODI0OTE7MDA7Jw==\"",
        "no": "C10163",
        "name": "LITTLE&TALL",
        "eMail": "emilie@littleandtall.fr",
        "customerGroup": "PHYSANDDIG",
        "address": "9 rue Masurel",
        "postCode": "59800",
        "city": "LILLE",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.6391302,
        "longitude": 3.0616085,
        "customAddr": "9 rue Masurel, LILLE, FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMjA1OTc2MDQ1NzE3ODQyODE2MTswMDsn\"",
        "no": "C10165",
        "name": "Kinderzimmer Bonn-Beuel",
        "eMail": "info@kinderzimmer-bonn.de",
        "customerGroup": "PHYSANDDIG",
        "address": "hermannstraße 21",
        "postCode": "53225",
        "city": "Bonn",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-07-29",
        "homepage": "https://www.kinderzimmer-bonn.de/",
        "latitude": 50.7378181,
        "longitude": 7.116880999999999,
        "customAddr": "hermannstraße 21, Bonn, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1MTIxOTIzMTU2MDExMzYwMDY4MTswMDsn\"",
        "no": "C10166",
        "name": "HK Benniu International Supply China Management Ltd",
        "eMail": "shenry@lepetitchou.net",
        "customerGroup": "PHYSANDDIG",
        "address": "UNIT 3 , 14/F BLOCK A2 HANG WAI INT CENTRE NO.6 KIN TAI STREET TUEN MUN, NT",
        "postCode": "970000",
        "city": "Hong-Kong",
        "countryRegionCode": "HK",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 22.3976228,
        "longitude": 113.9712141,
        "customAddr": "UNIT 3 , 14/F BLOCK A2 HANG WAI INT CENTRE NO.6 KIN TAI STREET TUEN MUN, NT, Hong-Kong, HK"
      },
      {
        "@odata.etag": "W/\"JzE5OzMwOTgxOTMzMDg0ODE2ODU1MDAxOzAwOyc=\"",
        "no": "C10167",
        "name": "0",
        "eMail": "ojohnstone@googlemail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Upper sherwoord road",
        "postCode": "BN25 3EA",
        "city": "Seaford",
        "countryRegionCode": "GB",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.7796347,
        "longitude": 0.112109,
        "customAddr": "Upper sherwoord road, Seaford, GB"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NTg1NjIzNjc3ODkzODAwMTAyMTswMDsn\"",
        "no": "C10168",
        "name": "Mandragora",
        "eMail": "mandragora_kleding@telenet.be",
        "customerGroup": "PHYSICAL",
        "address": "Beeldhouwersstraat 46",
        "postCode": "2000",
        "city": "Antwerpen",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.2072788,
        "longitude": 4.3952008,
        "customAddr": "Beeldhouwersstraat 46, Antwerpen, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MTI0NzkwNTA3Njg2MTUzOTE0MTswMDsn\"",
        "no": "C10169",
        "name": "Puck baby & kids",
        "eMail": "cmk277@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Hoofddorpweg 14h",
        "postCode": "1058 PB",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-11",
        "homepage": "https://onderstebovenpuck.nl/",
        "latitude": 52.3512201,
        "longitude": 4.851398,
        "customAddr": "Hoofddorpweg 14h, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMDI3NDA0MDYzMzA3MjM0Njg0MTswMDsn\"",
        "no": "C10170",
        "name": "Hip-Stoer-Lief",
        "eMail": "info@hip-stoer-lief.nl",
        "customerGroup": "ONLINE",
        "address": "Kromsteeg 14",
        "postCode": "5331AK",
        "city": "Kerkdriel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.7735468,
        "longitude": 5.334688,
        "customAddr": "Kromsteeg 14, Kerkdriel, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzM5MDA3MTE0MzIxNTU3Njg1NDYxOzAwOyc=\"",
        "no": "C10171",
        "name": "Kleine heldeN",
        "eMail": "mail@kleinehelden.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Barrevoetestraat 6",
        "postCode": "2011 WP",
        "city": "Haarlem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3799578,
        "longitude": 4.6300134,
        "customAddr": "Barrevoetestraat 6, Haarlem, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzE1OTA5OTU2MDExOTkyODU0NjYxOzAwOyc=\"",
        "no": "C10172",
        "name": "Murray & Finn",
        "eMail": "murrayandfinn@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Maple Street 46",
        "postCode": "7901",
        "city": "Summit",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 38.7945952,
        "longitude": -106.5348379,
        "customAddr": "Maple Street 46, Summit, US"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1NzM4NDI1MDYxNTU3ODA3NTczMTswMDsn\"",
        "no": "C10173",
        "name": "Wylder shop",
        "eMail": "hello@wyldershop.com",
        "customerGroup": "ONLINE",
        "address": "1938 Seascape Blvd.",
        "postCode": "95003",
        "city": "Aptos",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 36.951338,
        "longitude": -121.868837,
        "customAddr": "1938 Seascape Blvd., Aptos, US"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MDA1MjQ2NTU2NTA3OTU1MjM4MTswMDsn\"",
        "no": "C10174",
        "name": "WEPURELOVE INTERNATIONAL CO., LTD.",
        "eMail": "little.wonders.tw@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "1F., No. 453, Beishi E. Rd., Shalu Dist.,",
        "postCode": "433110",
        "city": "Taichung",
        "countryRegionCode": "TW",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 24.223168,
        "longitude": 120.577312,
        "customAddr": "1F., No. 453, Beishi E. Rd., Shalu Dist.,, Taichung, TW"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNTAyNTcwMTcyODA1MTIxMzE5MTswMDsn\"",
        "no": "C10177",
        "name": "The Watermelon Kids",
        "eMail": "aci.xi@163.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Wanjiali Chashan Street, Quhai District Wenzhou",
        "postCode": "363005",
        "city": "Hujian",
        "countryRegionCode": "CN",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 27.912128,
        "longitude": 120.701325,
        "customAddr": "Wanjiali Chashan Street, Quhai District Wenzhou, Hujian, CN"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMzY2NjY0Mjk2NzA3MTg4NjU4MTswMDsn\"",
        "no": "C10178",
        "name": "Juna Concept ",
        "eMail": "sarah@junaconcept.com",
        "customerGroup": "ONLINE",
        "address": "Weidenweg 12",
        "postCode": "74321",
        "city": "Bietigheim-Bissingen",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 48.9501389,
        "longitude": 9.142584900000001,
        "customAddr": "Weidenweg 12, Bietigheim-Bissingen, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzM3OTcxMjkyMTg5MjYwNDY4NzcxOzAwOyc=\"",
        "no": "C10179",
        "name": "INSTANT LOUVE",
        "eMail": "zina@instantlouve.com",
        "customerGroup": "ONLINE",
        "address": "Domaine d'Arny, rue de la Ferme d'Arny",
        "postCode": "91680",
        "city": "Bruyères-Le-Châtel",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://instantlouve.com/",
        "latitude": 48.5839934,
        "longitude": 2.1925667,
        "customAddr": "Domaine d'Arny, rue de la Ferme d'Arny, Bruyères-Le-Châtel, FR"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk2ODYzNDUwNjg2MDA5NjMwMjkxOzAwOyc=\"",
        "no": "C10180",
        "name": "CARA No.9",
        "eMail": "vividelove@gmail.com",
        "customerGroup": "ONLINE",
        "address": "3F, No.9,Ln.2, Shuiyuan Street",
        "postCode": "234020",
        "city": "New Taipei City, TW (R.O.C)",
        "countryRegionCode": "TW",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.cara-no9.com/",
        "latitude": 25.005584,
        "longitude": 121.512104,
        "customAddr": "3F, No.9,Ln.2, Shuiyuan Street, New Taipei City, TW (R.O.C), TW"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMDkwODA0Mzk5Mzg5Mjc1MDU4MTswMDsn\"",
        "no": "C10181",
        "name": "Newborn musthaves",
        "eMail": "info@newbornmusthaves.nl",
        "customerGroup": "ONLINE",
        "address": "Berkenlaan 39",
        "postCode": "3771XV",
        "city": "Barneveld",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-07-26",
        "homepage": "",
        "latitude": 52.1509467,
        "longitude": 5.590398299999999,
        "customAddr": "Berkenlaan 39, Barneveld, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzM1NjcyMzE0NDYyNTA2MjQyNDE7MDA7Jw==\"",
        "no": "C10182",
        "name": "Charlie Ray",
        "eMail": "charlotte_lemaire@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Witloofstraat 19",
        "postCode": "1910",
        "city": "Nederokkerzeel",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.92211289999999,
        "longitude": 4.5648515,
        "customAddr": "Witloofstraat 19, Nederokkerzeel, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1MjYyODY4NzE5MTU2MzYwODQ4MTswMDsn\"",
        "no": "C10183",
        "name": "Blitskikker",
        "eMail": "info@blitskikkeramsterdam.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Javastraat 117HS",
        "postCode": "1098 HV",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://blitskikkeramsterdam.nl/",
        "latitude": 52.3637609,
        "longitude": 4.9375009,
        "customAddr": "Javastraat 117HS, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzE1MTY4ODgzOTA5MzU2NjY0NzE7MDA7Jw==\"",
        "no": "C10184",
        "name": "Klein Konijn",
        "eMail": "info@klein-konijn.nl",
        "customerGroup": "ONLINE",
        "address": "Havenstraat",
        "postCode": "7887 BP",
        "city": "Erica",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.7155111,
        "longitude": 6.9267578,
        "customAddr": "Havenstraat, Erica, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMzczMzQ2NTc4NjQxODM4MDEzMTswMDsn\"",
        "no": "C10185",
        "name": "Mommies & Miracles",
        "eMail": "info@mommiesandmiracles.nl",
        "customerGroup": "ONLINE",
        "address": "Roerdomplaan 21",
        "postCode": "8446 JP",
        "city": "Heerenveen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.mommiesandmiracles.nl/",
        "latitude": 52.9471997,
        "longitude": 5.923187,
        "customAddr": "Roerdomplaan 21, Heerenveen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU5MDQ5MjI0MTUyNzQzODI3OTUxOzAwOyc=\"",
        "no": "C10186",
        "name": "Grocery-Store",
        "eMail": "info@grocery-store.nl",
        "customerGroup": "ONLINE",
        "address": "Van Ghentstraat 32",
        "postCode": "3262 EM",
        "city": "Oud-Beijerland",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8210584,
        "longitude": 4.408891400000001,
        "customAddr": "Van Ghentstraat 32, Oud-Beijerland, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzY2MTY4MzU3NzI1NDUxNzU1NjExOzAwOyc=\"",
        "no": "C10187",
        "name": "Goldig Concept ",
        "eMail": "hello@goldigconcept.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Churerstrasse 32",
        "postCode": "HS 9470",
        "city": "Buchs",
        "countryRegionCode": "CH",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 47.1607685,
        "longitude": 9.4756862,
        "customAddr": "Churerstrasse 32, Buchs, CH"
      },
      {
        "@odata.etag": "W/\"JzIwOzExOTQ5Njk1MDU3NjU3NTQwMDk4MTswMDsn\"",
        "no": "C10188",
        "name": "LILIBOO",
        "eMail": "info@liliboo.nl",
        "customerGroup": "ONLINE",
        "address": "Poortwachter 108",
        "postCode": "1531TZ",
        "city": "Wormer",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.499498,
        "longitude": 4.79795,
        "customAddr": "Poortwachter 108, Wormer, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk0Njk5Nzg2NzQyMDM5NjY5ODUxOzAwOyc=\"",
        "no": "C10189",
        "name": "Bij en Mus",
        "eMail": "b2b@bijenmus.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Grote Kerkstraat 4",
        "postCode": "7941 LB",
        "city": "Meppel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.bijenmus.nl/",
        "latitude": 52.6971842,
        "longitude": 6.1908688,
        "customAddr": "Grote Kerkstraat 4, Meppel, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzM1NzE0MTc0NzgxMDU1MTc0NDYxOzAwOyc=\"",
        "no": "C10190",
        "name": "Petite Jul'eau ",
        "eMail": "info@juleau.nl",
        "customerGroup": "ONLINE",
        "address": "Lindegracht 27",
        "postCode": "8441 GK",
        "city": "Heerenveen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.9605279,
        "longitude": 5.9244056,
        "customAddr": "Lindegracht 27, Heerenveen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MzIyMDQ1NTk0MzczODQ1MjYwMTswMDsn\"",
        "no": "C10191",
        "name": "Kruimel",
        "eMail": "info@kruimel-baby.nl",
        "customerGroup": "ONLINE",
        "address": "Jacob Merlostraat 10",
        "postCode": "5961 AB",
        "city": "Horst",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.kruimel-kids.nl/",
        "latitude": 51.4552531,
        "longitude": 6.0512688,
        "customAddr": "Jacob Merlostraat 10, Horst, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzNDc1MzY1MDM3Mzg2MTUxOTU1MTswMDsn\"",
        "no": "C10192",
        "name": "Petit Soof",
        "eMail": "contact@petitsoof.nl",
        "customerGroup": "ONLINE",
        "address": "Fahrenheitstraat 615",
        "postCode": "2561DC",
        "city": "Den Haag",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0785455,
        "longitude": 4.2697086,
        "customAddr": "Fahrenheitstraat 615, Den Haag, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMDc2MDgxODgxMzE0MDgxNDU1MTswMDsn\"",
        "no": "C10193",
        "name": "K一家小店",
        "eMail": "shine600@163.com",
        "customerGroup": "ONLINE",
        "address": "Qing Yang Qu DongYuanShiGuangDao 9-1801",
        "postCode": "610000",
        "city": "Chengdu",
        "countryRegionCode": "CN",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 30.6748499,
        "longitude": 104.06291,
        "customAddr": "Qing Yang Qu DongYuanShiGuangDao 9-1801, Chengdu, CN"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NTAyNzI3ODc3MDc2Mjc2NjkwMTswMDsn\"",
        "no": "C10194",
        "name": "Keekabuu",
        "eMail": "info@keekabuu.com",
        "customerGroup": "ONLINE",
        "address": "Mitchamplein 3E",
        "postCode": "7556 SC",
        "city": "Hengelo",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-17",
        "homepage": "https://keekabuu.com/",
        "latitude": 52.2669018,
        "longitude": 6.7871051,
        "customAddr": "Mitchamplein 3E, Hengelo, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NTYxNTAyODE1NzYxMzU3NDYwMTswMDsn\"",
        "no": "C10195",
        "name": "Alweroshop",
        "eMail": "info@alweroshop.nl",
        "customerGroup": "ONLINE",
        "address": "Past. Vernooystraat 5b",
        "postCode": "7071 BR",
        "city": "Ulft",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 3,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-09-04",
        "homepage": "",
        "latitude": 51.8915883,
        "longitude": 6.382770499999999,
        "customAddr": "Past. Vernooystraat 5b, Ulft, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk3MjcyMzIzMzg5NTMyMjk5NjUxOzAwOyc=\"",
        "no": "C10196",
        "name": "mini moon VVZRL",
        "eMail": "info@minimoon.be",
        "customerGroup": "PHYSANDDIG",
        "address": "De Munt 16",
        "postCode": "8800",
        "city": "Roeselare",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-16",
        "homepage": "https://www.minimoon.be/",
        "latitude": 50.9466207,
        "longitude": 3.1245096,
        "customAddr": "De Munt 16, Roeselare, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzEzMDMxODU5MDI3ODcxMzAxMDIxOzAwOyc=\"",
        "no": "C10197",
        "name": "Dream out Loud",
        "eMail": "info@dreamoutloud.shop",
        "customerGroup": "ONLINE",
        "address": "Charloisse Lagedijk 471",
        "postCode": "3084LA",
        "city": "Rotterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-11",
        "homepage": "https://dreamoutloud.shop/",
        "latitude": 51.8672497,
        "longitude": 4.4867116,
        "customAddr": "Charloisse Lagedijk 471, Rotterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MTY0NTE2MTkwMjk3MzI2ODM2MTswMDsn\"",
        "no": "C10198",
        "name": "Echt eigen ",
        "eMail": "info@echteigen.nl",
        "customerGroup": "PHYSICAL",
        "address": "Overtoom 1a",
        "postCode": "1901EW",
        "city": "Castricum",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.54628659999999,
        "longitude": 4.6624098,
        "customAddr": "Overtoom 1a, Castricum, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2MDA4OTc0NzE5MDY5NTkwMTA0MTswMDsn\"",
        "no": "C10199",
        "name": "The Fable Kids",
        "eMail": "shop@thefablekids.nl",
        "customerGroup": "ONLINE",
        "address": "Grutto 24",
        "postCode": "7462 ZH",
        "city": "Rijssen ",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://thefablekids.nl/",
        "latitude": 52.30750940000001,
        "longitude": 6.500703,
        "customAddr": "Grutto 24, Rijssen , NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMwMzY3MTIzNjc3MjI5MDM5NjgxOzAwOyc=\"",
        "no": "C10200",
        "name": "Studio Noré",
        "eMail": "info@studionore.com",
        "customerGroup": "ONLINE",
        "address": "Bètaplein 144",
        "postCode": "2321KS",
        "city": "Leiden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.14534980000001,
        "longitude": 4.4945428,
        "customAddr": "Bètaplein 144, Leiden, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNzYxNjQ5NzA0Nzg0MjkyMTUyMTswMDsn\"",
        "no": "C10201",
        "name": "Hello Archie",
        "eMail": "birgitvandriessche@helloarchie.com",
        "customerGroup": "ONLINE",
        "address": "Daknam Dorp 8",
        "postCode": "9160",
        "city": "Lokeren",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.124503,
        "longitude": 3.9805094,
        "customAddr": "Daknam Dorp 8, Lokeren, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMjE1NzczMzY2MjI1MzMxOTk2MTswMDsn\"",
        "no": "C10202",
        "name": "KLEIN ATELIER",
        "eMail": "evaderoover@hotmail.com",
        "customerGroup": "ONLINE",
        "address": "Duffelsesteenweg 63",
        "postCode": "2550",
        "city": "Kontich",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.1306835,
        "longitude": 4.4491821,
        "customAddr": "Duffelsesteenweg 63, Kontich, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzExMzQ1NjEyOTA5ODgwMTU5ODgxOzAwOyc=\"",
        "no": "C10203",
        "name": "Klein Studio",
        "eMail": "info@kleinstudio.dk",
        "customerGroup": "ONLINE",
        "address": "Brønlunds Alle 9",
        "postCode": "2900",
        "city": "Hellerup",
        "countryRegionCode": "DK",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 55.7276016,
        "longitude": 12.5481326,
        "customAddr": "Brønlunds Alle 9, Hellerup, DK"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc0NjA4Nzc2NDU1OTQ3MjgzMDkxOzAwOyc=\"",
        "no": "C10204",
        "name": "Little Shop around the Corner",
        "eMail": "littleshoparoundthecorner@live.nl",
        "customerGroup": "ONLINE",
        "address": "Paul Rodenkolaan 68",
        "postCode": "7207CH",
        "city": "Zutphen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.littleshoparoundthecorner.nl/",
        "latitude": 52.12978,
        "longitude": 6.2241838,
        "customAddr": "Paul Rodenkolaan 68, Zutphen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NTA3Mzc5MTk3MDg1NDQxMzM4MTswMDsn\"",
        "no": "C10205",
        "name": "Papallou NY",
        "eMail": "miriam@papallou.com",
        "customerGroup": "PHYSANDDIG",
        "address": "5102-12th ave",
        "postCode": "11219",
        "city": "Brooklyn",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://papallou.com/",
        "latitude": 40.635292,
        "longitude": -73.99580999999999,
        "customAddr": "5102-12th ave, Brooklyn, US"
      },
      {
        "@odata.etag": "W/\"JzE5OzY4MDA3MjM4OTk0OTMyNTk3NTExOzAwOyc=\"",
        "no": "C10206",
        "name": "Mom•Me Box",
        "eMail": "info@mommebox.nl",
        "customerGroup": "ONLINE",
        "address": "Lijsterbesplein 17",
        "postCode": "2563KZ",
        "city": "Den Haag",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0739611,
        "longitude": 4.2650654,
        "customAddr": "Lijsterbesplein 17, Den Haag, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc1OTcwMTE1NzkzMDU5NDQ1MDcxOzAwOyc=\"",
        "no": "C10207",
        "name": "chu chu CHUPETERIA",
        "eMail": "chuchuchupeteria@gmail.com",
        "customerGroup": "ONLINE",
        "address": "3-40-10 Kitashinjuku",
        "postCode": "1690074",
        "city": "Shinjuku",
        "countryRegionCode": "JP",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-07-17",
        "homepage": "",
        "latitude": 35.705047,
        "longitude": 139.6890223,
        "customAddr": "3-40-10 Kitashinjuku, Shinjuku, JP"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1NjE5MjYyNjcwOTk5NDQ4MjcwMTswMDsn\"",
        "no": "C10208",
        "name": "Bandel",
        "eMail": "hello@bandel-store.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Voorstad 8",
        "postCode": "6131CR",
        "city": "Sittard",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "http://www.bandel-store.nl",
        "latitude": 50.998729,
        "longitude": 5.864370399999999,
        "customAddr": "Voorstad 8, Sittard, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMjc1NDQzMjUzMTIxODQ1NTIxMTswMDsn\"",
        "no": "C10209",
        "name": "My little market ",
        "eMail": "info@mylittlemarket.nl",
        "customerGroup": "PHYSICAL",
        "address": "Langendijk 43 A",
        "postCode": "4201CE",
        "city": "Gorinchem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://mylittlemarket.nl/",
        "latitude": 51.82928829999999,
        "longitude": 4.9761932,
        "customAddr": "Langendijk 43 A, Gorinchem, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NDExNzQ3MDQyNDAzNTkyNzM1MTswMDsn\"",
        "no": "C10210",
        "name": "Loet en Noor",
        "eMail": "loetennoor@outlook.com",
        "customerGroup": "PHYSICAL",
        "address": "Langeviele 29",
        "postCode": "4331 LR",
        "city": "Middelburg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.4978018,
        "longitude": 3.6090825,
        "customAddr": "Langeviele 29, Middelburg, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk3NTc5ODg3NTU1MjkwODY2NjAxOzAwOyc=\"",
        "no": "C10211",
        "name": "Jut & Juul Lifestyle for Kids",
        "eMail": "info@jutenjuul.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Nieuwe Rijn 58",
        "postCode": "2312 JH",
        "city": "Leiden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.jutenjuul.nl/",
        "latitude": 52.1567023,
        "longitude": 4.4945636,
        "customAddr": "Nieuwe Rijn 58, Leiden, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzM4MzQwNDU0MDU5OTg1MjkwODcxOzAwOyc=\"",
        "no": "C10212",
        "name": "VOF Black Dog Bark Back",
        "eMail": "tschaapoverdedam@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Plein 1",
        "postCode": "1861 JX",
        "city": "Bergen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.6749368,
        "longitude": 4.706394599999999,
        "customAddr": "Plein 1, Bergen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MTMwNzE1Mjk2Mjc5MDQyMzE2MTswMDsn\"",
        "no": "C10213",
        "name": "Lidor",
        "eMail": "info@lidor.nl",
        "customerGroup": "ONLINE",
        "address": "Archimedes 8",
        "postCode": "7942DA",
        "city": "Meppel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.7016048,
        "longitude": 6.173535999999999,
        "customAddr": "Archimedes 8, Meppel, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzE0Mzg2ODE4MTk3NzQ4NjQxMTE7MDA7Jw==\"",
        "no": "C10214",
        "name": "JIMINY VOF - Moa.Lova.",
        "eMail": "hello@moalova.be",
        "customerGroup": "ONLINE",
        "address": "Krekelweg 4",
        "postCode": "2820",
        "city": "Bonheiden",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://moalova.be/",
        "latitude": 51.019906,
        "longitude": 4.5475929,
        "customAddr": "Krekelweg 4, Bonheiden, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ2ODgzODc1MzYxMjI5OTEwNjIxOzAwOyc=\"",
        "no": "C10215",
        "name": "Studio Scheveningen",
        "eMail": "info@studioscheveningen.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Keizerstraat 50",
        "postCode": "2584 BK",
        "city": "Scheveningen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.10591609999999,
        "longitude": 4.2742483,
        "customAddr": "Keizerstraat 50, Scheveningen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzE1NjM4NjQ3ODA0ODAzOTYwMDExOzAwOyc=\"",
        "no": "C10216",
        "name": "Klaartje conceptstore",
        "eMail": "info@klaarconceptstore.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Irislaan 53",
        "postCode": "2343CG",
        "city": "Oegstgeest",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://klaarconceptstore.nl/",
        "latitude": 52.1866853,
        "longitude": 4.4709182,
        "customAddr": "Irislaan 53, Oegstgeest, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2ODY3MDY0OTI2NjEwMTg0Mjk0MTswMDsn\"",
        "no": "C10217",
        "name": "",
        "eMail": "testmagento321@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "848 Traction Street 456",
        "postCode": "29673",
        "city": "Piedmont",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 38.7945952,
        "longitude": -106.5348379,
        "customAddr": "848 Traction Street 456, Piedmont, US"
      },
      {
        "@odata.etag": "W/\"JzE5OzU3MzIwMzM2MjQ0NDcyOTQ1NDgxOzAwOyc=\"",
        "no": "C10218",
        "name": "Jack & Zo.",
        "eMail": "info@jackenzo.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Plein 1940 177 ",
        "postCode": "3925JM",
        "city": "Scherpenzeel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-12",
        "homepage": "https://www.jackenzo.nl/nl/",
        "latitude": 52.0797128,
        "longitude": 5.490795,
        "customAddr": "Plein 1940 177 , Scherpenzeel, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwOTQzOTc5MzU2NDIzODk5OTkyMTswMDsn\"",
        "no": "C10219",
        "name": "DOUX BLEU Conceptstore",
        "eMail": "info@douxbleu-conceptstore.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Passage 1",
        "postCode": "5401GK",
        "city": "Uden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-06",
        "homepage": "https://www.douxbleu-conceptstore.nl/",
        "latitude": 51.6576776,
        "longitude": 5.613791,
        "customAddr": "Passage 1, Uden, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExOTMxMDY3MDI5MzAzOTY1NTI4MTswMDsn\"",
        "no": "C10220",
        "name": "So Lit ",
        "eMail": "info@solitstyling.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kromstraat 12A",
        "postCode": "5504 BC",
        "city": "Veldhoven",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.4038259,
        "longitude": 5.3954275,
        "customAddr": "Kromstraat 12A, Veldhoven, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgwMzk3NTc0NjA0NTM3NjUyNjYxOzAwOyc=\"",
        "no": "C10221",
        "name": "Wild mountain hats - Nadeche Fotografie",
        "eMail": "nadechefotografie@hotmail.com",
        "customerGroup": "ONLINE",
        "address": "Oldermannenlaan 5",
        "postCode": "8014NE",
        "city": "Zwolle",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.4960259,
        "longitude": 6.1093736,
        "customAddr": "Oldermannenlaan 5, Zwolle, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzY0MDk1NDU3ODc4MzU5NTAwNDcxOzAwOyc=\"",
        "no": "C10222",
        "name": "Petozzi",
        "eMail": "info@petozzi.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Kruisstraat 10a",
        "postCode": "5211 DV",
        "city": "Den Bosch ",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-15",
        "homepage": "https://www.petozzi.com/nl/",
        "latitude": 51.6893252,
        "longitude": 5.3007199,
        "customAddr": "Kruisstraat 10a, Den Bosch , NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg4MTU1NTM0MDQwNTkyNzM0OTAxOzAwOyc=\"",
        "no": "C10223",
        "name": "Belle&Beau VOf",
        "eMail": "mhswart@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Engstraat 13",
        "postCode": "5256 BD",
        "city": "Heusden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.7342139,
        "longitude": 5.1377038,
        "customAddr": "Engstraat 13, Heusden, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzUyNDE0NTEwMjI5MjE1NTk2NzAxOzAwOyc=\"",
        "no": "C10224",
        "name": "Bibs",
        "eMail": "info@bibsmiddelburg.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Langeviele 69",
        "postCode": "4331LS",
        "city": "Middelburg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.4973654,
        "longitude": 3.6077395,
        "customAddr": "Langeviele 69, Middelburg, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExOTgyNDQzMjgxNzgzMDM5NDcyMTswMDsn\"",
        "no": "C10225",
        "name": "Les ptits mosüs",
        "eMail": "info@lesptitsmosus.com",
        "customerGroup": "ONLINE",
        "address": "1280 Avenue du Chanoine-Morel",
        "postCode": "G1S4B2",
        "city": "Quebec",
        "countryRegionCode": "CA",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 46.7844937,
        "longitude": -71.2478005,
        "customAddr": "1280 Avenue du Chanoine-Morel, Quebec, CA"
      },
      {
        "@odata.etag": "W/\"JzE5OzYyNTI2NTU0NjY2NjU5MjEzNDUxOzAwOyc=\"",
        "no": "C10226",
        "name": "Lagomkind Comm.v.",
        "eMail": "info@lagomkind.com",
        "customerGroup": "ONLINE",
        "address": "Kasteelstraat 31",
        "postCode": "2160",
        "city": "Wommelgem",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.1991601,
        "longitude": 4.530035,
        "customAddr": "Kasteelstraat 31, Wommelgem, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ0ODIxMTQ3NjI3MjY3MDc1MDUxOzAwOyc=\"",
        "no": "C10227",
        "name": "knus & kado",
        "eMail": "info@knusenkado.nl",
        "customerGroup": "ONLINE",
        "address": "De Dellen 9",
        "postCode": "9231 CZ",
        "city": "Surhuisterveen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.knusenkado.nl/",
        "latitude": 53.1830946,
        "longitude": 6.1678282,
        "customAddr": "De Dellen 9, Surhuisterveen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzExNzk3MTQ1OTIxOTI1MjIwMjgxOzAwOyc=\"",
        "no": "C10228",
        "name": "Daily Monkeys",
        "eMail": "denise@dailymonkeys.nl",
        "customerGroup": "ONLINE",
        "address": "Zonweg 28",
        "postCode": "2516BM",
        "city": "Den Haag",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0682172,
        "longitude": 4.3438667,
        "customAddr": "Zonweg 28, Den Haag, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ4MjU4NjkyNjcxMjc1ODAyMjMxOzAwOyc=\"",
        "no": "C10230",
        "name": "Små folk as",
        "eMail": "post@sma-folk.no",
        "customerGroup": "PHYSICAL",
        "address": "Trelastveien 12 H",
        "postCode": "1415",
        "city": "Oppegård",
        "countryRegionCode": "NO",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 59.78833359999999,
        "longitude": 10.801819,
        "customAddr": "Trelastveien 12 H, Oppegård, NO"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk0NjgwNDI0NjU4NDA2MDE2MTUxOzAwOyc=\"",
        "no": "C10232",
        "name": "De Gele Flamingo",
        "eMail": "sophie@degeleflamingo.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Ruiterijschool 14",
        "postCode": "2930",
        "city": "Brasschaat",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://degeleflamingo.nl/",
        "latitude": 51.328221,
        "longitude": 4.5334183,
        "customAddr": "Ruiterijschool 14, Brasschaat, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1MDQ3OTQ2NTExMzU5MzEzOTI5MTswMDsn\"",
        "no": "C10233",
        "name": "Wijs West",
        "eMail": "info@wijswest.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Bilderdijkstraat 62",
        "postCode": "1053KV",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3705207,
        "longitude": 4.870038,
        "customAddr": "Bilderdijkstraat 62, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNjExNzc3MzA1ODI0OTgzMDg5MTswMDsn\"",
        "no": "C10234",
        "name": "PEPITE SRL - One Of A Kind",
        "eMail": "marine@ooak.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Rue du Commerce, 12",
        "postCode": "1300",
        "city": "Wavre",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.716493,
        "longitude": 4.610194,
        "customAddr": "Rue du Commerce, 12, Wavre, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNzA2NTcxMjI2MTEwMDg4MzMxMTswMDsn\"",
        "no": "C10235",
        "name": "RESUMA S.A. Division Textile Botox",
        "eMail": "laurence.winandy@cactus.lu",
        "customerGroup": "ONLINE",
        "address": "Route Des 3 Cartons",
        "postCode": "8399",
        "city": "Windhof",
        "countryRegionCode": "LU",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 49.6469008,
        "longitude": 5.9555852,
        "customAddr": "Route Des 3 Cartons, Windhof, LU"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMjUyNTM2NDc3NzY1ODczMDc3MTswMDsn\"",
        "no": "C10236",
        "name": "Milch und Honig Kinderladen",
        "eMail": "info@milchundhonig-leipzig.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Löhrstr. 14",
        "postCode": "04105",
        "city": "Leipzig",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.34581739999999,
        "longitude": 12.3736447,
        "customAddr": "Löhrstr. 14, Leipzig, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNzEzMTE2NDM0NDQ3MjcwMDA0MTswMDsn\"",
        "no": "C10237",
        "name": "Seas the Day",
        "eMail": "seastheday@ziggo.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Dorpsstraat 167",
        "postCode": "1721BG",
        "city": "Broek op Langedijk",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.6823389,
        "longitude": 4.8080942,
        "customAddr": "Dorpsstraat 167, Broek op Langedijk, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMzQ4MjczNTkyMzQ0NzYzMzE4MTswMDsn\"",
        "no": "C10238",
        "name": "Curated Cradle",
        "eMail": "hello@curatedcradle.com",
        "customerGroup": "PHYSANDDIG",
        "address": "10-370 Wilson street east",
        "postCode": "L9G2C2",
        "city": "Ancaster",
        "countryRegionCode": "CA",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 43.2272369,
        "longitude": -79.9751385,
        "customAddr": "10-370 Wilson street east, Ancaster, CA"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3Njg4MTgzNTIwNzk1MDUwODQ5MTswMDsn\"",
        "no": "C10239",
        "name": "Safer Baby SRL",
        "eMail": "saferbabystore@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Via Monsignore Di sotto 11",
        "postCode": "44045",
        "city": "Dodici Morelli",
        "countryRegionCode": "IT",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 44.8028431,
        "longitude": 11.3035796,
        "customAddr": "Via Monsignore Di sotto 11, Dodici Morelli, IT"
      },
      {
        "@odata.etag": "W/\"JzE5OzY1MzQ2MDMxNDY3MzI0NTQ4NDQxOzAwOyc=\"",
        "no": "C10240",
        "name": "Sprouting Littles",
        "eMail": "sproutinglittlesshop@gmail.com",
        "customerGroup": "ONLINE",
        "address": "1973 Winfield Drive unit 27",
        "postCode": "V3G 1K6",
        "city": "Abbotsford",
        "countryRegionCode": "CA",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-30",
        "homepage": "https://www.sproutinglittles.com/",
        "latitude": 49.0381618,
        "longitude": -122.2288847,
        "customAddr": "1973 Winfield Drive unit 27, Abbotsford, CA"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ4MzcwODkzNzAxMzg3ODQxNjcxOzAwOyc=\"",
        "no": "C10241",
        "name": "De kleine huismuis",
        "eMail": "anieke@kleinehuismuis.nl",
        "customerGroup": "ONLINE",
        "address": "Hengelosestraat 31",
        "postCode": "7482AA",
        "city": "Haaksbergen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.1687497,
        "longitude": 6.7409998,
        "customAddr": "Hengelosestraat 31, Haaksbergen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MTQ0MTIwOTc4Mzg1NDc3ODUyMTswMDsn\"",
        "no": "C10242",
        "name": "Däumling Store -DoPiMi GmbH",
        "eMail": "einkauf@little-seahorse.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Franz-Schubert-STraße 11",
        "postCode": "96472",
        "city": "Rödental",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.3016308,
        "longitude": 11.0407412,
        "customAddr": "Franz-Schubert-STraße 11, Rödental, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzM2MDI1MzIwNzk3MDM1NzgyMDExOzAwOyc=\"",
        "no": "C10244",
        "name": "Teddy & Beer",
        "eMail": "info@teddyenbeer.nl",
        "customerGroup": "ONLINE",
        "address": "Stationsweg 78",
        "postCode": "1851 LM",
        "city": "Heiloo",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://teddyenbeer.nl/",
        "latitude": 52.6000696,
        "longitude": 4.702744099999999,
        "customAddr": "Stationsweg 78, Heiloo, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2MjQ5NTAxNTE3MzQ4MzU1NzkxMTswMDsn\"",
        "no": "C10245",
        "name": "Sweet Something Kids",
        "eMail": "sweetsomethingkids@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Korte Nieuwstraat 23",
        "postCode": "2960",
        "city": "Brecht",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.2964855,
        "longitude": 4.5721067,
        "customAddr": "Korte Nieuwstraat 23, Brecht, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1NDkyNDA1NzcxMTU0MTQ3MDk5MTswMDsn\"",
        "no": "C10246",
        "name": "Bambino Stores",
        "eMail": "hey@bambinostores.com",
        "customerGroup": "ONLINE",
        "address": "The Walled Garden Church Lane Caythorpe",
        "postCode": "NG32 3EL",
        "city": "Grantham",
        "countryRegionCode": "GB",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.0258997,
        "longitude": -0.603665,
        "customAddr": "The Walled Garden Church Lane Caythorpe, Grantham, GB"
      },
      {
        "@odata.etag": "W/\"JzE5OzY5MjAyNTA0MzAxMTk5MjM3OTExOzAwOyc=\"",
        "no": "C10247",
        "name": "Muize-pluis",
        "eMail": "info@muize-pluis.nl",
        "customerGroup": "ONLINE",
        "address": "Dijkstraat 106",
        "postCode": "3904DJ",
        "city": "Veenendaal",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0208485,
        "longitude": 5.530301499999999,
        "customAddr": "Dijkstraat 106, Veenendaal, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzIwODI4NDc1OTcwMDIyMDI3MTExOzAwOyc=\"",
        "no": "C10248",
        "name": "Beijing Fengfeng Changtian Co., Ltd",
        "eMail": "379303131@qq.com",
        "customerGroup": "PHYSICAL",
        "address": "北京市朝阳区北苑路170号4号楼3层(大屯孵化器A748) 403,",
        "postCode": "100300",
        "city": "Beijing",
        "countryRegionCode": "CN",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 39.99792,
        "longitude": 116.4192,
        "customAddr": "北京市朝阳区北苑路170号4号楼3层(大屯孵化器A748) 403,, Beijing, CN"
      },
      {
        "@odata.etag": "W/\"JzE5OzM4MDQyMjExNTc0ODQ2MjYyMDMxOzAwOyc=\"",
        "no": "C10249",
        "name": "Birch and Bear",
        "eMail": "hello@birchandbear.com.au",
        "customerGroup": "ONLINE",
        "address": "287 high St",
        "postCode": "3070",
        "city": "Northcote",
        "countryRegionCode": "AU",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": -37.771983,
        "longitude": 144.9982439,
        "customAddr": "287 high St, Northcote, AU"
      },
      {
        "@odata.etag": "W/\"JzE5OzQyMjc5MjY3NTA2NTQ3MTE4MTUxOzAwOyc=\"",
        "no": "C10250",
        "name": "Sunnao store Tokyo",
        "eMail": "sunnaostore@gmail.com",
        "customerGroup": "ONLINE",
        "address": "kamitakaido, 3-8-21",
        "postCode": "1680074",
        "city": "suginami-ku",
        "countryRegionCode": "JP",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://sunnao.stores.jp/",
        "latitude": 35.6756558,
        "longitude": 139.6161737,
        "customAddr": "kamitakaido, 3-8-21, suginami-ku, JP"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc4MTQyNjc1Nzk5MTQzMTMwMjUxOzAwOyc=\"",
        "no": "C10252",
        "name": "Babyzus",
        "eMail": "info@babyzus.nl",
        "customerGroup": "ONLINE",
        "address": "Prins Hendrikstraat 85",
        "postCode": "1975BP",
        "city": "IJmuiden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.4626983,
        "longitude": 4.590452099999999,
        "customAddr": "Prins Hendrikstraat 85, IJmuiden, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzNzQ4MDY1NTkzNTIzMjIwNjU2MTswMDsn\"",
        "no": "C10254",
        "name": "Wildmoon.cz",
        "eMail": "sales@wildmoon.cz",
        "customerGroup": "ONLINE",
        "address": "Srbínská 6",
        "postCode": "10100",
        "city": "Praha",
        "countryRegionCode": "CZ",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://wildmoon.cz/",
        "latitude": 50.0688977,
        "longitude": 14.4936503,
        "customAddr": "Srbínská 6, Praha, CZ"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ5MDM3Mjc2MzUyODgwNzk5MzYxOzAwOyc=\"",
        "no": "C10255",
        "name": "generous.jp",
        "eMail": "info.generous.jp@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Nadaward,Tsurukabuto4-2-12-303",
        "postCode": "6570011",
        "city": "Kobecity",
        "countryRegionCode": "JP",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 34.7139737,
        "longitude": 135.2281184,
        "customAddr": "Nadaward,Tsurukabuto4-2-12-303, Kobecity, JP"
      },
      {
        "@odata.etag": "W/\"JzE5OzkwNjcyNTkxOTQzOTc3NDIzNDAxOzAwOyc=\"",
        "no": "C10256",
        "name": "Polka Dot",
        "eMail": "winkel@polkadot.nl",
        "customerGroup": "PHYSICAL",
        "address": "Kleine Houtstraat 11",
        "postCode": "2011DD",
        "city": "Haarlem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.37914,
        "longitude": 4.6370572,
        "customAddr": "Kleine Houtstraat 11, Haarlem, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2MTIxMjc4NjQxNjUwMzUwOTQ2MTswMDsn\"",
        "no": "C10257",
        "name": "UMI kids",
        "eMail": "18750711302@163.com",
        "customerGroup": "ONLINE",
        "address": "Unit 2404, Building 3, Wanda Central Huacheng Community, Bihu Road, Longwen District",
        "postCode": "363005",
        "city": "Zhangzhou",
        "countryRegionCode": "CN",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 24.49636,
        "longitude": 117.678551,
        "customAddr": "Unit 2404, Building 3, Wanda Central Huacheng Community, Bihu Road, Longwen District, Zhangzhou, CN"
      },
      {
        "@odata.etag": "W/\"JzE5OzUyNTM3Mjk3MDI0MTg4Mjc1MDcxOzAwOyc=\"",
        "no": "C10258",
        "name": "coucou natur",
        "eMail": "hello@coucou-natur.com",
        "customerGroup": "ONLINE",
        "address": "Albrecht-Dürer-Str. 3",
        "postCode": "83026",
        "city": "Rosenheim",
        "countryRegionCode": "DE",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-31",
        "homepage": "https://www.coucou-natur.com/",
        "latitude": 47.8379461,
        "longitude": 12.1254204,
        "customAddr": "Albrecht-Dürer-Str. 3, Rosenheim, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzU2MzExOTQyMDM4ODA0Njk5NzExOzAwOyc=\"",
        "no": "C10259",
        "name": "Wolfje kids conceptstore ",
        "eMail": "info@wolfjekids.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "De korf 23",
        "postCode": "2924AH",
        "city": "Krimpen aan den IJssel ",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.wolfjekids.nl/",
        "latitude": 51.92231580000001,
        "longitude": 4.6107678,
        "customAddr": "De korf 23, Krimpen aan den IJssel , NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0OTY5NDc0NTY2OTY1ODMzNzMzMTswMDsn\"",
        "no": "C10260",
        "name": "Teddy & James",
        "eMail": "info@teddyjames.nl",
        "customerGroup": "ONLINE",
        "address": "Rooseveltlaan 182-1",
        "postCode": "1078 NV",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3434857,
        "longitude": 4.8969687,
        "customAddr": "Rooseveltlaan 182-1, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzE5MTMxOTc5MDAwMjE3Njg4NDExOzAwOyc=\"",
        "no": "C10261",
        "name": "ELUUN",
        "eMail": "info@eluun.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Grote markt 2",
        "postCode": "8011 LV",
        "city": "Zwolle",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://eluun.nl/",
        "latitude": 52.5118632,
        "longitude": 6.092941499999999,
        "customAddr": "Grote markt 2, Zwolle, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2Mjc4MTI2MDUyNTg3MDk2NjU4MTswMDsn\"",
        "no": "C10262",
        "name": "Mint Mini Mall",
        "eMail": "info@mintminimall.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Runstraat 27",
        "postCode": "1016GJ",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.368868,
        "longitude": 4.8831149,
        "customAddr": "Runstraat 27, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMzU1NTYyMzM1ODAxNDM4NTA0MTswMDsn\"",
        "no": "C10263",
        "name": "Ode to Wool",
        "eMail": "aude@odetowool.com",
        "customerGroup": "ONLINE",
        "address": "Clos des érables, 4",
        "postCode": "1950",
        "city": "Kraainem",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.8437047,
        "longitude": 4.4695974,
        "customAddr": "Clos des érables, 4, Kraainem, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzIxNTExNzIyNTgwODMxOTI3ODgxOzAwOyc=\"",
        "no": "C10264",
        "name": "Veritas NV",
        "eMail": "she@veritas.be",
        "customerGroup": "PHYSANDDIG",
        "address": "De Villermontstraat 9",
        "postCode": "2550",
        "city": "Kontich",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.1398859,
        "longitude": 4.441443899999999,
        "customAddr": "De Villermontstraat 9, Kontich, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzEzMjEwNjYzNzQzMDM2ODY1NTIxOzAwOyc=\"",
        "no": "C10265",
        "name": "Lucija s.r.o.",
        "eMail": "messybrassy@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Východná 6968/26A",
        "postCode": "911 08",
        "city": "Trenčín",
        "countryRegionCode": "SK",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 48.87143469999999,
        "longitude": 18.0530697,
        "customAddr": "Východná 6968/26A, Trenčín, SK"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NjQ1MDkzNjY4MzM0MTIwODEzMTswMDsn\"",
        "no": "C10266",
        "name": "BlondbyFashion Conceptstore ",
        "eMail": "info@blondbyfashion.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Raadhuisstraat 3-b2",
        "postCode": "5261EH",
        "city": "Vught",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.6573226,
        "longitude": 5.299550600000001,
        "customAddr": "Raadhuisstraat 3-b2, Vught, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MjA2ODEyOTEyNzU4MjU0MjU1MTswMDsn\"",
        "no": "C10267",
        "name": "natura Kinderladen",
        "eMail": "info@natura-kinderladen.de",
        "customerGroup": "PHYSICAL",
        "address": "Herzog-Otto-Str. 8",
        "postCode": "83022",
        "city": "Rosenheim",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.natura-kinderladen.de/",
        "latitude": 47.85443,
        "longitude": 12.12297,
        "customAddr": "Herzog-Otto-Str. 8, Rosenheim, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1Njg5OTE0NjA2MDIzMzYzMzkxMTswMDsn\"",
        "no": "C10268",
        "name": "finnlilli",
        "eMail": "info@littlenordicbaby.com",
        "customerGroup": "ONLINE",
        "address": "hjorths gata 12",
        "postCode": "26936",
        "city": "bastad ",
        "countryRegionCode": "SE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 56.4283321,
        "longitude": 12.8596554,
        "customAddr": "hjorths gata 12, bastad , SE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyOTI5OTgxMTYxNDY1MjA1NDk5MTswMDsn\"",
        "no": "C10270",
        "name": "Kixx International - Kixx Online ",
        "eMail": "yvonne@kixx-online.nl",
        "customerGroup": "ONLINE",
        "address": "46 Newtonstraat",
        "postCode": "1704SB",
        "city": "Heerhugowaard",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.69482199999999,
        "longitude": 4.834635,
        "customAddr": "46 Newtonstraat, Heerhugowaard, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgzMjgzMDA1MzQ1MDUyMzgxNDAxOzAwOyc=\"",
        "no": "C10271",
        "name": "Lotties",
        "eMail": "lotties.lotties@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Hoofdstraat 184",
        "postCode": "2071 EM",
        "city": "Santpoort-Noord",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.4308416,
        "longitude": 4.6440017,
        "customAddr": "Hoofdstraat 184, Santpoort-Noord, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MjA5NDI2MjMzMjA5MzgwMzU0MTswMDsn\"",
        "no": "C10273",
        "name": "THE CHILDHOODCOLLECTIVE",
        "eMail": "thechildhoodcollective@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Burgermeester Lovinkstraat 91",
        "postCode": "1764GD",
        "city": "Breezand",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://thechildhoodcollective.nl/",
        "latitude": 52.8944728,
        "longitude": 4.8084978,
        "customAddr": "Burgermeester Lovinkstraat 91, Breezand, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzQ0MTM4NzE5MTYxNjQzNTM0ODE7MDA7Jw==\"",
        "no": "C10274",
        "name": "Never grow up - babyshop",
        "eMail": "nevergrowupbabyshop@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Kleine Houtstraat 6",
        "postCode": "2011 DM",
        "city": "Haarlem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-13",
        "homepage": "https://www.nevergrowupbabyshop.nl/",
        "latitude": 52.3793482,
        "longitude": 4.6367951,
        "customAddr": "Kleine Houtstraat 6, Haarlem, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMxOTY3NDQzODUxODM0NDYzNjcxOzAwOyc=\"",
        "no": "C10275",
        "name": "poeticmansion",
        "eMail": "mail@poeticmansion.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Donker Weg 45",
        "postCode": "41748",
        "city": "Viersen",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.2509716,
        "longitude": 6.4216346,
        "customAddr": "Donker Weg 45, Viersen, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzgxODYzNDI5NzI1MjQ2Njc1NDMxOzAwOyc=\"",
        "no": "C10276",
        "name": "Groho ",
        "eMail": "info@leviandmeli.nl",
        "customerGroup": "ONLINE",
        "address": "Tonnnenbergerhout 7",
        "postCode": "3845HD",
        "city": "Harderwijk",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-07-17",
        "homepage": "",
        "latitude": 52.3244614,
        "longitude": 5.604285099999999,
        "customAddr": "Tonnnenbergerhout 7, Harderwijk, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMjMyMzc1MDI3Mjg4MzE2Mjc2MTswMDsn\"",
        "no": "C10277",
        "name": "wonder & melon",
        "eMail": "hello@wonderandmelon.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Zuiderhagen 37",
        "postCode": "7511GJ",
        "city": "Enschede",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-01",
        "homepage": "https://wonderandmelon.nl/",
        "latitude": 52.2196518,
        "longitude": 6.8938063,
        "customAddr": "Zuiderhagen 37, Enschede, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzczNTY0MTAyNjc2MzA5NTExNDE7MDA7Jw==\"",
        "no": "C10278",
        "name": "Phien",
        "eMail": "info@byphien.nl",
        "customerGroup": "ONLINE",
        "address": "2e Daalsedijk 61",
        "postCode": "3551 EB",
        "city": "Utrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0989837,
        "longitude": 5.1009897,
        "customAddr": "2e Daalsedijk 61, Utrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNjk2OTAxMjA1NTg0NTkwNDM5MTswMDsn\"",
        "no": "C10279",
        "name": "Chance",
        "eMail": "jvanzoeren@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Oude schans 26",
        "postCode": "3752AG",
        "city": "Spakenburg",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-28",
        "homepage": "https://chancekinderkleding.nl/",
        "latitude": 52.2541731,
        "longitude": 5.3779243,
        "customAddr": "Oude schans 26, Spakenburg, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NjE2Nzg3NzM3MzE2MjkxNDk0MTswMDsn\"",
        "no": "C10281",
        "name": "Charlotte et Charlie",
        "eMail": "achats@charlotteetcharlie.ca",
        "customerGroup": "PHYSANDDIG",
        "address": "1751 rue du marais Suite 180",
        "postCode": "G1M 0A2",
        "city": "Quebec",
        "countryRegionCode": "CA",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 46.8146608,
        "longitude": -71.28797829999999,
        "customAddr": "1751 rue du marais Suite 180, Quebec, CA"
      },
      {
        "@odata.etag": "W/\"JzE5OzIyODI3OTQ4OTUxODg3MjUwOTYxOzAwOyc=\"",
        "no": "C10283",
        "name": "Atajanova Kidsfashion",
        "eMail": "nordischkindch@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Winterthurerstrasse 47",
        "postCode": "8006",
        "city": "Zurich",
        "countryRegionCode": "CH",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 47.3883592,
        "longitude": 8.546424499999999,
        "customAddr": "Winterthurerstrasse 47, Zurich, CH"
      },
      {
        "@odata.etag": "W/\"JzE5OzIzNjgwMjU2OTgzODcxNDI4MTMxOzAwOyc=\"",
        "no": "C10285",
        "name": "Bobo Bear",
        "eMail": "info@bobobear.ca",
        "customerGroup": "ONLINE",
        "address": "3139 polo pl",
        "postCode": "L5M6K9",
        "city": "Mississauga",
        "countryRegionCode": "CA",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 43.563759,
        "longitude": -79.74521610000001,
        "customAddr": "3139 polo pl, Mississauga, CA"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc0NjI2NzIwOTk1NjYyMzY3MDkxOzAwOyc=\"",
        "no": "C10286",
        "name": "DEAR FAM",
        "eMail": "DEARFAMMAIL@GMAIL.COM",
        "customerGroup": "ONLINE",
        "address": "HORTENSIA, 12",
        "postCode": "18199",
        "city": "CAJAR",
        "countryRegionCode": "ES",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 37.1274002,
        "longitude": -3.5693039,
        "customAddr": "HORTENSIA, 12, CAJAR, ES"
      },
      {
        "@odata.etag": "W/\"JzE5OzkxNjU0MTY0ODE3OTA0ODA0NDgxOzAwOyc=\"",
        "no": "C10287",
        "name": "Sessa ",
        "eMail": "info@paploustore.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Dorpsstraat 28/1",
        "postCode": "3500",
        "city": "Hasselt",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.9324921,
        "longitude": 5.335262,
        "customAddr": "Dorpsstraat 28/1, Hasselt, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MzM0MDkzNTE4MTk4NzIzNTE0MTswMDsn\"",
        "no": "C10288",
        "name": "Maart Food Marketing & Concepts",
        "eMail": "maartjebruijns@yahoo.com",
        "customerGroup": "PHYSICAL",
        "address": "Freesiaberg 37",
        "postCode": "4708 CE",
        "city": "Roosendaal",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.5095661,
        "longitude": 4.4324123,
        "customAddr": "Freesiaberg 37, Roosendaal, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzUwMTEzMzMwMjk2MTIzNzAzNjE7MDA7Jw==\"",
        "no": "C10289",
        "name": "FLO",
        "eMail": "inetrimpeneers@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Beekstraat 6",
        "postCode": "3800",
        "city": "Sint-Truiden",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.81529519999999,
        "longitude": 5.1837998,
        "customAddr": "Beekstraat 6, Sint-Truiden, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzU0MDExOTUzMzgyNzk5NTMyMDIxOzAwOyc=\"",
        "no": "C10290",
        "name": "Sundays Kids Store",
        "eMail": "sundayskidsstore@gmail.com",
        "customerGroup": "ONLINE",
        "address": "15 rue Pablo picasso",
        "postCode": "51100",
        "city": "Reims",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 49.2557902,
        "longitude": 4.0525059,
        "customAddr": "15 rue Pablo picasso, Reims, FR"
      },
      {
        "@odata.etag": "W/\"JzE4OzU0MTM0MDcyMDA2NTAzNjc3OTE7MDA7Jw==\"",
        "no": "C10291",
        "name": "Living and Glamour",
        "eMail": "shuchinlim@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Visserssteeg 4",
        "postCode": "3752BZ",
        "city": "Bunschoten",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.2544193,
        "longitude": 5.3770612,
        "customAddr": "Visserssteeg 4, Bunschoten, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMjA0NzczMTQ2MTgzMTM3NDM0MTswMDsn\"",
        "no": "C10292",
        "name": "Hatseflats kinderkleding & meer ",
        "eMail": "info@hatseflatskinderkleding.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Slijkstraat 40",
        "postCode": "1381 BA",
        "city": "Weesp",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.hatseflatskinderkleding.nl/",
        "latitude": 52.3083736,
        "longitude": 5.041061,
        "customAddr": "Slijkstraat 40, Weesp, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQwOTI5NzUxNjkwMjU1MTcyOTgxOzAwOyc=\"",
        "no": "C10293",
        "name": "Room4Kids",
        "eMail": "els@room4kids.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Sint Jorisstraat 26",
        "postCode": "9300",
        "city": "Aalst",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.9371845,
        "longitude": 4.0377306,
        "customAddr": "Sint Jorisstraat 26, Aalst, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMDQyMjcwMDc3MDM1NDE5MDAzMTswMDsn\"",
        "no": "C10294",
        "name": "Wijsneus",
        "eMail": "info@wijsneus.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Vismarkt 26",
        "postCode": "9711 KT",
        "city": "Groningen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.2171933,
        "longitude": 6.5656856,
        "customAddr": "Vismarkt 26, Groningen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzIzNDI0NDkzNjI4ODIzNjY2NDIxOzAwOyc=\"",
        "no": "C10296",
        "name": "Zin in! Kids Conceptstore ",
        "eMail": "Info@zininkidsconceptstore.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "‘t Hooghuis 1-2",
        "postCode": "4191AE",
        "city": "Geldermalsen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.zininkidsconceptstore.nl/",
        "latitude": 51.8830563,
        "longitude": 5.2888993,
        "customAddr": "‘t Hooghuis 1-2, Geldermalsen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMDY3NzQzODY1MDAxMjI0ODQ3MTswMDsn\"",
        "no": "C10297",
        "name": "Rumah Conceptstore",
        "eMail": "rumahconceptstore@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Rembrandtstraat 15",
        "postCode": "2671 GC",
        "city": "Naaldwijk",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9940902,
        "longitude": 4.2074821,
        "customAddr": "Rembrandtstraat 15, Naaldwijk, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMjQ0ODU3MzkyMTQ0OTE4MTI0MTswMDsn\"",
        "no": "C10298",
        "name": "Gerca nv",
        "eMail": "laura@berca.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Hoogbeverenstraat 25",
        "postCode": "8850",
        "city": "Ardooie",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.9936416,
        "longitude": 3.1705364,
        "customAddr": "Hoogbeverenstraat 25, Ardooie, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3Nzk4ODM5MDQ0NTgxNjAzNjIxMTswMDsn\"",
        "no": "C10299",
        "name": "Lovt Amsterdam",
        "eMail": "info@lovt-amsterdam.com",
        "customerGroup": "ONLINE",
        "address": "Majanggracht 20",
        "postCode": "1019PW",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.37819510000001,
        "longitude": 4.9296147,
        "customAddr": "Majanggracht 20, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNjEyOTE0NzU4ODYwNzk2NDgzMTswMDsn\"",
        "no": "C10300",
        "name": "MADIS",
        "eMail": "olivia@littlecasba.com",
        "customerGroup": "PHYSANDDIG",
        "address": "102 RAISE MARITAISE",
        "postCode": "17580",
        "city": "LE BOIS PLAGE EN RE",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 46.1799198,
        "longitude": -1.3891752,
        "customAddr": "102 RAISE MARITAISE, LE BOIS PLAGE EN RE, FR"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ1NjIwMjM5NTcwNjk1MTg2NjUxOzAwOyc=\"",
        "no": "C10301",
        "name": "CoCoCopenhagenApS",
        "eMail": "ht.cococopenhagen@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Grønnegade 31",
        "postCode": "2970",
        "city": "Hørsholm",
        "countryRegionCode": "DK",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 55.8808579,
        "longitude": 12.465877,
        "customAddr": "Grønnegade 31, Hørsholm, DK"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3NjkyNTUzMjI5OTA1NjIwNTE0MTswMDsn\"",
        "no": "C10302",
        "name": "Something New Store ",
        "eMail": "info@somethingnew-store.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Hoofdstraat 47",
        "postCode": "6436CB",
        "city": "Amstenrade",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.somethingnew-store.nl/",
        "latitude": 50.9415606,
        "longitude": 5.923380799999999,
        "customAddr": "Hoofdstraat 47, Amstenrade, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk0ODY3OTkzNDk5MzAwMDY3OTMxOzAwOyc=\"",
        "no": "C10303",
        "name": "Villa UK",
        "eMail": "info@villa-uk.nl",
        "customerGroup": "ONLINE",
        "address": "Heereweg 204",
        "postCode": "2161BP",
        "city": "Lisse",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.villa-uk.nl/",
        "latitude": 52.2601472,
        "longitude": 4.5542606,
        "customAddr": "Heereweg 204, Lisse, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2Njk0MzU0MzMyOTQ4NDE0ODM1MTswMDsn\"",
        "no": "C10304",
        "name": "Auryn Naturfashion GmbH",
        "eMail": "info@auryn-shop.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Reichenbachstr. 35",
        "postCode": "80469",
        "city": "München",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 48.130059,
        "longitude": 11.5760007,
        "customAddr": "Reichenbachstr. 35, München, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzU3NzUyODQ4NTM0MTIwMzUyNzUxOzAwOyc=\"",
        "no": "C10305",
        "name": "FEMME + FRENKIE",
        "eMail": "joscha@femmefrenkie.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Voldersgracht 28",
        "postCode": "2611 EV",
        "city": "Delft",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://femmefrenkie.com/",
        "latitude": 52.0126406,
        "longitude": 4.359995899999999,
        "customAddr": "Voldersgracht 28, Delft, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg2OTE1NDM4NjQ1MjgwMDIxODUxOzAwOyc=\"",
        "no": "C10306",
        "name": "Club Coucoun",
        "eMail": "julie_motte@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Kortrijksesteenweg 69",
        "postCode": "8530",
        "city": "Harelbeke",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.8503084,
        "longitude": 3.3027852,
        "customAddr": "Kortrijksesteenweg 69, Harelbeke, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1Mjk0NzI0MjMyMjUyMzgyMDg4MTswMDsn\"",
        "no": "C10307",
        "name": "Little wow GmbH & Co Kg",
        "eMail": "lara@littlewow.co",
        "customerGroup": "PHYSANDDIG",
        "address": "Eppendorfer Weg 268",
        "postCode": "20251",
        "city": "Hamburg",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.5840192,
        "longitude": 9.9789916,
        "customAddr": "Eppendorfer Weg 268, Hamburg, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzE2NDE2NTQ1NzI1OTkwOTA1MDUxOzAwOyc=\"",
        "no": "C10308",
        "name": "Cocoomade",
        "eMail": "cocoomade@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "De uitpalingen 19",
        "postCode": "3971",
        "city": "Heppen",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.1051259,
        "longitude": 5.2155213,
        "customAddr": "De uitpalingen 19, Heppen, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MjgyNzk0MjA4OTE5MjQyNTA5MTswMDsn\"",
        "no": "C10309",
        "name": "Lil' Bobs",
        "eMail": "marieke@lilbobs.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Oost Kinderdijk 4",
        "postCode": "2953 CP",
        "city": "Alblasserdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.lil-bobs.nl/",
        "latitude": 51.8644646,
        "longitude": 4.6493838,
        "customAddr": "Oost Kinderdijk 4, Alblasserdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0ODQ3MDYxODAyNzIyODk4MDQxMTswMDsn\"",
        "no": "C10310",
        "name": "Terveyskauppa Päivi Haajanen Oy/Aito kauppa",
        "eMail": "imatra@aitokauppa.fi",
        "customerGroup": "PHYSANDDIG",
        "address": "Tietäjänkatu 2",
        "postCode": "55120",
        "city": "Imatra",
        "countryRegionCode": "FI",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 61.18771029999999,
        "longitude": 28.7716021,
        "customAddr": "Tietäjänkatu 2, Imatra, FI"
      },
      {
        "@odata.etag": "W/\"JzE5OzQyOTY4MDcyNTgyNjk1MDg2MzgxOzAwOyc=\"",
        "no": "C10311",
        "name": "Yan & Toet",
        "eMail": "yanentoet@gmail.com",
        "customerGroup": "ONLINE",
        "address": "het Kruys 20",
        "postCode": "5296NT",
        "city": "Esch",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.608638,
        "longitude": 5.292261,
        "customAddr": "het Kruys 20, Esch, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzE2ODMwODk1NjQ4NTk0MTg1NzIxOzAwOyc=\"",
        "no": "C10312",
        "name": "ERGOMEDICS bvba",
        "eMail": "info@ergomedics.be",
        "customerGroup": "ONLINE",
        "address": "Jan van Rijswijcklaan 290",
        "postCode": "2020",
        "city": "Antwerpen",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.webshop-ergomedics.be/",
        "latitude": 51.1851626,
        "longitude": 4.390830300000001,
        "customAddr": "Jan van Rijswijcklaan 290, Antwerpen, BE"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc0OTU0Mzc0MDI1MjEwODA3NjcxOzAwOyc=\"",
        "no": "C10313",
        "name": "Klijntje Baby- & kids lifestyle",
        "eMail": "info@klijntje.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Aasterbergerweg 19 a",
        "postCode": "6101 AC",
        "city": "Echt",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.105581,
        "longitude": 5.861074299999999,
        "customAddr": "Aasterbergerweg 19 a, Echt, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQzNjIxMTQ3ODEzMTgzMDYyMjcxOzAwOyc=\"",
        "no": "C10314",
        "name": "Les enfants terribles bvba",
        "eMail": "info@les-enfants-terribles.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Mechelsestraat 52",
        "postCode": "3000",
        "city": "Leuven",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.les-enfants-terribles.be/",
        "latitude": 50.8810971,
        "longitude": 4.6996654,
        "customAddr": "Mechelsestraat 52, Leuven, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNTI2NTI2NzI1MDY0ODEwNjQwMTswMDsn\"",
        "no": "C10315",
        "name": "Mums Closet by Bobbi Jean ",
        "eMail": "bybobbijean@yahoo.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Corridor 19",
        "postCode": "3901AL",
        "city": "Veenendaal",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://mumscloset.webshopapp.com/",
        "latitude": 52.0251357,
        "longitude": 5.5554396,
        "customAddr": "Corridor 19, Veenendaal, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzM0NzEwNTcwNDk4ODIxOTg3ODExOzAwOyc=\"",
        "no": "C10316",
        "name": "Kideo Online B.V.",
        "eMail": "webwinkel@kideo.nl",
        "customerGroup": "ONLINE",
        "address": "Vossenkamp 7J",
        "postCode": "9351VR",
        "city": "Leek",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-05",
        "homepage": "https://kideo.store/",
        "latitude": 53.1876985,
        "longitude": 6.3739002,
        "customAddr": "Vossenkamp 7J, Leek, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzExNjIxNTY1MDg0NTUwMzE1MzIxOzAwOyc=\"",
        "no": "C10317",
        "name": "Mini-Cycle Inc.",
        "eMail": "wholesale@mini-cycle.com",
        "customerGroup": "PHYSANDDIG",
        "address": "5524 Rue Saint-Patrick, Suite 491",
        "postCode": "H4E 1A8",
        "city": "Montreal",
        "countryRegionCode": "CA",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.4638657,
        "longitude": -73.5953236,
        "customAddr": "5524 Rue Saint-Patrick, Suite 491, Montreal, CA"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1NzA5NjIyMTg4NzcyNTMwMDQ1MTswMDsn\"",
        "no": "C10318",
        "name": "MINIAMPERE SAS DI SACCENTI STEFANIA E C",
        "eMail": "info@miniampere.it",
        "customerGroup": "PHYSANDDIG",
        "address": "Via Ampère 55",
        "postCode": "20131",
        "city": "Milano",
        "countryRegionCode": "IT",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.4833084,
        "longitude": 9.2262787,
        "customAddr": "Via Ampère 55, Milano, IT"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNjUxMTY2MDA3OTc1Nzc0OTc5MTswMDsn\"",
        "no": "C10319",
        "name": "j a k e. ",
        "eMail": "hello@thejakeshop.com",
        "customerGroup": "ONLINE",
        "address": "108 Spyglass Dr. Greenwood",
        "postCode": "29649",
        "city": "South-Carolina",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 34.2941107,
        "longitude": -82.0974705,
        "customAddr": "108 Spyglass Dr. Greenwood, South-Carolina, US"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MTUwNDk2NjkxNjc2NzE1ODE5MTswMDsn\"",
        "no": "C10320",
        "name": "Engelchen flieg",
        "eMail": "natur@engelchenflieg.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Königswinterer Str. 704",
        "postCode": "53227",
        "city": "Bonn",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.7103136,
        "longitude": 7.169081599999999,
        "customAddr": "Königswinterer Str. 704, Bonn, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1NjA3NjUwNjM2MjEzNjAzNjA0MTswMDsn\"",
        "no": "C10321",
        "name": "hello domburg v.o.f.",
        "eMail": "info@hellodomburg.nl",
        "customerGroup": "PHYSICAL",
        "address": "Weststraat 4",
        "postCode": "4357 BM",
        "city": "Domburg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.hellodomburg.nl/",
        "latitude": 51.563032,
        "longitude": 3.4959766,
        "customAddr": "Weststraat 4, Domburg, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzkwMzMwMDEwMTYxNjY0MTc1MTUxOzAwOyc=\"",
        "no": "C10322",
        "name": "hi baby! Photo X Concept Store",
        "eMail": "hi@hibaby-store.de",
        "customerGroup": "PHYSICAL",
        "address": "Lessingstraße 20",
        "postCode": "76185",
        "city": "Karlsruhe",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "http://hibaby-store.de/",
        "latitude": 49.0090055,
        "longitude": 8.385209399999999,
        "customAddr": "Lessingstraße 20, Karlsruhe, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MDk0NjU2NzIyMjYwODkzNDU5MTswMDsn\"",
        "no": "C10323",
        "name": "Re.Tale",
        "eMail": "hello@curatedbyedo.com",
        "customerGroup": "PHYSICAL",
        "address": "Dahliastraat 30",
        "postCode": "2060",
        "city": "Antwerpen",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.2270339,
        "longitude": 4.4197501,
        "customAddr": "Dahliastraat 30, Antwerpen, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzIwOTg2NTYzODcyMjAzNDU0OTIxOzAwOyc=\"",
        "no": "C10324",
        "name": "Dekids",
        "eMail": "info@dekids.cz",
        "customerGroup": "ONLINE",
        "address": "Ruska 48",
        "postCode": "10100",
        "city": "Prague",
        "countryRegionCode": "CZ",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.0723716,
        "longitude": 14.4576531,
        "customAddr": "Ruska 48, Prague, CZ"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMzg2Mzk3MDg4MTU4MTE5ODY0MTswMDsn\"",
        "no": "C10325",
        "name": "Het Faire Oosten",
        "eMail": "leveranciers@hetfaireoosten.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Waldenlaan, 208",
        "postCode": "1093 NH",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.hetfaireoosten.nl/",
        "latitude": 52.3569067,
        "longitude": 4.9304453,
        "customAddr": "Waldenlaan, 208, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzM2MTgyOTA1NzQ4MzQ4NDEwNjIxOzAwOyc=\"",
        "no": "C10326",
        "name": "Little Big Penguin",
        "eMail": "supplier@littlebigpenguin.com",
        "customerGroup": "ONLINE",
        "address": "530 Broadway",
        "postCode": "98122",
        "city": "Seattle",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 47.60683119999999,
        "longitude": -122.3205157,
        "customAddr": "530 Broadway, Seattle, US"
      },
      {
        "@odata.etag": "W/\"JzE4OzI0MzQzODM5Nzc0MTA1ODA5NjE7MDA7Jw==\"",
        "no": "C10327",
        "name": "Bisou Câlin ",
        "eMail": "coucou.bisoucalin@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Rue de Mons 14",
        "postCode": "7060",
        "city": "Soignies",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.579062,
        "longitude": 4.071107899999999,
        "customAddr": "Rue de Mons 14, Soignies, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NTUxNDg1MTcxMjA1OTk0MTM2MTswMDsn\"",
        "no": "C10328",
        "name": "BABBIS & KITS BV",
        "eMail": "info@babbisenkits.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Gildenlaan 1",
        "postCode": "2990",
        "city": "Wuustwezel",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.babbisenkits.be",
        "latitude": 51.3896722,
        "longitude": 4.5994399,
        "customAddr": "Gildenlaan 1, Wuustwezel, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NjU3MDU5NDE3NzIwMDU5NDg0MTswMDsn\"",
        "no": "C10329",
        "name": "The Bambino Club // LVSB BVBA ",
        "eMail": "hi@thebambinoclub.be",
        "customerGroup": "ONLINE",
        "address": "Mechelsesteenweg 17",
        "postCode": "2018",
        "city": "Antwerp",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.2103374,
        "longitude": 4.408095299999999,
        "customAddr": "Mechelsesteenweg 17, Antwerp, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MDkzMzUwNzg1NDc4MjIwNjU0MTswMDsn\"",
        "no": "C10330",
        "name": "mossa minimal",
        "eMail": "agata@mossaminimal.com",
        "customerGroup": "ONLINE",
        "address": "Sant marti de l'erm 5 1-3",
        "postCode": "08970",
        "city": "Sant joan despi",
        "countryRegionCode": "ES",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 41.3717271,
        "longitude": 2.0682643,
        "customAddr": "Sant marti de l'erm 5 1-3, Sant joan despi, ES"
      },
      {
        "@odata.etag": "W/\"JzE4Ozk4NTQ0MDAxOTI2NDA1Mjg0NTE7MDA7Jw==\"",
        "no": "C10331",
        "name": "Rozemarijn",
        "eMail": "info@rozemarijn.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Voorheuvel 84",
        "postCode": "3701 JH",
        "city": "Zeist",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.rozemarijn.nl/",
        "latitude": 52.08907929999999,
        "longitude": 5.2419041,
        "customAddr": "Voorheuvel 84, Zeist, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExODYzMzkwNjIxMjI1NTEzOTIyMTswMDsn\"",
        "no": "C10332",
        "name": "The Darling",
        "eMail": "nadine@thedarlingamsterdam.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Haarlemmerdijk 43",
        "postCode": "1013KB",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3820716,
        "longitude": 4.8879324,
        "customAddr": "Haarlemmerdijk 43, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzcwMjU3NzYyNDc1MDIzMjUzNzYxOzAwOyc=\"",
        "no": "C10333",
        "name": "Lievelings kids boutique ",
        "eMail": "info@lievelingskidsboutique.nl",
        "customerGroup": "PHYSICAL",
        "address": "De Dijk 4",
        "postCode": "9101MN",
        "city": "Dokkum",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.3247993,
        "longitude": 5.9983087,
        "customAddr": "De Dijk 4, Dokkum, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzY3NDE4MzE3MzcwNjA5NjE0MTIxOzAwOyc=\"",
        "no": "C10334",
        "name": "La Gamba Rossa",
        "eMail": "lagambarossa@hotmail.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Wijngaardstraat 4",
        "postCode": "8500",
        "city": "Kortrijk",
        "countryRegionCode": "BE",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://lagambarossa.be/",
        "latitude": 50.8256877,
        "longitude": 3.2688315,
        "customAddr": "Wijngaardstraat 4, Kortrijk, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzIxMzgzMTA5MTI1Mjc3OTY3MTgxOzAwOyc=\"",
        "no": "C10335",
        "name": "De Oude Stolp ",
        "eMail": "info@deoudestolp.nl",
        "customerGroup": "PHYSICAL",
        "address": "Piet Boendermakerweg 6",
        "postCode": "1862XR",
        "city": "Bergen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.6617861,
        "longitude": 4.7174051,
        "customAddr": "Piet Boendermakerweg 6, Bergen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MDUzMjYyMTcyOTAxNzMzODAzMTswMDsn\"",
        "no": "C10336",
        "name": "Souhail (little star)",
        "eMail": "souhail@bluewin.ch",
        "customerGroup": "PHYSICAL",
        "address": "Kirchgasse 24",
        "postCode": "5600",
        "city": "Lenzburg",
        "countryRegionCode": "CH",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 47.3877968,
        "longitude": 8.1798147,
        "customAddr": "Kirchgasse 24, Lenzburg, CH"
      },
      {
        "@odata.etag": "W/\"JzE5OzI0NTE4MTAwMzk1MjgwNzUzNDQxOzAwOyc=\"",
        "no": "C10337",
        "name": "TITIWU Concept Store For Kids",
        "eMail": "kontakt@titiwu.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Bei en Pferdeställen 18",
        "postCode": "72072",
        "city": "Tübingen",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://titiwu.store/",
        "latitude": 48.5123523,
        "longitude": 9.075782499999999,
        "customAddr": "Bei en Pferdeställen 18, Tübingen, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMTU4ODk3MTM3NTU0NjQ5MjgyMTswMDsn\"",
        "no": "C10338",
        "name": "young and brave Deutschland Ug",
        "eMail": "info@youngandbrave.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Maria-Theresia Straße 10",
        "postCode": "79102",
        "city": "Freiburg im Breisgau",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://youngandbrave.de/de/",
        "latitude": 47.9828815,
        "longitude": 7.8497945,
        "customAddr": "Maria-Theresia Straße 10, Freiburg im Breisgau, DE"
      },
      {
        "@odata.etag": "W/\"JzE4OzUxOTg3MzgwNzIzODg1NjAyMTE7MDA7Jw==\"",
        "no": "C10339",
        "name": "LouMa-twins",
        "eMail": "info@louma-twins.com",
        "customerGroup": "ONLINE",
        "address": "Kieselstrasse 59",
        "postCode": "45731",
        "city": "Waltrop",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.6245743,
        "longitude": 7.3924938,
        "customAddr": "Kieselstrasse 59, Waltrop, DE"
      },
      {
        "@odata.etag": "W/\"JzE4OzE2Nzg0MjUyODg1ODU4NjgxMzE7MDA7Jw==\"",
        "no": "C10340",
        "name": "TrendyBabes.co",
        "eMail": "Cassandrawach@outlook.com",
        "customerGroup": "ONLINE",
        "address": "22 Connor ave",
        "postCode": "N7G 0E8",
        "city": "Strathroy",
        "countryRegionCode": "CA",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 42.979385,
        "longitude": -81.61755819999999,
        "customAddr": "22 Connor ave, Strathroy, CA"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMzAzMjI5NDIyNDA4OTA0MDExMTswMDsn\"",
        "no": "C10342",
        "name": "Tracey Jones bv",
        "eMail": "Hello@traceyjones.be",
        "customerGroup": "PHYSICAL",
        "address": "Poststraat 91",
        "postCode": "9160",
        "city": "Lokeren",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.1049549,
        "longitude": 3.9962944,
        "customAddr": "Poststraat 91, Lokeren, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NTE3MjM4MzUzMjI5MjE0NzcwMTswMDsn\"",
        "no": "C10343",
        "name": "Berden Mode",
        "eMail": "robin.vanrenselaar@berden.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Promenade 12",
        "postCode": "6411 LA",
        "city": "Heerlen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.8877146,
        "longitude": 5.9765738,
        "customAddr": "Promenade 12, Heerlen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MjU3MTY3MzI2MjcwMDAwMjIyMTswMDsn\"",
        "no": "C10344",
        "name": "Baby & Spa Little Adventure ",
        "eMail": "babyspaenwellness@outlook.com",
        "customerGroup": "PHYSICAL",
        "address": "Schutboom 1",
        "postCode": "5427CG",
        "city": "Boekel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.6029691,
        "longitude": 5.665582199999999,
        "customAddr": "Schutboom 1, Boekel, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMTIxODY1MzM2MjA1MTAyODk3MTswMDsn\"",
        "no": "C10345",
        "name": "Baby Natural Store",
        "eMail": "info@babynaturalstore.nl",
        "customerGroup": "ONLINE",
        "address": "Schellingwouderdijk 253",
        "postCode": "1023NG",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-13",
        "homepage": "https://babynaturalstore.nl",
        "latitude": 52.3841835,
        "longitude": 4.962882899999999,
        "customAddr": "Schellingwouderdijk 253, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzY4MDQ2Nzk2NzE3MTgwNzQ2MTExOzAwOyc=\"",
        "no": "C10346",
        "name": "Petite Puce",
        "eMail": "info@petitepuce.ch",
        "customerGroup": "PHYSANDDIG",
        "address": "Spitalackerstrasse 60",
        "postCode": "3013",
        "city": "Bern",
        "countryRegionCode": "CH",
        "noOfQuotes": 2,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-12",
        "homepage": "https://www.petitepuce.ch/",
        "latitude": 46.9568759,
        "longitude": 7.4521783,
        "customAddr": "Spitalackerstrasse 60, Bern, CH"
      },
      {
        "@odata.etag": "W/\"JzE5OzUyODQ2MDk4MTg5NDAzNDQ1MDgxOzAwOyc=\"",
        "no": "C10347",
        "name": "Sheepsjop Schapenvachten VOF",
        "eMail": "info@sheepsjop.nl",
        "customerGroup": "ONLINE",
        "address": "de Noor 22",
        "postCode": "7481RP",
        "city": "Haaksbergen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.sheepsjop.nl/",
        "latitude": 52.1474913,
        "longitude": 6.8310052,
        "customAddr": "de Noor 22, Haaksbergen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzE1NjM0NzEwMzgxODU4MDI4NzkxOzAwOyc=\"",
        "no": "C10348",
        "name": "Wala Lingerie & Mode",
        "eMail": "info@walawormerveer.nl",
        "customerGroup": "PHYSICAL",
        "address": "Zaanweg 96",
        "postCode": "1521 DP",
        "city": "Wormerveer",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.4906867,
        "longitude": 4.7919431,
        "customAddr": "Zaanweg 96, Wormerveer, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzODI2MzkwNDIzMDk0MzY1Njk2MTswMDsn\"",
        "no": "C10349",
        "name": "poggi little looks",
        "eMail": "poggi@little-looks.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Jakobistr. 56",
        "postCode": "30163",
        "city": "Hannover",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3915689,
        "longitude": 9.741123,
        "customAddr": "Jakobistr. 56, Hannover, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4NDIxNTU0NjA2MDcxMTE2OTI5MTswMDsn\"",
        "no": "C10350",
        "name": "Teuntje ",
        "eMail": "info@teuntje.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Haarlemmerdijk 132",
        "postCode": "1013JJ",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://teuntje.nl/",
        "latitude": 52.3835485,
        "longitude": 4.885824299999999,
        "customAddr": "Haarlemmerdijk 132, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1MDQ2NzI3MzkxMjc4NjI3MDI5MTswMDsn\"",
        "no": "C10351",
        "name": "Tesli",
        "eMail": "tessa@tesli.nl",
        "customerGroup": "PHYSICAL",
        "address": "Beltrumsestraat 9",
        "postCode": "7141 AJ",
        "city": "Groenlo",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-06",
        "homepage": "https://tesli.nl/",
        "latitude": 52.0424951,
        "longitude": 6.6161423,
        "customAddr": "Beltrumsestraat 9, Groenlo, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNjgwNjE0ODc5MDkxODYyMzkzMTswMDsn\"",
        "no": "C10352",
        "name": "Lily fashion",
        "eMail": "info@lilyfashion.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Keizerserf 11",
        "postCode": "7442MG",
        "city": "Nijverdal",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3645715,
        "longitude": 6.459986199999999,
        "customAddr": "Keizerserf 11, Nijverdal, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzM1MDIwOTk5ODg2NDQ1MzQ4ODQxOzAwOyc=\"",
        "no": "C10353",
        "name": "de Wolster",
        "eMail": "huti@planet.nl",
        "customerGroup": "PHYSICAL",
        "address": "Kosterijstraat 12",
        "postCode": "7971 CK",
        "city": "Havelte",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.dewolster.nl/",
        "latitude": 52.7697529,
        "longitude": 6.2367406,
        "customAddr": "Kosterijstraat 12, Havelte, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MjgwNTcwNTU2OTA2MTkwNDQ2MTswMDsn\"",
        "no": "C10354",
        "name": "lyts",
        "eMail": "bo@vitaminebo.nl",
        "customerGroup": "ONLINE",
        "address": "Tsjaerddyk 32",
        "postCode": "8773KM",
        "city": "Folsgare",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.03760279999999,
        "longitude": 5.6029003,
        "customAddr": "Tsjaerddyk 32, Folsgare, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NjQzMjYyNjQ5MzcyOTE3MzAwMTswMDsn\"",
        "no": "C10355",
        "name": "Moonchild Baby Spa",
        "eMail": "sharon@moonchildbabyspa.nl",
        "customerGroup": "PHYSICAL",
        "address": "Kazernestraat",
        "postCode": "7411CJ",
        "city": "Deventer",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.2523542,
        "longitude": 6.1664334,
        "customAddr": "Kazernestraat, Deventer, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExOTUwNDEwNDU2NjAwNTkwMTU3MTswMDsn\"",
        "no": "C10356",
        "name": "SOUL COMPANY S.R.O.",
        "eMail": "kika@soulstudio.cz",
        "customerGroup": "ONLINE",
        "address": "Barrandova 1920/7",
        "postCode": "14300",
        "city": "Prague",
        "countryRegionCode": "CZ",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.0153304,
        "longitude": 14.4035357,
        "customAddr": "Barrandova 1920/7, Prague, CZ"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ4MTU3NDYyODk0OTYyNjg2OTQxOzAwOyc=\"",
        "no": "C10357",
        "name": "Warehouse for Kids",
        "eMail": "info@warehouseforkids.com",
        "customerGroup": "ONLINE",
        "address": "Thorbeckesingel 3",
        "postCode": "4142AP",
        "city": "Leerdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.89181500000001,
        "longitude": 5.085088,
        "customAddr": "Thorbeckesingel 3, Leerdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwODAwMTY5NjQ0OTE5Njc3NjU2MTswMDsn\"",
        "no": "C10358",
        "name": "Le Twins shop",
        "eMail": "letwinser@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Via XXI APRILE 1945 7/b",
        "postCode": "40134",
        "city": "Bologna",
        "countryRegionCode": "IT",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 44.4909074,
        "longitude": 11.3209398,
        "customAddr": "Via XXI APRILE 1945 7/b, Bologna, IT"
      },
      {
        "@odata.etag": "W/\"JzIwOzExODMzNzMzOTU2MTcwNTA3MDY5MTswMDsn\"",
        "no": "C10359",
        "name": "Être Mignon",
        "eMail": "etremignon.pn@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Corso Garibaldi, 39",
        "postCode": "33170",
        "city": "Pordenone",
        "countryRegionCode": "IT",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.9606614,
        "longitude": 12.6561726,
        "customAddr": "Corso Garibaldi, 39, Pordenone, IT"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg0NjM0MzQyNjQwODkzNjk4MjYxOzAwOyc=\"",
        "no": "C10360",
        "name": "Kids Enjoy",
        "eMail": "kidsenjoybavel@outlook.com",
        "customerGroup": "PHYSICAL",
        "address": "Pastoor Doensstraat 10",
        "postCode": "4854CP",
        "city": "Bavel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.56598289999999,
        "longitude": 4.831601399999999,
        "customAddr": "Pastoor Doensstraat 10, Bavel, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc2Mzg2NzgyMTM3MjY1OTI1MzcxOzAwOyc=\"",
        "no": "C10361",
        "name": "Scharrelvos",
        "eMail": "geertrui@scharrelvos.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Driekoningenstraat 61",
        "postCode": "2600",
        "city": "Berchem",
        "countryRegionCode": "BE",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-26",
        "homepage": "https://www.scharrelvos.be/",
        "latitude": 51.1966203,
        "longitude": 4.4222388,
        "customAddr": "Driekoningenstraat 61, Berchem, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzEzMTQ1NzYzNDIzNTI3MDIyNTMxOzAwOyc=\"",
        "no": "C10362",
        "name": "Nino",
        "eMail": "hello@celinethiers.be",
        "customerGroup": "ONLINE",
        "address": "Tsjammelsstraat 39",
        "postCode": "9790",
        "city": "Wortegem",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.8631891,
        "longitude": 3.4730082,
        "customAddr": "Tsjammelsstraat 39, Wortegem, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MjQzMTU5NjA2ODcxNjI2MjIzMTswMDsn\"",
        "no": "C10363",
        "name": "Comfortbodywear Wildeboer been en ondermode",
        "eMail": "Info@comfortbodywear.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Eiland 6",
        "postCode": "8011XR",
        "city": "Zwolle",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.5137101,
        "longitude": 6.096275299999999,
        "customAddr": "Eiland 6, Zwolle, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MjI0NDUwOTM1NzUxMDYxMjUxMTswMDsn\"",
        "no": "C10364",
        "name": "Vintage Atelier ",
        "eMail": "info@vintage-atelier.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Bogenstraat 1e",
        "postCode": "6017AT",
        "city": "Thorn",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.1613682,
        "longitude": 5.84192,
        "customAddr": "Bogenstraat 1e, Thorn, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk2MDk3NjI3MTkxMDI3ODc5MjYxOzAwOyc=\"",
        "no": "C10365",
        "name": "lima kids Conceptstore ",
        "eMail": "hello@limakids.de",
        "customerGroup": "PHYSICAL",
        "address": "Clarenbachplatz 1",
        "postCode": "50933",
        "city": "Köln",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.93771030000001,
        "longitude": 6.893701399999999,
        "customAddr": "Clarenbachplatz 1, Köln, DE"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc4Njk5NjYxOTUxMTg0NjkxMDAxOzAwOyc=\"",
        "no": "C10366",
        "name": "MAY ",
        "eMail": "info@mayconcept.store",
        "customerGroup": "PHYSANDDIG",
        "address": "Kattestraat 213",
        "postCode": "9150",
        "city": "Kruibeke",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.1747194,
        "longitude": 4.2968804,
        "customAddr": "Kattestraat 213, Kruibeke, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0ODg2MjY1NDk0ODkxNTIxMDc5MTswMDsn\"",
        "no": "C10367",
        "name": "Petites Jubelles",
        "eMail": "info@petites-jubelles.be",
        "customerGroup": "ONLINE",
        "address": "Stuurboord 26",
        "postCode": "8300",
        "city": "Knokke Heist",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.3292751,
        "longitude": 3.2478277,
        "customAddr": "Stuurboord 26, Knokke Heist, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNzcyNzc0MDUzNDIyNzE1ODY5MTswMDsn\"",
        "no": "C10368",
        "name": "BV Vanmarsenille - Baby Ann",
        "eMail": "babyann@vanmarsenille.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Ridderstraat 10",
        "postCode": "3800",
        "city": "Sint-Truiden",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.8157814,
        "longitude": 5.1879807,
        "customAddr": "Ridderstraat 10, Sint-Truiden, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNzMwODY2NzY2NjUzMjYxNzI4MTswMDsn\"",
        "no": "C10369",
        "name": "Flair Fashion",
        "eMail": "info@flairfashion.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Langestraat 121",
        "postCode": "7891GH",
        "city": "Klazinaveen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.7242811,
        "longitude": 6.9907724,
        "customAddr": "Langestraat 121, Klazinaveen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NjkzMjA2NjUyNTQ5NDMwNjg2MTswMDsn\"",
        "no": "C10370",
        "name": "Hairstyle Janina ",
        "eMail": "hairstylejanina@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Jan wierengaweg 36",
        "postCode": "7963 CP",
        "city": "Ruinen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.7609843,
        "longitude": 6.3609411,
        "customAddr": "Jan wierengaweg 36, Ruinen, NL"
      },
      {
        "@odata.etag": "W/\"JzE4Ozg0NDI4ODI2MjUzNjEyOTAyNzE7MDA7Jw==\"",
        "no": "C10371",
        "name": "KidKat",
        "eMail": "Info@kidkat.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Herenstraat 115",
        "postCode": "2271CD",
        "city": "Voorburg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0670702,
        "longitude": 4.3631712,
        "customAddr": "Herenstraat 115, Voorburg, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MjUzMTk2MTIxODI4NzMyOTYzMTswMDsn\"",
        "no": "C10372",
        "name": "Blossom store ",
        "eMail": "info@blossomstore.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Midstraat 60",
        "postCode": "8501AS",
        "city": "Joure",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.9677626,
        "longitude": 5.7948894,
        "customAddr": "Midstraat 60, Joure, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMjUyNDYyMjU5MjI5OTQxMDU4MTswMDsn\"",
        "no": "C10373",
        "name": "Nextdoor Kidswear",
        "eMail": "nextdoorkidsweardronten@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "De Redepassage 17",
        "postCode": "8254 KC",
        "city": "Dronten",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.52433449999999,
        "longitude": 5.7182927,
        "customAddr": "De Redepassage 17, Dronten, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk0NDczNTYzOTg5ODQwNjMyMDExOzAwOyc=\"",
        "no": "C10374",
        "name": "Lemonade ",
        "eMail": "cbylemonade@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Middenweg 46h",
        "postCode": "1097BR",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3539207,
        "longitude": 4.9299248,
        "customAddr": "Middenweg 46h, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ5NjI1OTE2NDAwMzQ4ODc1NzcxOzAwOyc=\"",
        "no": "C10376",
        "name": "Pitti Kids",
        "eMail": "pittikids@kpnplanet.nl",
        "customerGroup": "PHYSICAL",
        "address": "Gijsbrecht van Amstelstraat 162",
        "postCode": "1214BD",
        "city": "Hilversum",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://pittikids.nl/",
        "latitude": 52.2159373,
        "longitude": 5.1686941,
        "customAddr": "Gijsbrecht van Amstelstraat 162, Hilversum, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQwNDgzNjQ4ODY3NjU1MjUyNTExOzAwOyc=\"",
        "no": "C10377",
        "name": "YV-KE",
        "eMail": "yv-ke@outlook.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Dautzenbergstraat 18b",
        "postCode": "6411LB",
        "city": "Heerlen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.8888633,
        "longitude": 5.9786477,
        "customAddr": "Dautzenbergstraat 18b, Heerlen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNTY2NjQ3OTUyMjE0MTg5ODc4MTswMDsn\"",
        "no": "C10378",
        "name": "Vof cocoon ",
        "eMail": "ilonka@cocoonlifestyle.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Spuiplein 35",
        "postCode": "4511 AP",
        "city": "BRESKENS",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.3963824,
        "longitude": 3.5602279,
        "customAddr": "Spuiplein 35, BRESKENS, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzEyNDUxNzM5MzYyNTk3MTU0MzUxOzAwOyc=\"",
        "no": "C10379",
        "name": "KND GmbH",
        "eMail": "tn@kndkids.ch",
        "customerGroup": "ONLINE",
        "address": "ESPAS Wareneingang, c/o N. Nguyen Brüderhofweg 45",
        "postCode": "8057",
        "city": "Zürich",
        "countryRegionCode": "CH",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-03",
        "homepage": "https://kndkids.ch/",
        "latitude": 47.4009706,
        "longitude": 8.538068599999999,
        "customAddr": "ESPAS Wareneingang, c/o N. Nguyen Brüderhofweg 45, Zürich, CH"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2MjY2ODY2NDM4MDE1NDY0MDY2MTswMDsn\"",
        "no": "C10380",
        "name": "HYPE! Mode ",
        "eMail": "info@hypemode.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Koningshoek 92344",
        "postCode": "3144 BA",
        "city": "Maassluis",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.92813599999999,
        "longitude": 4.2390794,
        "customAddr": "Koningshoek 92344, Maassluis, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzcwMzQzNDAwNjYxNjExMzYyMTE7MDA7Jw==\"",
        "no": "C10381",
        "name": "Charlette",
        "eMail": "erikamuttert@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Duffelsesteenweg 132",
        "postCode": "2550",
        "city": "Kontich",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.1257721,
        "longitude": 4.4577674,
        "customAddr": "Duffelsesteenweg 132, Kontich, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzM5OTQ2MjEyMjk0NzU4NDg4MTUxOzAwOyc=\"",
        "no": "C10382",
        "name": "Solief",
        "eMail": "info@solief.nl",
        "customerGroup": "ONLINE",
        "address": "Boddenkampstraat 5c",
        "postCode": "7514AX",
        "city": "Enschede",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.2251251,
        "longitude": 6.8861702,
        "customAddr": "Boddenkampstraat 5c, Enschede, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzM2MTI1MTg0NzM0Njk1OTk3OTQxOzAwOyc=\"",
        "no": "C10383",
        "name": "Modehaus Fröhlich",
        "eMail": "info@maxima-hachenburg.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Wilhelmstraße 7",
        "postCode": "57627",
        "city": "Hachenburg",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.6615896,
        "longitude": 7.8226705,
        "customAddr": "Wilhelmstraße 7, Hachenburg, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MzkyMjExOTc4NzE0NjAwMjU1MTswMDsn\"",
        "no": "C10384",
        "name": "Stijl28",
        "eMail": "romy@stijl28.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Markt 14",
        "postCode": "5981 AN",
        "city": "Panningen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.stijl28.nl/",
        "latitude": 51.3287333,
        "longitude": 5.9801069,
        "customAddr": "Markt 14, Panningen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzY3NDYxMTI4MDAwMjY0MzgwMzcxOzAwOyc=\"",
        "no": "C10385",
        "name": "Zilt & Zo Lifestyle ",
        "eMail": "ziltenzo@texel.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Dorpsstraat 81",
        "postCode": "1796 CA",
        "city": "De Koog",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.0982915,
        "longitude": 4.7628007,
        "customAddr": "Dorpsstraat 81, De Koog, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ4MjQ2NTQ5NTM1OTY0OTk2MjIxOzAwOyc=\"",
        "no": "C10386",
        "name": "Moustache Kidsstore",
        "eMail": "kidsstore@ilovemoustache.nl",
        "customerGroup": "PHYSICAL",
        "address": "Dr. Erensstraat 9",
        "postCode": "6301 EC",
        "city": "Valkenburg a/d Geul",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-11",
        "homepage": "https://moustache-conceptstore.nl/stores/valkenburg-kidsstore/",
        "latitude": 50.8651731,
        "longitude": 5.8340917,
        "customAddr": "Dr. Erensstraat 9, Valkenburg a/d Geul, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMyNjY0NTI4NjE2MTM1MTM5ODUxOzAwOyc=\"",
        "no": "C10387",
        "name": "LBB&CO LTD",
        "eMail": "info@littlebaabaa.com",
        "customerGroup": "PHYSANDDIG",
        "address": "19 OAKLAND WAY",
        "postCode": "CH4 0GJ",
        "city": "CHESTER",
        "countryRegionCode": "GB",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.15621969999999,
        "longitude": -3.0388654,
        "customAddr": "19 OAKLAND WAY, CHESTER, GB"
      },
      {
        "@odata.etag": "W/\"JzE5OzE3OTc4NDU0OTUyMTk1NTk2ODIxOzAwOyc=\"",
        "no": "C10388",
        "name": "Mama Nova",
        "eMail": "info@mamanova.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Vlaardingweg 62",
        "postCode": "3044 CK",
        "city": "Rotterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://mamanova.nl/",
        "latitude": 51.9302517,
        "longitude": 4.4143218,
        "customAddr": "Vlaardingweg 62, Rotterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNzE0Nzk5MzkzODYyMjk2MjQyMTswMDsn\"",
        "no": "C10389",
        "name": "Finn Zeppelin",
        "eMail": "info@finnzeppelin.com",
        "customerGroup": "PHYSICAL",
        "address": "Willamekaai 16a",
        "postCode": "1500",
        "city": "Halle",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.7335678,
        "longitude": 4.2390062,
        "customAddr": "Willamekaai 16a, Halle, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzgzNjQ0Mjc4NDU0ODQ5OTgyNjAxOzAwOyc=\"",
        "no": "C10390",
        "name": "Slofjes.nl",
        "eMail": "info@slofjes.nl",
        "customerGroup": "ONLINE",
        "address": "Kagertuinen 57",
        "postCode": "2172XJ",
        "city": "Sassenheim",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.22367759999999,
        "longitude": 4.5334876,
        "customAddr": "Kagertuinen 57, Sassenheim, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMxMTA0NDY5NDcyNDUzNzA3OTkxOzAwOyc=\"",
        "no": "C10391",
        "name": "Anniland OÜ",
        "eMail": "marilin@anniland.ee",
        "customerGroup": "ONLINE",
        "address": "Männiku tee 10/1-2",
        "postCode": "11624",
        "city": "Tallinn",
        "countryRegionCode": "EE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 59.390852,
        "longitude": 24.7212861,
        "customAddr": "Männiku tee 10/1-2, Tallinn, EE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMDA0NDczNzcxNzA1MjQ5MjI2MTswMDsn\"",
        "no": "C10392",
        "name": "Das mooi schapenvachten ",
        "eMail": "merianw8@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Noordzijde 41",
        "postCode": "9515 PB",
        "city": "Gasselternijveenschemond",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.9915619,
        "longitude": 6.8765844,
        "customAddr": "Noordzijde 41, Gasselternijveenschemond, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4Mjg1NzA1MzU1Njk4MzQ5MTEyMTswMDsn\"",
        "no": "C10393",
        "name": "Hopac Retail B.V. ",
        "eMail": "admin@hopacretail.nl",
        "customerGroup": "ONLINE",
        "address": "Vissenstraat 28",
        "postCode": "7324AL",
        "city": "Apeldoorn",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.240423,
        "longitude": 5.983527,
        "customAddr": "Vissenstraat 28, Apeldoorn, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzIwNDc3NDkzNjE0Mzk4Nzc2MzYxOzAwOyc=\"",
        "no": "C10394",
        "name": "Shaz boutique ",
        "eMail": "shaz.boutiq@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Rua Comandante Matoso",
        "postCode": "8650 357",
        "city": "Sagres",
        "countryRegionCode": "PT",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 37.0085789,
        "longitude": -8.9370971,
        "customAddr": "Rua Comandante Matoso, Sagres, PT"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ0NTgwMTQwNjM0MzA3NTE2NTgxOzAwOyc=\"",
        "no": "C10395",
        "name": "Schatjes en Schoffies ",
        "eMail": "chantaljeedee@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Klooster Leuterstraat 5",
        "postCode": "3961AX",
        "city": "Wijk bij Duurstede",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9731616,
        "longitude": 5.3459933,
        "customAddr": "Klooster Leuterstraat 5, Wijk bij Duurstede, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg3MjA0OTcxNDcwNjE0NzU2MjkxOzAwOyc=\"",
        "no": "C10396",
        "name": "iO. Nina",
        "eMail": "ionina.depanne@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Duinkerkelaan 4",
        "postCode": "8660",
        "city": "De Panne",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.10277550000001,
        "longitude": 2.5900998,
        "customAddr": "Duinkerkelaan 4, De Panne, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3NjA4MTQ3OTY4MzEwMzE2ODU1MTswMDsn\"",
        "no": "C10397",
        "name": "Kimoe",
        "eMail": "kimoehossegor@gmail.com",
        "customerGroup": "ONLINE",
        "address": "631 avenue du touring club",
        "postCode": "40150",
        "city": "Hossegor",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 43.6599285,
        "longitude": -1.4280429,
        "customAddr": "631 avenue du touring club, Hossegor, FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMDg3MjExNjIyMDg4NzIyMjE5MTswMDsn\"",
        "no": "C10398",
        "name": "Lafem",
        "eMail": "info@lafem.eu",
        "customerGroup": "PHYSANDDIG",
        "address": "Zernikepark 12",
        "postCode": "9747 AN",
        "city": "Groningen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.244589,
        "longitude": 6.5336729,
        "customAddr": "Zernikepark 12, Groningen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1MjI5NzUxNzc2MTA0NzY0MTE5MTswMDsn\"",
        "no": "C10399",
        "name": "Poppedijn",
        "eMail": "hallo@poppedijn.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Burgwal 27",
        "postCode": "2611 GG",
        "city": "Delft",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-29",
        "homepage": "https://www.poppedijn.nl/",
        "latitude": 52.0110545,
        "longitude": 4.361195299999999,
        "customAddr": "Burgwal 27, Delft, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMTA3MTYzMDM1NzIwODQ0MjY2MTswMDsn\"",
        "no": "C10400",
        "name": "Gifts Collection",
        "eMail": "info@giftscollection.nl",
        "customerGroup": "ONLINE",
        "address": "Rosestraat 671",
        "postCode": "3071AK",
        "city": "Rotterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9075803,
        "longitude": 4.5058202,
        "customAddr": "Rosestraat 671, Rotterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQzMjM2ODA5MDc5OTU5MzAyMDExOzAwOyc=\"",
        "no": "C10401",
        "name": "Charlie & Lu",
        "eMail": "sarah@charlieundlu.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Huyssenallee 48",
        "postCode": "45128",
        "city": "Essen",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.4469424,
        "longitude": 7.0096354,
        "customAddr": "Huyssenallee 48, Essen, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0Mjc0MDczMjQ0MzQ3MDUxNTYzMTswMDsn\"",
        "no": "C10403",
        "name": "greatat8",
        "eMail": "info@greatat8.com",
        "customerGroup": "PHYSANDDIG",
        "address": "jan stasstraat 8",
        "postCode": "3000",
        "city": "Leuven",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.87954509999999,
        "longitude": 4.707005400000001,
        "customAddr": "jan stasstraat 8, Leuven, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0ODE5MDMyMjIxNDA3NDA1MTgzMTswMDsn\"",
        "no": "C10404",
        "name": "stoer design",
        "eMail": "info@stoer-design.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "kerkstraat 39",
        "postCode": "6981CL",
        "city": "Doesburg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0139211,
        "longitude": 6.1353507,
        "customAddr": "kerkstraat 39, Doesburg, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzIyMjcyMzQxMTU5MTM4NjY0NTUxOzAwOyc=\"",
        "no": "C10405",
        "name": "Bregjestyling",
        "eMail": "Marsje78@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Koraalrood 46",
        "postCode": "2718 SC",
        "city": "Zoetermeer",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0408201,
        "longitude": 4.502395900000001,
        "customAddr": "Koraalrood 46, Zoetermeer, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNDQ0NjIzODQ5MDk1MTA4Njg5MTswMDsn\"",
        "no": "C10406",
        "name": "Hip en Bio",
        "eMail": "info@hipenbio.nl",
        "customerGroup": "ONLINE",
        "address": "Minstreel 40",
        "postCode": "3161NE",
        "city": "Rhoon",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8621913,
        "longitude": 4.4134851,
        "customAddr": "Minstreel 40, Rhoon, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzI4OTgyODAwOTk1MjgzNDk5MjQxOzAwOyc=\"",
        "no": "C10407",
        "name": "Babyslofje-online.nl",
        "eMail": "info@Babyslofje-online.nl",
        "customerGroup": "ONLINE",
        "address": "Molenveld 17",
        "postCode": "1761BS",
        "city": "Anna Paulowna",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.8602502,
        "longitude": 4.8317198,
        "customAddr": "Molenveld 17, Anna Paulowna, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzkzNDAxNzQ4NTQ0MjQ0NTg2NDYxOzAwOyc=\"",
        "no": "C10408",
        "name": "The Mini Team",
        "eMail": "kk@theminiteam.com",
        "customerGroup": "ONLINE",
        "address": "Sukkervænget 63",
        "postCode": "5000",
        "city": "Odense C",
        "countryRegionCode": "DK",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 55.39381969999999,
        "longitude": 10.36957,
        "customAddr": "Sukkervænget 63, Odense C, DK"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMDQ1ODY4ODU0OTYzNjQzODM5MTswMDsn\"",
        "no": "C10409",
        "name": "LUV Spakenburg",
        "eMail": "info@luvspakenburg.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "De Ziel 21",
        "postCode": "3751BT",
        "city": "Bunschoten-Spakenburg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.2523037,
        "longitude": 5.3790931,
        "customAddr": "De Ziel 21, Bunschoten-Spakenburg, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzNDg3NDkyMjI3Njg0OTEyMTA1MTswMDsn\"",
        "no": "C10410",
        "name": "Ten Hove kindermode",
        "eMail": "info@tenhovekindermode.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Grotestraat 17",
        "postCode": "7461 KE",
        "city": "Rijssen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.308756,
        "longitude": 6.522277099999999,
        "customAddr": "Grotestraat 17, Rijssen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMDc4ODg0MjEzMzEyMTMyMDI2MTswMDsn\"",
        "no": "C10411",
        "name": "Boerenkamps",
        "eMail": "loverbosch@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Kruisstraat 6",
        "postCode": "5751BJ",
        "city": "Deurne",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.466499,
        "longitude": 5.7968081,
        "customAddr": "Kruisstraat 6, Deurne, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1NjQzNTkxMTAxODkyMDI4ODY3MTswMDsn\"",
        "no": "C10412",
        "name": "Little Canaille",
        "eMail": "hello@littlecanaille.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Rue de la Station, 107",
        "postCode": "6210",
        "city": "Reves",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.5498371,
        "longitude": 4.411983600000001,
        "customAddr": "Rue de la Station, 107, Reves, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NzEyNzEyODk5NTE3NjQ0ODkyMTswMDsn\"",
        "no": "C10413",
        "name": "Claroe sarl Carabistouille",
        "eMail": "info@carabistouille-namur.be",
        "customerGroup": "PHYSICAL",
        "address": "chaussee de louvain 463",
        "postCode": "5004",
        "city": "Bouge",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.4844951,
        "longitude": 4.8877581,
        "customAddr": "chaussee de louvain 463, Bouge, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MjQ1MjMwNzg2NDY0MTU5Njc5MTswMDsn\"",
        "no": "C10414",
        "name": "BEWEL/ LA BOTTEGA",
        "eMail": "carine@labottega.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Kiewitstraat 221 9",
        "postCode": "3500",
        "city": "Hasselt",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.labottega.be/",
        "latitude": 50.9555928,
        "longitude": 5.3676502,
        "customAddr": "Kiewitstraat 221 9, Hasselt, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMTg4NDAyMTcxMzc4NzEwODM1MTswMDsn\"",
        "no": "C10415",
        "name": "fluffymania ",
        "eMail": "hello@fluffymania.eu",
        "customerGroup": "ONLINE",
        "address": "Duifkruid",
        "postCode": "8255KJ",
        "city": "Swifterbant",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.560171,
        "longitude": 5.6416427,
        "customAddr": "Duifkruid, Swifterbant, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NzAzMjYwMTI0MjcyMzYxMjA3MTswMDsn\"",
        "no": "C10416",
        "name": "Philocaly Store",
        "eMail": "philocalystore@outlook.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Zwaanshals 408",
        "postCode": "3035 KT",
        "city": "Rotterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9326873,
        "longitude": 4.485872,
        "customAddr": "Zwaanshals 408, Rotterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzExNzExOTQ3NDgyMjcxNDMyMDUxOzAwOyc=\"",
        "no": "C10417",
        "name": "Lytse boef",
        "eMail": "info@lytseboef.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "De Dellen 16ib",
        "postCode": "9231EB",
        "city": "Surhuisterveen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.1848592,
        "longitude": 6.1737361,
        "customAddr": "De Dellen 16ib, Surhuisterveen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNDQ3NDI2MDk4OTUzMTk1MDkyMTswMDsn\"",
        "no": "C10419",
        "name": "Oergeluk.com",
        "eMail": "info@oergeluk.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Ulftseweg 37",
        "postCode": "7081AA",
        "city": "Gendringen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8772587,
        "longitude": 6.3857357,
        "customAddr": "Ulftseweg 37, Gendringen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNDI4NzQ1NzAzOTE5NjEwMjE5MTswMDsn\"",
        "no": "C10420",
        "name": "Schoenen.enzo",
        "eMail": "schoenen_enzo@live.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Bakkerspleintje 82 12",
        "postCode": "1901EZ",
        "city": "Castricum",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.schoenen-enzo.nl/",
        "latitude": 52.5466945,
        "longitude": 4.66266,
        "customAddr": "Bakkerspleintje 82 12, Castricum, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMzc3NzM5NTMxNDU4NDM3NjA2MTswMDsn\"",
        "no": "C10421",
        "name": "Atelier du Pau",
        "eMail": "info@atelierdupau.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Jacques Martensstraat 15",
        "postCode": "1944LR",
        "city": "Beverwijk",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.4938807,
        "longitude": 4.643949,
        "customAddr": "Jacques Martensstraat 15, Beverwijk, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3ODEwMDE2OTUwNTM4MDM4MjIyMTswMDsn\"",
        "no": "C10422",
        "name": "FiaNoa AS",
        "eMail": "fianoanorge@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Einerkjerrveien 1",
        "postCode": "4827",
        "city": "Froland",
        "countryRegionCode": "NO",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 58.50227770000001,
        "longitude": 8.588359400000002,
        "customAddr": "Einerkjerrveien 1, Froland, NO"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNzc4MzI3MTgzOTgwODIxMjc0MTswMDsn\"",
        "no": "C10423",
        "name": "Dandelion",
        "eMail": "hello@inthewoods.earth",
        "customerGroup": "PHYSICAL",
        "address": "Hoeklaan 9",
        "postCode": "2970",
        "city": "Schilde",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.inthewoods.earth/",
        "latitude": 51.2882214,
        "longitude": 4.6204632,
        "customAddr": "Hoeklaan 9, Schilde, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMDQzMzc2ODE1MDQzNTgxODI0MTswMDsn\"",
        "no": "C10424",
        "name": "Pipp&i",
        "eMail": "info@pipp-i.nl",
        "customerGroup": "ONLINE",
        "address": "Munthof 45",
        "postCode": "5551 XG",
        "city": "Valkenswaard",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.3569448,
        "longitude": 5.4251741,
        "customAddr": "Munthof 45, Valkenswaard, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMwMzAwNTUxOTUyNzY5MDMwMjIxOzAwOyc=\"",
        "no": "C10426",
        "name": "Petite Astrid VOF",
        "eMail": "petiteastrid@hotmail.com",
        "customerGroup": "ONLINE",
        "address": "Bettestraat 4",
        "postCode": "8580",
        "city": "Avelgem",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.7842315,
        "longitude": 3.4342459,
        "customAddr": "Bettestraat 4, Avelgem, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzY4ODYzNTIwOTQwMDgzNzk1MDgxOzAwOyc=\"",
        "no": "C10428",
        "name": "Mini Luel Kids ",
        "eMail": "info@miniluelkids.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Ricarda-Huch Str. 6",
        "postCode": "79114",
        "city": "Freiburg ",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 48.0053664,
        "longitude": 7.8119426,
        "customAddr": "Ricarda-Huch Str. 6, Freiburg , DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzEwNzAwMTk2NjU0MjcxMTg4NzIxOzAwOyc=\"",
        "no": "C10429",
        "name": "Pupulino ",
        "eMail": "Pupulino@outlook.de",
        "customerGroup": "ONLINE",
        "address": "Hauptstraße 5",
        "postCode": "83533",
        "city": "Edling",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 48.0568049,
        "longitude": 12.1669748,
        "customAddr": "Hauptstraße 5, Edling, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0OTIzODIxMDk2NDM5ODMxNzI0MTswMDsn\"",
        "no": "C10430",
        "name": "Pippa",
        "eMail": "catodens@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Turnhoutsebaan 260 ",
        "postCode": "2970",
        "city": "Schilde",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-13",
        "homepage": "https://pippakinderschoenen.be/",
        "latitude": 51.2396356,
        "longitude": 4.5810463,
        "customAddr": "Turnhoutsebaan 260 , Schilde, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1Njc2NDYwNzEzNzI0NDEwODM1MTswMDsn\"",
        "no": "C10431",
        "name": "Simply for Babies",
        "eMail": "info@simplyforlenie.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Hof van Holland 64",
        "postCode": "3332EH",
        "city": "Zwijndrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8230465,
        "longitude": 4.6514688,
        "customAddr": "Hof van Holland 64, Zwijndrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg4MDcwMjQ5NjAzOTY5NTUzODgxOzAwOyc=\"",
        "no": "C10432",
        "name": "XTRA-SOCIAL.",
        "eMail": "marieke.store@xtra-social.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Markt 50b",
        "postCode": "5541 EA",
        "city": "Reusel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://xtra-social.com/",
        "latitude": 51.3617171,
        "longitude": 5.1619046,
        "customAddr": "Markt 50b, Reusel, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzI4NzA1NTM3NTE4ODMwNTAyNTMxOzAwOyc=\"",
        "no": "C10433",
        "name": "Haags Borstvoedingscentrum Vita Nova",
        "eMail": "hbc.vitanova@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Prins Hendrikstraat 145",
        "postCode": "2518HN",
        "city": "Den Haag",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://haagsborstvoedingscentrumvitanova.nl/",
        "latitude": 52.08094850000001,
        "longitude": 4.2908126,
        "customAddr": "Prins Hendrikstraat 145, Den Haag, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1MDI4Njk4ODU1MDQ1MjkzNzIwMTswMDsn\"",
        "no": "C10435",
        "name": "Baby Natura",
        "eMail": "bestellingen@babynatura.nl",
        "customerGroup": "ONLINE",
        "address": "Greveling 23",
        "postCode": "9654 PM",
        "city": "Annerveenschekanaal",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.0829604,
        "longitude": 6.793990099999999,
        "customAddr": "Greveling 23, Annerveenschekanaal, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzkxMDU4Nzg0Nzc1NDAxNDc4MTkxOzAwOyc=\"",
        "no": "C10436",
        "name": "TSUM Kyiv",
        "eMail": "olha.nikitkina@tsum.com.ua",
        "customerGroup": "PHYSANDDIG",
        "address": "19-21 Bohdana Khmelnytskoho Str",
        "postCode": "01030",
        "city": "KYIV",
        "countryRegionCode": "UA",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.4457993,
        "longitude": 30.5121553,
        "customAddr": "19-21 Bohdana Khmelnytskoho Str, KYIV, UA"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ3NDczNTE0ODkxMDQwMzcwNTAxOzAwOyc=\"",
        "no": "C10437",
        "name": "Nøtteliten",
        "eMail": "post@nottelitenstore.no",
        "customerGroup": "PHYSANDDIG",
        "address": "Storgata 57",
        "postCode": "9008",
        "city": "Tromsø",
        "countryRegionCode": "NO",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 69.6481988,
        "longitude": 18.9548348,
        "customAddr": "Storgata 57, Tromsø, NO"
      },
      {
        "@odata.etag": "W/\"JzE5OzY2MzQ4MTM4MTA4MjQ1MjQxMTgxOzAwOyc=\"",
        "no": "C10438",
        "name": "TNT - THE NEW TREND",
        "eMail": "britt@tntthenewtrend.com",
        "customerGroup": "PHYSANDDIG",
        "address": "1020 Lawrence Ave West Unit 202",
        "postCode": "M6A 1C8",
        "city": "Toronto",
        "countryRegionCode": "CA",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 43.7128732,
        "longitude": -79.4620511,
        "customAddr": "1020 Lawrence Ave West Unit 202, Toronto, CA"
      },
      {
        "@odata.etag": "W/\"JzE5OzU4MDM3NzAzMzg1NzkwNTk1MjcxOzAwOyc=\"",
        "no": "C10439",
        "name": "CLUCK store",
        "eMail": "hello@cluckstore.com.au",
        "customerGroup": "PHYSANDDIG",
        "address": "127 Macquarie Street",
        "postCode": "7000",
        "city": "Hobart",
        "countryRegionCode": "AU",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": -42.8840451,
        "longitude": 147.3282738,
        "customAddr": "127 Macquarie Street, Hobart, AU"
      },
      {
        "@odata.etag": "W/\"JzE5OzcwMDM1OTQ4NzEzMjY4MzE4MDQxOzAwOyc=\"",
        "no": "C10440",
        "name": "Boutique Billie le kid",
        "eMail": "boutiquebillielekid@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "1001 Laurier ouest",
        "postCode": "H2V 2L1",
        "city": "Outremont",
        "countryRegionCode": "CA",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.5188069,
        "longitude": -73.5970914,
        "customAddr": "1001 Laurier ouest, Outremont, CA"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3OTM5NjExMTE5NjkxMzY5ODM5MTswMDsn\"",
        "no": "C10441",
        "name": "Kids concept store Zoet",
        "eMail": "hello@kidsconceptstorezoet.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Laat 118",
        "postCode": "1811EL",
        "city": "Alkmaar",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://kidsconceptstorezoet.nl/",
        "latitude": 52.6302196,
        "longitude": 4.748107399999999,
        "customAddr": "Laat 118, Alkmaar, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MjY1MjkwNzA0Njg5NTMxMzk1MTswMDsn\"",
        "no": "C10442",
        "name": "Enli Bahar",
        "eMail": "baharenli@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Via costa 2",
        "postCode": "37030",
        "city": "Roncà",
        "countryRegionCode": "IT",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.47062570000001,
        "longitude": 11.2875773,
        "customAddr": "Via costa 2, Roncà, IT"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NDc5NDAwODE1MTM3ODE5NzA4MTswMDsn\"",
        "no": "C10443",
        "name": "The Organic Kid",
        "eMail": "info@theorganickidMT.com",
        "customerGroup": "ONLINE",
        "address": "Flat 2, Emmar Court, Triq San Guzepp",
        "postCode": "MST 1262",
        "city": "Mosta",
        "countryRegionCode": "MT",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 35.9093247,
        "longitude": 14.4207862,
        "customAddr": "Flat 2, Emmar Court, Triq San Guzepp, Mosta, MT"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc4ODUzNjQzNzQzMTU1MjY5NzAxOzAwOyc=\"",
        "no": "C10444",
        "name": "Woodzy",
        "eMail": "woodzyconcept@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Wegscheid 1",
        "postCode": "77652",
        "city": "Offenburg",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 48.5103499,
        "longitude": 7.9544791,
        "customAddr": "Wegscheid 1, Offenburg, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNDgxMjEyNzc4MTcwNzc2NDYxMTswMDsn\"",
        "no": "C10445",
        "name": "Luksusbaby A/S",
        "eMail": "julie@luksusbaby.dk",
        "customerGroup": "ONLINE",
        "address": "Porsborgparken 15",
        "postCode": "9530",
        "city": "Støvring-Nordjylland",
        "countryRegionCode": "DK",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-05-22",
        "homepage": "https://luksusbaby.dk/",
        "latitude": 56.89225560000001,
        "longitude": 9.8154557,
        "customAddr": "Porsborgparken 15, Støvring-Nordjylland, DK"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3NDAzMzQzMzE4ODA5NDI0NzE1MTswMDsn\"",
        "no": "C10446",
        "name": "3 Little Stories",
        "eMail": "hello@3littlestories.be",
        "customerGroup": "ONLINE",
        "address": "Prinses Marie-Joséstraat 10b",
        "postCode": "9100",
        "city": "Sint-Niklaas",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "http://3littlestories.be ",
        "latitude": 51.1703211,
        "longitude": 4.1526659,
        "customAddr": "Prinses Marie-Joséstraat 10b, Sint-Niklaas, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzI1NDIwMzYwNTkyOTMxMDUwNTMxOzAwOyc=\"",
        "no": "C10447",
        "name": "Toost Hillegom",
        "eMail": "toosthillegom@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Hofstraat 2-001",
        "postCode": "2181AX",
        "city": "Hillegom",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.2923367,
        "longitude": 4.5787931,
        "customAddr": "Hofstraat 2-001, Hillegom, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1NzgyMDk3NTY4MjMzNTI2MDg4MTswMDsn\"",
        "no": "C10448",
        "name": "Kleine straat",
        "eMail": "info@kleinestraat.nl",
        "customerGroup": "PHYSICAL",
        "address": "Kerkstraat 6",
        "postCode": "5527 EG",
        "city": "Hapert",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://kleinestraat.nl/",
        "latitude": 51.3708099,
        "longitude": 5.2512718,
        "customAddr": "Kerkstraat 6, Hapert, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMzc2OTM5ODA1OTY4NTk0MjcyMTswMDsn\"",
        "no": "C10449",
        "name": "Little Legends BV",
        "eMail": "hello@littlelegends.nl",
        "customerGroup": "ONLINE",
        "address": "Jac. P Thijsseweg 13",
        "postCode": "2408ER",
        "city": "Alphen aan den Rijn",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-15",
        "homepage": "https://www.littlelegends.nl/",
        "latitude": 52.12845340000001,
        "longitude": 4.6353927,
        "customAddr": "Jac. P Thijsseweg 13, Alphen aan den Rijn, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NzA0NDQ3NTc3MDY5MjY4MjQ1MTswMDsn\"",
        "no": "C10450",
        "name": "Herbs & Lemon",
        "eMail": "katharina_schneiders@gmx.de",
        "customerGroup": "ONLINE",
        "address": "Wiesenstraße 10",
        "postCode": "46499",
        "city": "Hamminkeln",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://herbsandlemon.de/",
        "latitude": 51.7924646,
        "longitude": 6.526362499999999,
        "customAddr": "Wiesenstraße 10, Hamminkeln, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzUzODQ2OTc3NzYzMDUzMjYxNjMxOzAwOyc=\"",
        "no": "C10451",
        "name": "Leukspul",
        "eMail": "info@leukspul.online",
        "customerGroup": "PHYSICAL",
        "address": "Hondegatstraat 9",
        "postCode": "3841 CG",
        "city": "Harderwijk",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.leukspul.online/",
        "latitude": 52.3505915,
        "longitude": 5.6185417,
        "customAddr": "Hondegatstraat 9, Harderwijk, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc3MTU0MjUwOTExNDI1OTk1ODcxOzAwOyc=\"",
        "no": "C10452",
        "name": "Eigen Stijl",
        "eMail": "info@eigenstijlarnhem.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Steenstraat 75",
        "postCode": "6828CE",
        "city": "Arnhem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.98425959999999,
        "longitude": 5.918285500000001,
        "customAddr": "Steenstraat 75, Arnhem, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzEyOTc5MTE0OTE4MzMzNjM5NTIxOzAwOyc=\"",
        "no": "C10453",
        "name": "Atelier Abricot ",
        "eMail": "ann-sophie.van.coppenolle@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Wijnstraat 49",
        "postCode": "9600",
        "city": "Ronse",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.atelierabricot.be/",
        "latitude": 50.748828,
        "longitude": 3.5981061,
        "customAddr": "Wijnstraat 49, Ronse, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzY3MTY3Njc1MjI3NjcwMjY5MDkxOzAwOyc=\"",
        "no": "C10454",
        "name": "MUVOGA VOF",
        "eMail": "kirsten@muvoga.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Hoogstraat 150a",
        "postCode": "5258BG",
        "city": "Berlicum",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.6787371,
        "longitude": 5.3980052,
        "customAddr": "Hoogstraat 150a, Berlicum, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgxNjQ5MjQxOTU4NjIxNzcwOTkxOzAwOyc=\"",
        "no": "C10455",
        "name": "haystay conceptstore ",
        "eMail": "info@haystay.nl",
        "customerGroup": "PHYSICAL",
        "address": "Hooisteeg 12",
        "postCode": "5141 KH",
        "city": "Waalwijk",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.6914836,
        "longitude": 5.0672562,
        "customAddr": "Hooisteeg 12, Waalwijk, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3NDMyNTE2MzE2MzcwNjA5Mjc4MTswMDsn\"",
        "no": "C10456",
        "name": "Luca Elle Boutique Ltd.",
        "eMail": "hello@lucaelle.com",
        "customerGroup": "ONLINE",
        "address": "1158 Sunview Place",
        "postCode": "V1Z 3R1",
        "city": "West Kelowna",
        "countryRegionCode": "CA",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 49.8753732,
        "longitude": -119.562995,
        "customAddr": "1158 Sunview Place, West Kelowna, CA"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNzQyNTU4NDYwMzc4MTM1MzQwMTswMDsn\"",
        "no": "C10457",
        "name": "Kraamzorg Esra spa",
        "eMail": "info@kraamzorgesra.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Sint Jorisweg 60",
        "postCode": "3311PL",
        "city": "Dordrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8138669,
        "longitude": 4.675650399999999,
        "customAddr": "Sint Jorisweg 60, Dordrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMDcxODQ2NjgzNzI1NjcxMjk4MTswMDsn\"",
        "no": "C10458",
        "name": "Bende van Geluk",
        "eMail": "info@bendevangeluk.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Dorpsstraat 24",
        "postCode": "6661 EK",
        "city": "Elst",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-09-03",
        "homepage": "https://www.bendevangeluk.nl/",
        "latitude": 51.91942719999999,
        "longitude": 5.8480206,
        "customAddr": "Dorpsstraat 24, Elst, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMDAwMjIzNDE3MTAzNjU5NzQ3MTswMDsn\"",
        "no": "C10459",
        "name": "La Dune",
        "eMail": "schouwdana01@live.nl",
        "customerGroup": "PHYSICAL",
        "address": "Duinweg 2a",
        "postCode": "4356AS",
        "city": "Oostkapelle",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.56768410000001,
        "longitude": 3.5549164,
        "customAddr": "Duinweg 2a, Oostkapelle, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzYzNDgzOTg0MDgyOTI4NTg5MDQxOzAwOyc=\"",
        "no": "C10460",
        "name": "Elle et Tati BV",
        "eMail": "debruynewendy@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Konijntje 1",
        "postCode": "9910",
        "city": "Ursel",
        "countryRegionCode": "BE",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-29",
        "homepage": "https://www.aapnootmies.be/nl/",
        "latitude": 51.1308845,
        "longitude": 3.50206,
        "customAddr": "Konijntje 1, Ursel, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1Nzk2NDMwNTk4MTIzOTM0MjU3MTswMDsn\"",
        "no": "C10461",
        "name": "titibella",
        "eMail": "qing70420@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "75 borg crescent",
        "postCode": "3179",
        "city": "Scoresby",
        "countryRegionCode": "AU",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": -37.8954303,
        "longitude": 145.2208069,
        "customAddr": "75 borg crescent, Scoresby, AU"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2ODQzMjIxMzY4MzExNzM5NDEwMTswMDsn\"",
        "no": "C10462",
        "name": "Mausekind Concept Store ",
        "eMail": "info.mausekind@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Kantstrasse 48",
        "postCode": "68723",
        "city": "Plankstadt ",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 49.4014939,
        "longitude": 8.5832353,
        "customAddr": "Kantstrasse 48, Plankstadt , DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MDY4NzQ5MTczNTQ0MjExNjI0MTswMDsn\"",
        "no": "C10463",
        "name": "YUZHEN XUE",
        "eMail": "j3nnyxue@yahoo.com",
        "customerGroup": "ONLINE",
        "address": "95 coburg crescent",
        "postCode": "L4B 4E4",
        "city": "RICHMOND HILL",
        "countryRegionCode": "CA",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 43.849565,
        "longitude": -79.4297744,
        "customAddr": "95 coburg crescent, RICHMOND HILL, CA"
      },
      {
        "@odata.etag": "W/\"JzE5OzU3MjUyMzU5ODM4OTk1OTU2MDcxOzAwOyc=\"",
        "no": "C10464",
        "name": "Oetdoor bv",
        "eMail": "info@oetdoor.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Hogebrugweg 6",
        "postCode": "7273 PB",
        "city": "Haarlo",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-20",
        "homepage": "https://oetdoor.nl/",
        "latitude": 52.11338569999999,
        "longitude": 6.5461225,
        "customAddr": "Hogebrugweg 6, Haarlo, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgyODAyNDU1MjQ2NTIzMjg0ODIxOzAwOyc=\"",
        "no": "C10465",
        "name": "EWWK GmbH Libertykids.de",
        "eMail": "info@liberty-kids.de",
        "customerGroup": "ONLINE",
        "address": "Bonlanden 28",
        "postCode": "72072",
        "city": "Tübingen",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-16",
        "homepage": "",
        "latitude": 48.4861964,
        "longitude": 8.9984752,
        "customAddr": "Bonlanden 28, Tübingen, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzY4MjM2OTg0MTU3OTY5Mzg1NjcxOzAwOyc=\"",
        "no": "C10466",
        "name": "Ivy Babies",
        "eMail": "jazi@ivybabies.com",
        "customerGroup": "ONLINE",
        "address": "Group A Tower, Floor 2 Block 5, Emam Alhasan Bin Ali St",
        "postCode": "15300",
        "city": "Sharq",
        "countryRegionCode": "KW",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 29.3805187,
        "longitude": 47.9831014,
        "customAddr": "Group A Tower, Floor 2 Block 5, Emam Alhasan Bin Ali St, Sharq, KW"
      },
      {
        "@odata.etag": "W/\"JzE5OzUyMzgzNDI0NTY5NzI2ODUxNjExOzAwOyc=\"",
        "no": "C10467",
        "name": "aempf GmbH",
        "eMail": "nina@aempf.de",
        "customerGroup": "ONLINE",
        "address": "Kastanienstrase 10",
        "postCode": "44534",
        "city": "Lünen",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.62724859999999,
        "longitude": 7.514840800000001,
        "customAddr": "Kastanienstrase 10, Lünen, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNTg5NTY5MjY4NjY0MDk4NTM3MTswMDsn\"",
        "no": "C10468",
        "name": "Sweet Petite Jolie",
        "eMail": "info@sweetpetitejolie.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kromme Steenweg 35 ",
        "postCode": "5707CB",
        "city": "Helmond",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-09-04",
        "homepage": "https://www.sweetpetitejolie.nl/",
        "latitude": 51.47916799999999,
        "longitude": 5.649463,
        "customAddr": "Kromme Steenweg 35 , Helmond, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2MzE4OTIxNTk4MzA5OTU5MzE5MTswMDsn\"",
        "no": "C10469",
        "name": "CozyKidz ",
        "eMail": "info@cozykidz.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Parade 24",
        "postCode": "5911 CC",
        "city": "Venlo",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.Cozykidz.nl",
        "latitude": 51.3694259,
        "longitude": 6.1707259,
        "customAddr": "Parade 24, Venlo, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMjQ1NzE4MjcyODIwMjUwNzg3MTswMDsn\"",
        "no": "C10470",
        "name": "Kleine Reus",
        "eMail": "info@kleinereus.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Dr. Kuyperkade 19-ZW",
        "postCode": "3142GC",
        "city": "Maassluis",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-03",
        "homepage": "https://www.kleinereus.nl/",
        "latitude": 51.9223368,
        "longitude": 4.255652899999999,
        "customAddr": "Dr. Kuyperkade 19-ZW, Maassluis, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMTU3MjE5ODI1NTY0NTAwNzQzMTswMDsn\"",
        "no": "C10471",
        "name": "Babypark",
        "eMail": "inkoop@babypark.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Hogeveldseweg 2",
        "postCode": "4041 CP",
        "city": "Kesteren",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-09-03",
        "homepage": "https://www.babypark.nl/",
        "latitude": 51.9335002,
        "longitude": 5.591990099999999,
        "customAddr": "Hogeveldseweg 2, Kesteren, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzM4MzIwNjUzOTIzNDg3MzMxNDgxOzAwOyc=\"",
        "no": "C10472",
        "name": "H² baby boutique",
        "eMail": "info@h2babyboutique.com",
        "customerGroup": "PHYSANDDIG",
        "address": "rue Fond du Village 5B",
        "postCode": "1315",
        "city": "Incourt",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://h2babyboutique.com/",
        "latitude": 50.73072620000001,
        "longitude": 4.7736411,
        "customAddr": "rue Fond du Village 5B, Incourt, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2MTgwMjk4NjE1NjgzMTU5MzU3MTswMDsn\"",
        "no": "C10474",
        "name": "Meiden van de wit Kids & Conceptstore ",
        "eMail": "info@meidenvandewit.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Westerstraat 60",
        "postCode": "1601 AL",
        "city": "Enkhuizen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-29",
        "homepage": "https://www.meidenvandewit.nl/",
        "latitude": 52.7043262,
        "longitude": 5.2914638,
        "customAddr": "Westerstraat 60, Enkhuizen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNDU0OTgyMDYzMzg2NTk1ODIxMTswMDsn\"",
        "no": "C10475",
        "name": "Mueno",
        "eMail": "kfsimoncini@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Gonzalo Ramirez 1329 apt. 2208",
        "postCode": "11100",
        "city": "Montevideo",
        "countryRegionCode": "UY",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": -34.9119057,
        "longitude": -56.1869197,
        "customAddr": "Gonzalo Ramirez 1329 apt. 2208, Montevideo, UY"
      },
      {
        "@odata.etag": "W/\"JzE5OzIyMTgyODU3ODI3MTc4OTEwODgxOzAwOyc=\"",
        "no": "C10476",
        "name": "Smallable 42 rue du Faubourg St Antoine Paris, 75012 Frankrijk",
        "eMail": "a.cadenet@smallable.com",
        "customerGroup": "PHYSANDDIG",
        "address": "42 rue du Faubourg",
        "postCode": "75012",
        "city": "St Antoine",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-05",
        "homepage": "https://www.smallable.com/",
        "latitude": 48.8522138,
        "longitude": 2.372278,
        "customAddr": "42 rue du Faubourg, St Antoine, FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MTk4ODQ2NjUyNjAyMzQ5MTkyMTswMDsn\"",
        "no": "C10477",
        "name": "Koetie ",
        "eMail": "jzebregs@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Heuvelstraat 115",
        "postCode": "5038 AD",
        "city": "TILBURG",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.koetiestore.com/",
        "latitude": 51.55525009999999,
        "longitude": 5.083894,
        "customAddr": "Heuvelstraat 115, TILBURG, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MDU2ODYwMTI0NDc5NzQ1NzM4MTswMDsn\"",
        "no": "C10478",
        "name": "Omoda B.V.",
        "eMail": "mascha.vanorsouw@omoda.nl",
        "customerGroup": "ONLINE",
        "address": "Ruigendijkweg 1",
        "postCode": "4301 RX",
        "city": "Zierikzee",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-14",
        "homepage": "https://www.omoda.nl/",
        "latitude": 51.64093099999999,
        "longitude": 3.937163,
        "customAddr": "Ruigendijkweg 1, Zierikzee, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NjQ2MTMxMTI5MDIzOTQxMzkyMTswMDsn\"",
        "no": "C10479",
        "name": "Lancelot 4kids",
        "eMail": "info@lancelot4kids.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Breelaan 2C",
        "postCode": "1861GE",
        "city": "Bergen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-29",
        "homepage": "https://www.lancelot4kids.nl/",
        "latitude": 52.6694702,
        "longitude": 4.7009468,
        "customAddr": "Breelaan 2C, Bergen, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzI5NzAzOTM0MjMzNDA2MTc1OTE7MDA7Jw==\"",
        "no": "C10480",
        "name": "Mon Cheri Bebe ",
        "eMail": "moncheribebeny@gmail.com",
        "customerGroup": "ONLINE",
        "address": "12 Lizensk Blvd #411",
        "postCode": "10950",
        "city": "Monroe",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 41.3449647,
        "longitude": -74.1700211,
        "customAddr": "12 Lizensk Blvd #411, Monroe, US"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk2MDUwNjcxMzc1OTQyNTY1NTExOzAwOyc=\"",
        "no": "C10481",
        "name": "Voetjes & Sproetjes ",
        "eMail": "laurienraeymaekers@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Hovestraat 35",
        "postCode": "2370",
        "city": "Arendonk",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.3197947,
        "longitude": 5.09044,
        "customAddr": "Hovestraat 35, Arendonk, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2ODM1NTY0OTM3NTczMzQxNDI2MTswMDsn\"",
        "no": "C10482",
        "name": "Hazy ",
        "eMail": "info@hazy-conceptstore.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kerkstraat 54D",
        "postCode": "1271RM",
        "city": "Huizen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://hazy-conceptstore.nl/",
        "latitude": 52.298054,
        "longitude": 5.2360495,
        "customAddr": "Kerkstraat 54D, Huizen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMTYwNjQ5OTY0NjI3NjAxMjQ5MTswMDsn\"",
        "no": "C10483",
        "name": "Tally-ho",
        "eMail": "barbara@tally-ho.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Oude Bergerweg 9c",
        "postCode": "1862KH",
        "city": "Bergen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-27",
        "homepage": "https://www.tally-ho.nl/",
        "latitude": 52.6650354,
        "longitude": 4.7107905,
        "customAddr": "Oude Bergerweg 9c, Bergen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzYxMzgzOTg1NTU3ODAxNzEwNDUxOzAwOyc=\"",
        "no": "C10484",
        "name": "21'BOUTIQUE",
        "eMail": "marcia@21boutique.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Nieuwe Noord 21",
        "postCode": "1621 EM",
        "city": "Hoorn",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.6410891,
        "longitude": 5.0572571,
        "customAddr": "Nieuwe Noord 21, Hoorn, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg1NDg2MDI5MDQ3OTI1MDk2ODYxOzAwOyc=\"",
        "no": "C10485",
        "name": "animo kids",
        "eMail": "hello@animokidsau.com",
        "customerGroup": "ONLINE",
        "address": "5 Comptone Parade",
        "postCode": "3020",
        "city": "Sunshine North",
        "countryRegionCode": "AU",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": -37.77092,
        "longitude": 144.8315743,
        "customAddr": "5 Comptone Parade, Sunshine North, AU"
      },
      {
        "@odata.etag": "W/\"JzE5OzU0OTMwMDg2Mjc5NTE1NDI5NDAxOzAwOyc=\"",
        "no": "C10486",
        "name": "Dorien de Herdt Concept & Design",
        "eMail": "info@felizshoes.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "de Fluit 40",
        "postCode": "1398CA",
        "city": "Muiden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.felizshoes.nl/",
        "latitude": 52.3306705,
        "longitude": 5.0619184,
        "customAddr": "de Fluit 40, Muiden, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzE4MTMwODkxNDU4OTA5MDI2MDE7MDA7Jw==\"",
        "no": "C10487",
        "name": "Liebo",
        "eMail": "info@liebo.nl",
        "customerGroup": "ONLINE",
        "address": "Korenbloemstraat 1",
        "postCode": "5409AX",
        "city": "Odiliapeel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.6450948,
        "longitude": 5.7090111,
        "customAddr": "Korenbloemstraat 1, Odiliapeel, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NjYwMzE5NzMxODk4NDk3ODUyMTswMDsn\"",
        "no": "C10488",
        "name": "Wauw Warenhuis",
        "eMail": "info@wauwwarenhuis.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Frederik Hendriklaan 141",
        "postCode": "2582BZ",
        "city": "Den Haag",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.09199650000001,
        "longitude": 4.2750379,
        "customAddr": "Frederik Hendriklaan 141, Den Haag, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzIxMzY5MjUyMDQ0NTAyNTE4NDUxOzAwOyc=\"",
        "no": "C10489",
        "name": "Mini Parade",
        "eMail": "miniparade19@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Gedempte Gracht 19",
        "postCode": "1741 GA",
        "city": "Schagen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-15",
        "homepage": "https://www.miniparade.nl/",
        "latitude": 52.7869052,
        "longitude": 4.7979843,
        "customAddr": "Gedempte Gracht 19, Schagen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzYxODQyMzYyODU3MDk3OTE2NjYxOzAwOyc=\"",
        "no": "C10490",
        "name": "Lab of Style",
        "eMail": "facturatie@labofstyle.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kerkplein 3",
        "postCode": "3972 EK",
        "city": "Driebergen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://labofstyle.nl/",
        "latitude": 52.0555321,
        "longitude": 5.2761692,
        "customAddr": "Kerkplein 3, Driebergen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ3NDE5NzU1NzE0NDg1NjIzMDcxOzAwOyc=\"",
        "no": "C10491",
        "name": "Meis&Jip",
        "eMail": "info@meisenjip.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Fortuinstraat 3b",
        "postCode": "7772BM",
        "city": "Hardenberg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.meisenjip.nl/",
        "latitude": 52.5751955,
        "longitude": 6.618719,
        "customAddr": "Fortuinstraat 3b, Hardenberg, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg2MDY0MjcyMTE2MDMyODQzODUxOzAwOyc=\"",
        "no": "C10492",
        "name": "Charlotte and the kids ",
        "eMail": "charlotte@andthekids.de",
        "customerGroup": "ONLINE",
        "address": "Katzwanger Hauptstraße 3b",
        "postCode": "90453",
        "city": "Nürnberg",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.andthekids.de/",
        "latitude": 49.35313379999999,
        "longitude": 11.0553249,
        "customAddr": "Katzwanger Hauptstraße 3b, Nürnberg, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzIzNDgxNTYyNDUwOTgzNjMwMjIxOzAwOyc=\"",
        "no": "C10493",
        "name": "Creative Minds Revive Bv",
        "eMail": "office@mujajuma.com",
        "customerGroup": "ONLINE",
        "address": "Phoenixstraat 60 B",
        "postCode": "2611 AM",
        "city": "Delft",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0125576,
        "longitude": 4.3530944,
        "customAddr": "Phoenixstraat 60 B, Delft, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMyNTEwMDE4NzEzMjE4Mjk5OTYxOzAwOyc=\"",
        "no": "C10494",
        "name": "Lieneloe",
        "eMail": "info@lieneloe.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kruisstraat 25",
        "postCode": "2011 PW",
        "city": "Haarlem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://lieneloe.nl/",
        "latitude": 52.3839419,
        "longitude": 4.6360414,
        "customAddr": "Kruisstraat 25, Haarlem, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgxODQwNjMyNTAwNTA5ODk3MjcxOzAwOyc=\"",
        "no": "C10495",
        "name": "Pas de dragon dans la maison !",
        "eMail": "margaux.lumale@gmail.com",
        "customerGroup": "ONLINE",
        "address": "11 rue de Wagram App. 19",
        "postCode": "94470",
        "city": "Boissy-Saint-Léger",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 48.7489537,
        "longitude": 2.5107324,
        "customAddr": "11 rue de Wagram App. 19, Boissy-Saint-Léger, FR"
      },
      {
        "@odata.etag": "W/\"JzE5OzY0Mjk4Mzk1Mzk5NzA2NzkzMDIxOzAwOyc=\"",
        "no": "C10496",
        "name": "Room42/ Room for kids",
        "eMail": "room.haarlem@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Grote Houtstraat 94",
        "postCode": "2011SR",
        "city": "Haarlem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-14",
        "homepage": "https://www.room-42.nl/",
        "latitude": 52.3787411,
        "longitude": 4.632612,
        "customAddr": "Grote Houtstraat 94, Haarlem, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc4MDM0MTg0ODgzNjg1Nzg0OTExOzAwOyc=\"",
        "no": "C10497",
        "name": "Bambini & Mamma ",
        "eMail": "susanne.weingaertner@me.com",
        "customerGroup": "PHYSICAL",
        "address": "Burgstrasse 5",
        "postCode": "26122",
        "city": "Oldenburg",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.bambiniundmamma.de/",
        "latitude": 53.13968200000001,
        "longitude": 8.2110946,
        "customAddr": "Burgstrasse 5, Oldenburg, DE"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk0NzI2MDI0NTczMDQ2MDgwNzExOzAwOyc=\"",
        "no": "C10498",
        "name": "Morgenroth kids",
        "eMail": "kids@morgenroth.biz",
        "customerGroup": "PHYSICAL",
        "address": "Friedrich- Wilhelm Str 49",
        "postCode": "38100",
        "city": "Braunschweig",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://kids.morgenroth.biz/",
        "latitude": 52.261209,
        "longitude": 10.5201628,
        "customAddr": "Friedrich- Wilhelm Str 49, Braunschweig, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NzIyNjM5Njg2MzIxODc2NzMyMTswMDsn\"",
        "no": "C10499",
        "name": "Van Tilburg ",
        "eMail": "facturen@vantilburg.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Het Runneke 10",
        "postCode": "5388 PZ",
        "city": "Nistelrode",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.vantilburgonline.nl/",
        "latitude": 51.7134825,
        "longitude": 5.5590861,
        "customAddr": "Het Runneke 10, Nistelrode, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgwNjc2NzcwMzMwNTYzNDU5NzcxOzAwOyc=\"",
        "no": "C10501",
        "name": "Louvelee",
        "eMail": "info@Louvelee.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Haagsemarkt 17",
        "postCode": "4813BA",
        "city": "Breda",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.57754260000001,
        "longitude": 4.739209199999999,
        "customAddr": "Haagsemarkt 17, Breda, NL"
      },
      {
        "@odata.etag": "W/\"JzE4Ozk0MTg0MzYxMTY1MTUwNzk4OTE7MDA7Jw==\"",
        "no": "C10502",
        "name": "Wonderful Sunbabay",
        "eMail": "welldawn2018@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Ln. 470, Yingcai Rd., West Dist. 5F.-9, No. 12",
        "postCode": "403",
        "city": "Taichung City",
        "countryRegionCode": "TW",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 24.1523312,
        "longitude": 120.6658204,
        "customAddr": "Ln. 470, Yingcai Rd., West Dist. 5F.-9, No. 12, Taichung City, TW"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk2OTYwMjUxMzA3NDMxMzMyNTAxOzAwOyc=\"",
        "no": "C10503",
        "name": "Het Kleine Gastje",
        "eMail": "martine_niezink@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "De Gast 36",
        "postCode": "9801AE",
        "city": "Zuidhorn",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.2498873,
        "longitude": 6.4026481,
        "customAddr": "De Gast 36, Zuidhorn, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgwNjg3NTg0OTU0NjA5NTExMzMxOzAwOyc=\"",
        "no": "C10504",
        "name": "Le Pain",
        "eMail": "lepainbaby@hotmail.com",
        "customerGroup": "ONLINE",
        "address": "6344 James Harris way",
        "postCode": "20121",
        "city": "Centreville",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 38.8330904,
        "longitude": -77.45740839999999,
        "customAddr": "6344 James Harris way, Centreville, US"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2OTM2OTM2MzY5NTY1NTExMDU5MTswMDsn\"",
        "no": "C10505",
        "name": "Drentse Schaapjes",
        "eMail": "drentse-dames@hotmail.com",
        "customerGroup": "ONLINE",
        "address": "Schuwacht 364",
        "postCode": "2931 BB",
        "city": "Krimpen aan de lek",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.896049,
        "longitude": 4.6409699,
        "customAddr": "Schuwacht 364, Krimpen aan de lek, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4Mzc1NzYzNjU2MTA0OTYxNzcyMTswMDsn\"",
        "no": "C10506",
        "name": "Nunc Interieur",
        "eMail": "57brigittebrewster@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Rosmarijnsteeg 7",
        "postCode": "1012RP",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.37035410000001,
        "longitude": 4.8895184,
        "customAddr": "Rosmarijnsteeg 7, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzEyMjQ0OTY2MjI5MTEwNDY0MDAxOzAwOyc=\"",
        "no": "C10507",
        "name": "Natuurlijk Gewoon",
        "eMail": "Info@birthvillage.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Jericholaan 65b",
        "postCode": "3061HB",
        "city": "Rotterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9307926,
        "longitude": 4.506526399999999,
        "customAddr": "Jericholaan 65b, Rotterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk0Njk4MzE1NDM0MjM5OTIxODgxOzAwOyc=\"",
        "no": "C10508",
        "name": "Little Baby Pocket",
        "eMail": "magdalena.skiba@littlebabypocket.de",
        "customerGroup": "ONLINE",
        "address": "Hauptstraße 154",
        "postCode": "69207",
        "city": "Sandhausen",
        "countryRegionCode": "DE",
        "noOfQuotes": 1,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-01",
        "homepage": "https://littlebabypocket.de/",
        "latitude": 49.34446879999999,
        "longitude": 8.656457699999999,
        "customAddr": "Hauptstraße 154, Sandhausen, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzIzMDQxNDkzMDE0OTgwNzgwOTAxOzAwOyc=\"",
        "no": "C10509",
        "name": "Softie baby musthaves",
        "eMail": "info@softiebabymusthaves.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Torenallee 60 02",
        "postCode": "5617BD",
        "city": "Eindhoven",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.4474878,
        "longitude": 5.4556263,
        "customAddr": "Torenallee 60 02, Eindhoven, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMyMDQyNDA4MjU5Mjc2NzIyNTMxOzAwOyc=\"",
        "no": "C10510",
        "name": "het vlinder atelier",
        "eMail": "gaaffrontriempje@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Kelderweg 4",
        "postCode": "4365SC",
        "city": "meliskerke",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.atelier-vlinder.nl/",
        "latitude": 51.5279554,
        "longitude": 3.54053,
        "customAddr": "Kelderweg 4, meliskerke, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3NDc1Nzk2NTc1Nzc1MjkwMjI0MTswMDsn\"",
        "no": "C10511",
        "name": "Little Beans",
        "eMail": "asmae_2010@live.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Vosmaerstraat 32k",
        "postCode": "3027KL",
        "city": "Rotterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9172707,
        "longitude": 4.438987399999999,
        "customAddr": "Vosmaerstraat 32k, Rotterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0OTMyOTU1MTM3ODQ3NDU0NDcyMTswMDsn\"",
        "no": "C10512",
        "name": "Ammi",
        "eMail": "eline@ammiconceptstore.be",
        "customerGroup": "PHYSICAL",
        "address": "Sonnisstraat 61",
        "postCode": "3530",
        "city": "Houthalen-Helchteren",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.0743388,
        "longitude": 5.4099764,
        "customAddr": "Sonnisstraat 61, Houthalen-Helchteren, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MTY5MjQ1MzQwMjI4MzAyNzc2MTswMDsn\"",
        "no": "C10513",
        "name": "Brow Bar Obdam",
        "eMail": "jolanda@browbarobdam.nl",
        "customerGroup": "PHYSICAL",
        "address": "Kerkweg 19F",
        "postCode": "1713JE",
        "city": "Obdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.6763488,
        "longitude": 4.9075792,
        "customAddr": "Kerkweg 19F, Obdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMTUwODI2MDI3NjUzOTYyOTQzMTswMDsn\"",
        "no": "C10514",
        "name": "Magnificence ",
        "eMail": "delphine_fortry@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Steenpoort 26",
        "postCode": "8500",
        "city": "Kortrijk",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.82731870000001,
        "longitude": 3.27039,
        "customAddr": "Steenpoort 26, Kortrijk, BE"
      },
      {
        "@odata.etag": "W/\"JzE4OzIyMjEwMTE2ODQ1MTE1MjYyMDE7MDA7Jw==\"",
        "no": "C10515",
        "name": "miniundmali Concept Store",
        "eMail": "hello@miniundmali.de",
        "customerGroup": "PHYSICAL",
        "address": "Hühnermarkt 4",
        "postCode": "41751",
        "city": "Viersen",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.25149,
        "longitude": 6.333679999999999,
        "customAddr": "Hühnermarkt 4, Viersen, DE"
      },
      {
        "@odata.etag": "W/\"JzE4OzYzOTQyNTEzNTI5MzU0NTUxMDE7MDA7Jw==\"",
        "no": "C10516",
        "name": "Stars by Daan ",
        "eMail": "starsbydaan@live.nl",
        "customerGroup": "PHYSICAL",
        "address": "Laanstraat 21",
        "postCode": "3743 BA",
        "city": "Baarn",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.2116096,
        "longitude": 5.290932,
        "customAddr": "Laanstraat 21, Baarn, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMzY1ODYwODUxNjY0MTAwMjU4MTswMDsn\"",
        "no": "C10517",
        "name": "Nutrimarket Oy - Aminopörssi",
        "eMail": "anton@nutrimarket.fi",
        "customerGroup": "PHYSANDDIG",
        "address": "Ruosilantie 14",
        "postCode": "00390",
        "city": "Helsinki",
        "countryRegionCode": "FI",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.aminoporssi.fi/",
        "latitude": 60.2391161,
        "longitude": 24.8546429,
        "customAddr": "Ruosilantie 14, Helsinki, FI"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMjQ3MTM0NTI4MDMwNTQ4MzA0MTswMDsn\"",
        "no": "C10518",
        "name": "Tao Mom's Choice",
        "eMail": "taomomschoice@gmail.com",
        "customerGroup": "ONLINE",
        "address": "2097 eucalyptus ct",
        "postCode": "95050",
        "city": "SANTA-CLARA",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 37.3599356,
        "longitude": -121.9629305,
        "customAddr": "2097 eucalyptus ct, SANTA-CLARA, US"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyOTYzODI5Nzk3MzUwNDQ2MTU2MTswMDsn\"",
        "no": "C10519",
        "name": "Pepito Kids ",
        "eMail": "elisa@pepitokids.com",
        "customerGroup": "ONLINE",
        "address": "rue des Sept Petites 34",
        "postCode": "6120",
        "city": "Nalinnes",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.34347959999999,
        "longitude": 4.430059,
        "customAddr": "rue des Sept Petites 34, Nalinnes, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzgzMDAwNzQyNzU1MDUxMDA3ODQxOzAwOyc=\"",
        "no": "C10520",
        "name": "Thiene",
        "eMail": "grandisvera@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Via del corso 1",
        "postCode": "36016",
        "city": "Vicenza",
        "countryRegionCode": "IT",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.5461815,
        "longitude": 11.5413779,
        "customAddr": "Via del corso 1, Vicenza, IT"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ1MDg4NzczMDA5OTA1NTc3MTUxOzAwOyc=\"",
        "no": "C10521",
        "name": "Stadtlandkind GmbH",
        "eMail": "roberta.zingg@stadtlandkind.ch",
        "customerGroup": "ONLINE",
        "address": "Spühlstrasse, 4",
        "postCode": "9016",
        "city": "St.Gallen",
        "countryRegionCode": "CH",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 47.4398189,
        "longitude": 9.4223239,
        "customAddr": "Spühlstrasse, 4, St.Gallen, CH"
      },
      {
        "@odata.etag": "W/\"JzE5OzEzMDk5ODYxODMwMzg1MTMyNzAxOzAwOyc=\"",
        "no": "C10522",
        "name": "Konfettiwolke",
        "eMail": "hello@konfettiwolke.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Weberstraße 82",
        "postCode": "60318",
        "city": "Frankfurt",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.1273744,
        "longitude": 8.6869634,
        "customAddr": "Weberstraße 82, Frankfurt, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1OTgzMDI0MTkzNTcxNTU1MjU2MTswMDsn\"",
        "no": "C10523",
        "name": "Natuurgeneeskracht ",
        "eMail": "info@natuurgeneeskracht.nl",
        "customerGroup": "PHYSICAL",
        "address": "Raadhuisplein 4",
        "postCode": "2042LR",
        "city": "Zandvoort",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.37172469999999,
        "longitude": 4.529890600000001,
        "customAddr": "Raadhuisplein 4, Zandvoort, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNzczODA0MTUyOTM2NjE3NzEwMTswMDsn\"",
        "no": "C10524",
        "name": "Kloop GmbH",
        "eMail": "info@kloopkids.com",
        "customerGroup": "ONLINE",
        "address": "Steinesweg 7",
        "postCode": "40822",
        "city": "Mettmann",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.2569726,
        "longitude": 6.9513934,
        "customAddr": "Steinesweg 7, Mettmann, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ1NjYxODI0NzQzNzcxODQxNDIxOzAwOyc=\"",
        "no": "C10525",
        "name": "WURMPY",
        "eMail": "info@wurmpy.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Houttil 64",
        "postCode": "1811JL",
        "city": "Alkmaar",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.6308806,
        "longitude": 4.7491996,
        "customAddr": "Houttil 64, Alkmaar, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNDI3NjgyMzAxNTQyNzcxODYzMTswMDsn\"",
        "no": "C10526",
        "name": "Notti Nordic by Katsari",
        "eMail": "rikkepf@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Rødsveien 69",
        "postCode": "1781",
        "city": "Halden",
        "countryRegionCode": "NO",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-12",
        "homepage": "",
        "latitude": 59.1268672,
        "longitude": 11.3599454,
        "customAddr": "Rødsveien 69, Halden, NO"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3NTk2NjU0MjEyMTgwNTQyODA3MTswMDsn\"",
        "no": "C10527",
        "name": "Ninaka Boutique KLG",
        "eMail": "info@ninaka.ch",
        "customerGroup": "ONLINE",
        "address": "Mühlematten 5",
        "postCode": "4455",
        "city": "Zunzgen",
        "countryRegionCode": "CH",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 47.4470642,
        "longitude": 7.8088348,
        "customAddr": "Mühlematten 5, Zunzgen, CH"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNzk4OTY5OTY4MTE5NzEzOTEwMTswMDsn\"",
        "no": "C10528",
        "name": "Kleine Kanjer",
        "eMail": "nmistroni@hotmail.com",
        "customerGroup": "ONLINE",
        "address": "Tweede Anjeliersdwarsstraat 19",
        "postCode": "1015 NS",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3774899,
        "longitude": 4.8817768,
        "customAddr": "Tweede Anjeliersdwarsstraat 19, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzUzNzgyNTQzMDQyNzMyMDc5NTkxOzAwOyc=\"",
        "no": "C10530",
        "name": "Ines_essentials ",
        "eMail": "ines_diaries@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Via Nova 80",
        "postCode": "7017",
        "city": "Flims Dorf",
        "countryRegionCode": "CH",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://ines-essentials.com/",
        "latitude": 46.8337617,
        "longitude": 9.2823183,
        "customAddr": "Via Nova 80, Flims Dorf, CH"
      },
      {
        "@odata.etag": "W/\"JzE5OzI0NTYxOTU1MTMzNTIyNjI0NzMxOzAwOyc=\"",
        "no": "C10531",
        "name": "Old Stable BV",
        "eMail": "info@oldstable.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Koestraat 1A",
        "postCode": "1441CV",
        "city": "Purmerend",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.5083852,
        "longitude": 4.948536199999999,
        "customAddr": "Koestraat 1A, Purmerend, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzY2MTI0OTk3NDI3Mzk4MTk4MDQxOzAwOyc=\"",
        "no": "C10532",
        "name": "MN Fashion BV ",
        "eMail": "graceyquan@outlook.com",
        "customerGroup": "PHYSICAL",
        "address": "Huo Xiu Feng Dong Xiao Qu, Ze Zhou County, Jin Cheng, Shan Xi Province",
        "postCode": "048000",
        "city": "Shan Xi",
        "countryRegionCode": "CN",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 35.50326099999999,
        "longitude": 112.916506,
        "customAddr": "Huo Xiu Feng Dong Xiao Qu, Ze Zhou County, Jin Cheng, Shan Xi Province, Shan Xi, CN"
      },
      {
        "@odata.etag": "W/\"JzE5OzExMjk5NjM5NzQxODY3MjUwMDIxOzAwOyc=\"",
        "no": "C10533",
        "name": "NOVIBABY INC",
        "eMail": "novibaby2@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "2801 NE Riverside Way Ste200",
        "postCode": "97211",
        "city": "PORTLAND",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.5808136,
        "longitude": -122.6365414,
        "customAddr": "2801 NE Riverside Way Ste200, PORTLAND, US"
      },
      {
        "@odata.etag": "W/\"JzE5OzgyNjk5MjcyNjIxMjI5MDgwMTQxOzAwOyc=\"",
        "no": "C10534",
        "name": "Binorm",
        "eMail": "binorm@binorm.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Turfstraat 6",
        "postCode": "7201KG",
        "city": "Zutphen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-09-03",
        "homepage": "https://www.binorm.nl/",
        "latitude": 52.1420881,
        "longitude": 6.1955133,
        "customAddr": "Turfstraat 6, Zutphen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNzIwODIzNzk4NTEwOTY3NDE3MTswMDsn\"",
        "no": "C10535",
        "name": "Pipelettes et Galopins",
        "eMail": "hello@pipelettes-et-galopins.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Rue de Linthout 190",
        "postCode": "1040",
        "city": "Bruxelles",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://pipelettes-et-galopins.com/",
        "latitude": 50.8420594,
        "longitude": 4.4010213,
        "customAddr": "Rue de Linthout 190, Bruxelles, BE"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc0NjEyNjQ5ODUzNzc4MTkwMDUxOzAwOyc=\"",
        "no": "C10536",
        "name": "Smart Babyshop",
        "eMail": "contact@smart-luxembourg.com",
        "customerGroup": "PHYSANDDIG",
        "address": "25 Chemin de Roedgen",
        "postCode": "2432",
        "city": "Luxembourg",
        "countryRegionCode": "LU",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 49.590958,
        "longitude": 6.103861999999999,
        "customAddr": "25 Chemin de Roedgen, Luxembourg, LU"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3Nzk4Mzg2ODA0ODUwNTA5NjI3MTswMDsn\"",
        "no": "C10537",
        "name": "Lubu's et moi...",
        "eMail": "moi@lubus.ch",
        "customerGroup": "PHYSANDDIG",
        "address": "zentralstrasse 32",
        "postCode": "2502",
        "city": "biel/bienne",
        "countryRegionCode": "CH",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.lubus.ch/de",
        "latitude": 47.1380778,
        "longitude": 7.2451906,
        "customAddr": "zentralstrasse 32, biel/bienne, CH"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1MTk2MjY3ODgxMTYzOTk1OTEzMTswMDsn\"",
        "no": "C10538",
        "name": "Noeloe",
        "eMail": "noeloe_@outlook.com",
        "customerGroup": "ONLINE",
        "address": "Vughterstraat 21",
        "postCode": "5211 EW",
        "city": "s-Hertogenbosch",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.noeloe.nl/",
        "latitude": 51.6876048,
        "longitude": 5.3015226,
        "customAddr": "Vughterstraat 21, s-Hertogenbosch, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMDc1NTgzNzE4MDMyNzQ1NDYzMTswMDsn\"",
        "no": "C10539",
        "name": "Club Frou Frou",
        "eMail": "josefien@froufrou.online",
        "customerGroup": "ONLINE",
        "address": "Franckenstraat 13",
        "postCode": "2000",
        "city": "Antwerpen",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.2154706,
        "longitude": 4.398180099999999,
        "customAddr": "Franckenstraat 13, Antwerpen, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzI2ODg4NjA2NzI0NTU5MTAwNzcxOzAwOyc=\"",
        "no": "C10540",
        "name": "Little One BK",
        "eMail": "little_onebk@outlook.com",
        "customerGroup": "ONLINE",
        "address": "Melvert 7",
        "postCode": "5469SB",
        "city": "Erp",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.611436,
        "longitude": 5.5968705,
        "customAddr": "Melvert 7, Erp, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMzU5NTcwMDUwMDc5OTk3NTc5MTswMDsn\"",
        "no": "C10541",
        "name": "Citron Grenadine",
        "eMail": "geraldine@citrongrenadine.be",
        "customerGroup": "PHYSANDDIG",
        "address": "36 passage de l'Ergot",
        "postCode": "1348",
        "city": "Louvain-la-Neuve",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.citrongrenadine.be/",
        "latitude": 50.6692384,
        "longitude": 4.614001099999999,
        "customAddr": "36 passage de l'Ergot, Louvain-la-Neuve, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzQxNTg2MzQ2Mjc1MzY3MjU4ODYxOzAwOyc=\"",
        "no": "C10542",
        "name": "K-Deetje",
        "eMail": "Info@k-deetje.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Kortrijksestraat 14",
        "postCode": "8020",
        "city": "Oostkamp",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://k-deetje.be/",
        "latitude": 51.1536619,
        "longitude": 3.2350027,
        "customAddr": "Kortrijksestraat 14, Oostkamp, BE"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg2ODQ4Mjc5MjE4OTEyMDIyNTcxOzAwOyc=\"",
        "no": "C10543",
        "name": "Knitting Project",
        "eMail": "ileana.denes@smally.ro",
        "customerGroup": "ONLINE",
        "address": "Principala",
        "postCode": "557243",
        "city": "Rusi",
        "countryRegionCode": "RO",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": null,
        "longitude": null,
        "customAddr": "Principala, Rusi, RO"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwODcxMTUyMzc2ODAyOTA4NDIyMTswMDsn\"",
        "no": "C10544",
        "name": "FLOW-CONCEPTSTORE",
        "eMail": "info@flowconceptstore.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kerkstraat 53A",
        "postCode": "4141 AV",
        "city": "Leerdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.89047309999999,
        "longitude": 5.092457899999999,
        "customAddr": "Kerkstraat 53A, Leerdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNjM3MTI2NDE3NDE0Nzk2MDQxMTswMDsn\"",
        "no": "C10545",
        "name": "Things I Like Things I Love B.V.",
        "eMail": "inkoop.as@thingsilikethingsilove.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Gyroscoopweg 52",
        "postCode": "1042AC",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-23",
        "homepage": "https://www.thingsilikethingsilove.com/",
        "latitude": 52.4000232,
        "longitude": 4.841781,
        "customAddr": "Gyroscoopweg 52, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ4NzQ5NTI1Mjg4OTc4NDAyMjYxOzAwOyc=\"",
        "no": "C10546",
        "name": "So Little",
        "eMail": "info@solittle.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Dorpstraat 47A",
        "postCode": "6093 EB",
        "city": "Heythuysen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.25031480000001,
        "longitude": 5.8984653,
        "customAddr": "Dorpstraat 47A, Heythuysen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ0Mzg2MzM3Mjc4MzE5MTc3MzYxOzAwOyc=\"",
        "no": "C10547",
        "name": "Peakaboo kids",
        "eMail": "kidspeakaboo@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "UNIT 8 , 5/F （91770）MING FAT IND. CTR , KIN FAT ST ,TUEN MUN UNIT 8 , 5/F （92752）MING FAT IND",
        "postCode": "213300",
        "city": "Tuen mun",
        "countryRegionCode": "HK",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 22.395718,
        "longitude": 113.967901,
        "customAddr": "UNIT 8 , 5/F （91770）MING FAT IND. CTR , KIN FAT ST ,TUEN MUN UNIT 8 , 5/F （92752）MING FAT IND, Tuen mun, HK"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2ODI2MDg4MzE1ODQ2NjIzNDAxMTswMDsn\"",
        "no": "C10548",
        "name": "Yourownprint",
        "eMail": "yourownprintwebshop@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Zalmwater 57",
        "postCode": "2993DX",
        "city": "Barendrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.846895,
        "longitude": 4.5049325,
        "customAddr": "Zalmwater 57, Barendrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MjMzNTMyNjQ0MjA4MDYzODQwMTswMDsn\"",
        "no": "C10549",
        "name": "Framboise et Vincent ",
        "eMail": "framboise_et_vincent@gmx.de",
        "customerGroup": "ONLINE",
        "address": "Schopenhauerstr. 16",
        "postCode": "55606",
        "city": "Kirn",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 49.7994184,
        "longitude": 7.4612379,
        "customAddr": "Schopenhauerstr. 16, Kirn, DE"
      },
      {
        "@odata.etag": "W/\"JzE3Ozk1MDA5ODQ4Mjg3MTc3MDk0MTswMDsn\"",
        "no": "C10550",
        "name": "Juffrouw Pollewop",
        "eMail": "info@juffrouwpollewop.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Vriesestraat 78",
        "postCode": "3311NR",
        "city": "Dordrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.juffrouwpollewop.nl/",
        "latitude": 51.8134297,
        "longitude": 4.6684323,
        "customAddr": "Vriesestraat 78, Dordrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc0MDY3NzA3MzU0MTkxMjY0NjExOzAwOyc=\"",
        "no": "C10551",
        "name": "Niños en Niñas ",
        "eMail": "info@ninos-en-ninas.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Burgemeester Cortenstraat 8b",
        "postCode": "6226GV",
        "city": "Maastricht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.8443346,
        "longitude": 5.7281574,
        "customAddr": "Burgemeester Cortenstraat 8b, Maastricht, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MDA2MjQyMzEwMTMwMTI5OTg2MTswMDsn\"",
        "no": "C10552",
        "name": "1000Women",
        "eMail": "shop@babyandme.me",
        "customerGroup": "PHYSANDDIG",
        "address": "1342 Military Road Unit 959659",
        "postCode": "14304",
        "city": "Niagara Falls",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 43.0912791,
        "longitude": -78.9716548,
        "customAddr": "1342 Military Road Unit 959659, Niagara Falls, US"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg3OTcyMTg1NDQyNjM0OTg0MzMxOzAwOyc=\"",
        "no": "C10553",
        "name": "ginger fairy",
        "eMail": "sandra@gingerfairy.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "aw van voordenlaan 9",
        "postCode": "1241 AN",
        "city": "Kortenhoef",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.2442735,
        "longitude": 5.1147568,
        "customAddr": "aw van voordenlaan 9, Kortenhoef, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU1NTI2OTgxMDg5NjE3NDQ1MjYxOzAwOyc=\"",
        "no": "C10554",
        "name": "le Fanfare B.V",
        "eMail": "info@lefanfare.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Lusthofstraat 46A",
        "postCode": "3062 WN",
        "city": "Rotterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-13",
        "homepage": "https://www.lefanfare.nl/",
        "latitude": 51.92344569999999,
        "longitude": 4.511577,
        "customAddr": "Lusthofstraat 46A, Rotterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU5NjIyMTM3OTY3NTk1NTI4NTgxOzAwOyc=\"",
        "no": "C10555",
        "name": "Blomsterbarna",
        "eMail": "kristinaellingsen@msn.com",
        "customerGroup": "ONLINE",
        "address": "Øvre Sædalsvegen 307",
        "postCode": "5099",
        "city": "Bergen",
        "countryRegionCode": "NO",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 60.3450835,
        "longitude": 5.3780284,
        "customAddr": "Øvre Sædalsvegen 307, Bergen, NO"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNDMzMjMzNzQxMjExMTMyOTI3MTswMDsn\"",
        "no": "C10556",
        "name": "Zin Doesburg ",
        "eMail": "vofdebake@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Kerkstraat 18",
        "postCode": "6981 CM",
        "city": "Doesburg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.01383870000001,
        "longitude": 6.1350381,
        "customAddr": "Kerkstraat 18, Doesburg, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzI4MTY5NDc1NDgzMjI4Mzg3MTQxOzAwOyc=\"",
        "no": "C10557",
        "name": "Mumerakis",
        "eMail": "mumerakis@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Calle Puigterra de Dalt, 19-25, 3r 3a",
        "postCode": "08241",
        "city": "MANRESA",
        "countryRegionCode": "ES",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 41.7260143,
        "longitude": 1.8274368,
        "customAddr": "Calle Puigterra de Dalt, 19-25, 3r 3a, MANRESA, ES"
      },
      {
        "@odata.etag": "W/\"JzE5OzY3NjA0MTcyMDg2MjU5Nzg0OTkxOzAwOyc=\"",
        "no": "C10558",
        "name": "Finn & Julia",
        "eMail": "info@finnenjulia.com",
        "customerGroup": "PHYSICAL",
        "address": "Heidestatiestraat 27 bus 1",
        "postCode": "2920",
        "city": "Kalmthout",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.finnenjulia.com/",
        "latitude": 51.3655238,
        "longitude": 4.4649511,
        "customAddr": "Heidestatiestraat 27 bus 1, Kalmthout, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzI2MTI1MTI2MTA3Mjc3MjM3MTcxOzAwOyc=\"",
        "no": "C10559",
        "name": "Van Tilburg Nistelrode ",
        "eMail": "dverboven@vantilburg.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Het Runneke 10",
        "postCode": "5388 PZ",
        "city": "Nistelrode",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.7134825,
        "longitude": 5.5590861,
        "customAddr": "Het Runneke 10, Nistelrode, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMyNjA1ODM1Nzc4MTgwNTgzOTgxOzAwOyc=\"",
        "no": "C10560",
        "name": "SAS So Boheme ",
        "eMail": "so-boheme@hotmail.fr",
        "customerGroup": "PHYSANDDIG",
        "address": "11 blvd Edouard Baudoin",
        "postCode": "06160",
        "city": "Juan les pins ",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 43.5676394,
        "longitude": 7.1123539,
        "customAddr": "11 blvd Edouard Baudoin, Juan les pins , FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNjk1MzcxMjE0MjA5MTYyNjU0MTswMDsn\"",
        "no": "C10561",
        "name": "Moani conceptstore",
        "eMail": "info@moani.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Marktplein 38",
        "postCode": "1972GB",
        "city": "Ijmuiden ",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.4584072,
        "longitude": 4.615348099999999,
        "customAddr": "Marktplein 38, Ijmuiden , NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNTQ5ODQyNzIzNzIyNzI0MTMwMTswMDsn\"",
        "no": "C10562",
        "name": "OH MINI. kids concept store",
        "eMail": "info@ohministore.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Naumannstr 7",
        "postCode": "10829",
        "city": "Berlin",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.4855784,
        "longitude": 13.363728,
        "customAddr": "Naumannstr 7, Berlin, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzYwMDE1NDMwMDQwNjkyOTY0MTIxOzAwOyc=\"",
        "no": "C10563",
        "name": "Piraten en Prinsessen",
        "eMail": "saskya@piratenenprinsessen.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Ruysdaelstraat 29",
        "postCode": "1961 RM",
        "city": "Heemskerk",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.50995289999999,
        "longitude": 4.6697355,
        "customAddr": "Ruysdaelstraat 29, Heemskerk, NL"
      },
      {
        "@odata.etag": "W/\"JzE4Ozk5MTQ5NDY2NDQ4ODQxMDgyMjE7MDA7Jw==\"",
        "no": "C10564",
        "name": "Cucù Mini&Mama di Alessandra Raspa",
        "eMail": "wholesale@cucuminiandmama.com",
        "customerGroup": "ONLINE",
        "address": "via ballilla 57",
        "postCode": "09013",
        "city": "Carbonia",
        "countryRegionCode": "IT",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 39.1688332,
        "longitude": 8.5181198,
        "customAddr": "via ballilla 57, Carbonia, IT"
      },
      {
        "@odata.etag": "W/\"JzE4OzQ1MTE1NzMzNjA5MzM5MzAwODE7MDA7Jw==\"",
        "no": "C10565",
        "name": "Coeur de Megeve ",
        "eMail": "julia@stellerhotels.com",
        "customerGroup": "PHYSICAL",
        "address": "44 rue Charles Feige",
        "postCode": "74120",
        "city": "Megeve",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.coeurdemegeve.com/",
        "latitude": 45.8570775,
        "longitude": 6.6185773,
        "customAddr": "44 rue Charles Feige, Megeve, FR"
      },
      {
        "@odata.etag": "W/\"JzE5OzUyMDc3NzUzNzc5Nzc2Mjk3ODUxOzAwOyc=\"",
        "no": "C10566",
        "name": "Label92 ",
        "eMail": "Info.label92@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Molenpoortstraat 23",
        "postCode": "7041 BE",
        "city": "S-Heerenberg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8758112,
        "longitude": 6.2454303,
        "customAddr": "Molenpoortstraat 23, S-Heerenberg, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1OTUzODAyNDU3Nzc0MjI0NTgxMTswMDsn\"",
        "no": "C10567",
        "name": "Lander Vandekerckhove-Degrande (Discocake.be)",
        "eMail": "info@discocake.be",
        "customerGroup": "ONLINE",
        "address": "Elbestraat 13",
        "postCode": "8760",
        "city": "Meulebeke",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.9584574,
        "longitude": 3.274007,
        "customAddr": "Elbestraat 13, Meulebeke, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMjk1OTk3MDk5NTI1NTEzMjI5MTswMDsn\"",
        "no": "C10568",
        "name": "Eco-Brands",
        "eMail": "karen@eco-brands.eu",
        "customerGroup": "ONLINE",
        "address": "Morellaan 30",
        "postCode": "2990",
        "city": "Wuustwezel",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://eco-brands.eu/",
        "latitude": 51.3867383,
        "longitude": 4.5352831,
        "customAddr": "Morellaan 30, Wuustwezel, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwOTEzMTU2OTY4NDYwNDI4NTA5MTswMDsn\"",
        "no": "C10569",
        "name": "A Lovely Day",
        "eMail": "dorine@lovelydaystore.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Scheldestraat 42",
        "postCode": "1078GL",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3465542,
        "longitude": 4.8908188,
        "customAddr": "Scheldestraat 42, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMxNzcwMTg2MTUwNzIzNzI2MjgxOzAwOyc=\"",
        "no": "C10570",
        "name": "Lie.ve.Ling Kids ",
        "eMail": "info@lievelingkids.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "7 Kerkstraat",
        "postCode": "4141 AT",
        "city": "Leerdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.lievelingkids.nl/",
        "latitude": 51.8911457,
        "longitude": 5.0950935,
        "customAddr": "7 Kerkstraat, Leerdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMwNTc2NjA3OTEyMDEwNDIxNzcxOzAwOyc=\"",
        "no": "C10571",
        "name": "Magical fun inc.",
        "eMail": "magicalfuninc@gmail.com",
        "customerGroup": "ONLINE",
        "address": "4377 158th st",
        "postCode": "11358",
        "city": "flushing",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 40.7569005,
        "longitude": -73.8080493,
        "customAddr": "4377 158th st, flushing, US"
      },
      {
        "@odata.etag": "W/\"JzE5OzY0ODUzNTk4NzUwMTQ2NDE4MzgxOzAwOyc=\"",
        "no": "C10573",
        "name": "JX KIDS BVBA",
        "eMail": "info@jxkids.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Kleidaallaan 14",
        "postCode": "2620",
        "city": "Hemiksem",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.1367643,
        "longitude": 4.3470477,
        "customAddr": "Kleidaallaan 14, Hemiksem, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzgxMjg0OTE0OTUwMzQwMzA5NDIxOzAwOyc=\"",
        "no": "C10574",
        "name": "Op Wolkjes Lopen",
        "eMail": "sandrahelsen72@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Tuinweg 17",
        "postCode": "2290",
        "city": "Vorselaar",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.20482149999999,
        "longitude": 4.7794262,
        "customAddr": "Tuinweg 17, Vorselaar, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzI4ODU0MjA5MDI0MDAyNjAyNTQxOzAwOyc=\"",
        "no": "C10575",
        "name": "Tribu Collection",
        "eMail": "info@tribucollection.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Boskapellei 103",
        "postCode": "2930",
        "city": "Brasschaat",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.2976945,
        "longitude": 4.450542400000001,
        "customAddr": "Boskapellei 103, Brasschaat, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyOTk2MTYyNDU3MjQ3MTEzNzI0MTswMDsn\"",
        "no": "C10576",
        "name": "BLOM WOL",
        "eMail": "blom@blomwol.nl",
        "customerGroup": "ONLINE",
        "address": "Hoge Steenweg 52",
        "postCode": "5175AD",
        "city": "Loon op Zand",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.62926119999999,
        "longitude": 5.066544299999999,
        "customAddr": "Hoge Steenweg 52, Loon op Zand, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNDI2OTM2MTUzNzI3ODU5NDM0MTswMDsn\"",
        "no": "C10577",
        "name": "My Little Palace ",
        "eMail": "info@mylittlepalace.eu",
        "customerGroup": "PHYSANDDIG",
        "address": "Brinkersweg 1A",
        "postCode": "8071GR",
        "city": "Nunspeet",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.mylittlepalace.eu/",
        "latitude": 52.376421,
        "longitude": 5.7819357,
        "customAddr": "Brinkersweg 1A, Nunspeet, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2ODA1NTUxNzk5NjkxOTkzNjYzMTswMDsn\"",
        "no": "C10578",
        "name": "Kardemommeshop ",
        "eMail": "anna@kardemommeshop.com",
        "customerGroup": "ONLINE",
        "address": "Skoieveien 172",
        "postCode": "4517",
        "city": "Norway",
        "countryRegionCode": "NO",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 58.0676406,
        "longitude": 7.554209899999999,
        "customAddr": "Skoieveien 172, Norway, NO"
      },
      {
        "@odata.etag": "W/\"JzE5OzI5MDc4NTQ4NjUxMTE5ODc1NzAxOzAwOyc=\"",
        "no": "C10579",
        "name": "Hippeschoentjes.be",
        "eMail": "info@hippeschoentjes.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Nijverheidslaan 8",
        "postCode": "3200",
        "city": "Aarschot",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.9893624,
        "longitude": 4.822676,
        "customAddr": "Nijverheidslaan 8, Aarschot, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwOTc3MjI3NTUzNjY2NjA4NTIyMTswMDsn\"",
        "no": "C10580",
        "name": "Milliebag",
        "eMail": "info@milliebag.com",
        "customerGroup": "ONLINE",
        "address": "Heuveloord 21",
        "postCode": "3523CK",
        "city": "Utrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://milliebag.com/",
        "latitude": 52.07568,
        "longitude": 5.1209643,
        "customAddr": "Heuveloord 21, Utrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1NzU5NjMzODQwODA4MjY2NTUzMTswMDsn\"",
        "no": "C10581",
        "name": "Zussies kleding",
        "eMail": "info@zussieskleding.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Prinsenstraat 12",
        "postCode": "7721AJ",
        "city": "Dalfsen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://zussieskleding.nl/",
        "latitude": 52.5037641,
        "longitude": 6.2600025,
        "customAddr": "Prinsenstraat 12, Dalfsen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQwOTY0NTcxNzAyMjU1MTA2NTcxOzAwOyc=\"",
        "no": "C10582",
        "name": "Montie",
        "eMail": "info@montie.shop",
        "customerGroup": "PHYSANDDIG",
        "address": "Boeschepestraat 30",
        "postCode": "8970",
        "city": "Poperinge",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.8518728,
        "longitude": 2.7230572,
        "customAddr": "Boeschepestraat 30, Poperinge, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MTk2NDgyNzUxMDMwOTg3MDM2MTswMDsn\"",
        "no": "C10583",
        "name": "Lief",
        "eMail": "dinekeveenstra@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Via Garibaldi 42",
        "postCode": "40066",
        "city": "Pieve di cento",
        "countryRegionCode": "IT",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 44.7140853,
        "longitude": 11.3053848,
        "customAddr": "Via Garibaldi 42, Pieve di cento, IT"
      },
      {
        "@odata.etag": "W/\"JzE4Ozk1MDA5ODA2NDQ3OTE4NzAyOTE7MDA7Jw==\"",
        "no": "C10584",
        "name": "Het Duifje kindermode",
        "eMail": "info@hetduifje.nl",
        "customerGroup": "PHYSICAL",
        "address": "Misterstraat 6",
        "postCode": "7101 EW",
        "city": "Winterswijk",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.hetduifje.nl/",
        "latitude": 51.971595,
        "longitude": 6.719262199999999,
        "customAddr": "Misterstraat 6, Winterswijk, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMjU0OTk5NzY4MjcyMTQyNjY5MTswMDsn\"",
        "no": "C10585",
        "name": "Teezeit & Ambiente ",
        "eMail": "teezeitundambiente3@web.de",
        "customerGroup": "PHYSICAL",
        "address": "Alte Bielefelder Straße 16",
        "postCode": "33824",
        "city": "Werther",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0721674,
        "longitude": 8.4135215,
        "customAddr": "Alte Bielefelder Straße 16, Werther, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzExODY2MzE1MTI4NzM1MzQwNTA4MTswMDsn\"",
        "no": "C10586",
        "name": "SARL SMB",
        "eMail": "martial@a-hb.fr",
        "customerGroup": "PHYSICAL",
        "address": "32 boulevard du jeu de paume",
        "postCode": "34000",
        "city": "Montpellier",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 43.6067646,
        "longitude": 3.8752189,
        "customAddr": "32 boulevard du jeu de paume, Montpellier, FR"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ2OTI0MzYyMTcyODAzMDI2MDExOzAwOyc=\"",
        "no": "C10587",
        "name": "Rogowski & Rogowski UG",
        "eMail": "isabel.r@meaamare.com",
        "customerGroup": "PHYSICAL",
        "address": "Kanzlerstraße 7",
        "postCode": "40472",
        "city": "Düsseldorf",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.2633191,
        "longitude": 6.8235082,
        "customAddr": "Kanzlerstraße 7, Düsseldorf, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2Nzc4NjkyMDY2MzA5NzgwODg5MTswMDsn\"",
        "no": "C10588",
        "name": "Schoenen De Gelaarsde KAT",
        "eMail": "schoenendegelaarsdekat@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Glabbeekstraat 113",
        "postCode": "3450",
        "city": "Geetbets",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.88006660000001,
        "longitude": 5.104797200000001,
        "customAddr": "Glabbeekstraat 113, Geetbets, BE"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg3NDUxODUxNjU1NjEwMzI0NzUxOzAwOyc=\"",
        "no": "C10589",
        "name": "Moos",
        "eMail": "h.desfossez@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "6 rue Pierre Ogee",
        "postCode": "59112",
        "city": "Annoeullin",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.5287309,
        "longitude": 2.9323579,
        "customAddr": "6 rue Pierre Ogee, Annoeullin, FR"
      },
      {
        "@odata.etag": "W/\"JzE5OzU0ODk3MzY1ODcxNDIwNTQxOTgxOzAwOyc=\"",
        "no": "C10590",
        "name": "Eva Rodríguez Castro (VARASTON)",
        "eMail": "info@varaston.com",
        "customerGroup": "ONLINE",
        "address": "WAREHOUSE SHIPMENTS: C/ Luis Freire García 22, 15190 STORE: C/ Pío XII 1, 15001",
        "postCode": "15190",
        "city": "A Coruña",
        "countryRegionCode": "ES",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 43.3712857,
        "longitude": -8.3951235,
        "customAddr": "WAREHOUSE SHIPMENTS: C/ Luis Freire García 22, 15190 STORE: C/ Pío XII 1, 15001, A Coruña, ES"
      },
      {
        "@odata.etag": "W/\"JzE5OzkwNzEyMDIyMDk0MzUxNDg4MTExOzAwOyc=\"",
        "no": "C10591",
        "name": "Mamour",
        "eMail": "mamourkidstore@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "12 place de la Libération",
        "postCode": "69130",
        "city": "Ecully",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.7754074,
        "longitude": 4.7778714,
        "customAddr": "12 place de la Libération, Ecully, FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMDM4NTEwMzM4NjMxNzk2MjU0MTswMDsn\"",
        "no": "C10592",
        "name": "t Winkeltje (Antroposofische gemeenschap Haarlem)",
        "eMail": "antroposofiehaarlem.shop@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Prinsen Bolwerk 3B",
        "postCode": "2011MA",
        "city": "Haarlem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3884638,
        "longitude": 4.6427046,
        "customAddr": "Prinsen Bolwerk 3B, Haarlem, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzM3MDc5OTc1OTEzNzA0NzEzOTUxOzAwOyc=\"",
        "no": "C10593",
        "name": "Mano & Noa",
        "eMail": "info@mano-noa.nl",
        "customerGroup": "PHYSICAL",
        "address": "Kerkstraat 87",
        "postCode": "2201KL",
        "city": "Noordwijk",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-11",
        "homepage": "https://mano-noa.nl/",
        "latitude": 52.2351448,
        "longitude": 4.444872699999999,
        "customAddr": "Kerkstraat 87, Noordwijk, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQwMzQ5NjU1NDY1MjEzOTMxMDExOzAwOyc=\"",
        "no": "C10594",
        "name": "La Galette",
        "eMail": "lagalette.salesucre@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "via civerchi 63",
        "postCode": "26013",
        "city": "Crema",
        "countryRegionCode": "IT",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.3637542,
        "longitude": 9.6914357,
        "customAddr": "via civerchi 63, Crema, IT"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MzcyNDg1MzUwNTAzODQwNzcwMTswMDsn\"",
        "no": "C10595",
        "name": "Modehart ",
        "eMail": "awkluiter@live.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Hoornderweg 9",
        "postCode": "9698 PK",
        "city": "Wedde",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.0769002,
        "longitude": 7.063021399999999,
        "customAddr": "Hoornderweg 9, Wedde, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMTUwNDQzMDU4NTYzNDQ4MDI0MTswMDsn\"",
        "no": "C10596",
        "name": "Super-Hip 4 You",
        "eMail": "info@superhip4you.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Rijksstraatweg 56A",
        "postCode": "3223KA",
        "city": "Hellevoetsluis",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8364595,
        "longitude": 4.1333287,
        "customAddr": "Rijksstraatweg 56A, Hellevoetsluis, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU0ODA4NzczMDU0NzkwODg3NjAxOzAwOyc=\"",
        "no": "C10597",
        "name": "Mijn Modewereld",
        "eMail": "jeanette@mijnmodewereld.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Dorpsstraat 44",
        "postCode": "7957 AW",
        "city": "De Wijk",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.67245370000001,
        "longitude": 6.2851509,
        "customAddr": "Dorpsstraat 44, De Wijk, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk0ODkxOTQyNzAyOTk2NjYwOTExOzAwOyc=\"",
        "no": "C10598",
        "name": "ChoO ",
        "eMail": "contact@choo-design.fr",
        "customerGroup": "PHYSANDDIG",
        "address": "130 Chemin du pont blanc",
        "postCode": "84270",
        "city": "Vedene",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 43.9784962,
        "longitude": 4.887889899999999,
        "customAddr": "130 Chemin du pont blanc, Vedene, FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNjk2NjcyNzU5NDQ4NzA3ODc2MTswMDsn\"",
        "no": "C10599",
        "name": "Su&Jill",
        "eMail": "info@suenjill.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Sprongstraat 9",
        "postCode": "7201KS",
        "city": "Zutphen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.suenjill.nl/",
        "latitude": 52.1411722,
        "longitude": 6.197257899999999,
        "customAddr": "Sprongstraat 9, Zutphen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc0NjUyMzY5MjY2NDYyMzc5NDUxOzAwOyc=\"",
        "no": "C10600",
        "name": "Little waves",
        "eMail": "shoplittlewaves@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "8 White Street",
        "postCode": "07701",
        "city": "Red bank ",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 40.3508311,
        "longitude": -74.0659557,
        "customAddr": "8 White Street, Red bank , US"
      },
      {
        "@odata.etag": "W/\"JzE5OzM4NjA2MTQ5NTA3NTcxNzM4OTkxOzAwOyc=\"",
        "no": "C10601",
        "name": "novibaby ",
        "eMail": "zoeykids02@outlook.com",
        "customerGroup": "ONLINE",
        "address": "2828 Utica St",
        "postCode": "80212",
        "city": "Denver",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 39.757841,
        "longitude": -105.0451813,
        "customAddr": "2828 Utica St, Denver, US"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2Njg1NjQ2MTIyODgzOTUyNzgxMTswMDsn\"",
        "no": "C10602",
        "name": "Sussies",
        "eMail": "indewolletjes@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Roodmus 18",
        "postCode": "3435CH",
        "city": "Nieuwegein",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0258312,
        "longitude": 5.0772476,
        "customAddr": "Roodmus 18, Nieuwegein, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzE4MjE1MTI5NTIwMjc3MTc5ODExOzAwOyc=\"",
        "no": "C10603",
        "name": "selbstconcept — carefully selected goods ",
        "eMail": "hello@selbstconcept.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Stegstraße 54",
        "postCode": "60594",
        "city": "Frankfurt am Main",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.1023545,
        "longitude": 8.6840932,
        "customAddr": "Stegstraße 54, Frankfurt am Main, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2MTc3MDMwNDI1MTU0NTIwNTMwMTswMDsn\"",
        "no": "C10604",
        "name": "Rikst Fashion & Lifestyle ",
        "eMail": "rikst.fl@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Christinastraat 2",
        "postCode": "9285 TM",
        "city": "Buitenpost",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.2530711,
        "longitude": 6.143196,
        "customAddr": "Christinastraat 2, Buitenpost, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzYxODUwMzc1Mjc2MDcxNTQ1OTQxOzAwOyc=\"",
        "no": "C10605",
        "name": "SARL Ateliers B.",
        "eMail": "contact.maisonbeloscar@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "12 RUE JUSTIN DALEAS",
        "postCode": "65200",
        "city": "BAGNERES-DE-BIGORRE",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 43.06361,
        "longitude": 0.1482599,
        "customAddr": "12 RUE JUSTIN DALEAS, BAGNERES-DE-BIGORRE, FR"
      },
      {
        "@odata.etag": "W/\"JzE5OzYwNzEyMTEzNjAyNjc3MzY3MDkxOzAwOyc=\"",
        "no": "C10606",
        "name": "Little Bohemian",
        "eMail": "info@littlebohemian.nl",
        "customerGroup": "ONLINE",
        "address": "Bisschop Ottostraat 3",
        "postCode": "2033 GN",
        "city": "HAARLEM",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.37591459999999,
        "longitude": 4.6488768,
        "customAddr": "Bisschop Ottostraat 3, HAARLEM, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MDQwNDY2MDAwMjQ4NzAyNzY4MTswMDsn\"",
        "no": "C10607",
        "name": "Kloffies en Koffies",
        "eMail": "katrien@kloffiesenkoffies.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Nieuwe Ginnekenstraat 36",
        "postCode": "4811 NS",
        "city": "Breda",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.kloffiesenkoffies.nl/",
        "latitude": 51.58122580000001,
        "longitude": 4.777074799999999,
        "customAddr": "Nieuwe Ginnekenstraat 36, Breda, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzYyNzk3MTc3ODg1OTM1Mjg2ODgxOzAwOyc=\"",
        "no": "C10608",
        "name": "By Daisy topstylist",
        "eMail": "daisy_serena@Hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Bertus bulstraat 17",
        "postCode": "3077 MR",
        "city": "Rotterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.89841699999999,
        "longitude": 4.5207612,
        "customAddr": "Bertus bulstraat 17, Rotterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU5NTU3MzQ0MzA5NjE1MTI4MTUxOzAwOyc=\"",
        "no": "C10609",
        "name": "Van Mij",
        "eMail": "marielle@van-mij.nl",
        "customerGroup": "PHYSICAL",
        "address": "Klarendalseweg 393",
        "postCode": "6822GT",
        "city": "Arnhem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-11",
        "homepage": "https://van-mij.nl/",
        "latitude": 51.9892208,
        "longitude": 5.923213199999999,
        "customAddr": "Klarendalseweg 393, Arnhem, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNDIxNjk2OTM2ODA3NDI4MTk2MTswMDsn\"",
        "no": "C10610",
        "name": "HYGGE the farm",
        "eMail": "nic@hygge-thefarm.com",
        "customerGroup": "PHYSICAL",
        "address": "Cordsstrasse 5-9",
        "postCode": "22609",
        "city": "Hamburg",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.5578452,
        "longitude": 9.8481575,
        "customAddr": "Cordsstrasse 5-9, Hamburg, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMzU5MzczNzIzNjQyNjEzNjAwMTswMDsn\"",
        "no": "C10611",
        "name": "La Manufacture bohème",
        "eMail": "lamanufactureboheme@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "9 rue Chimay",
        "postCode": "1333",
        "city": "Luxembourg",
        "countryRegionCode": "LU",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.lamanufactureboheme.lu/",
        "latitude": 49.6106056,
        "longitude": 6.129717599999999,
        "customAddr": "9 rue Chimay, Luxembourg, LU"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3NDQzOTM0MDYzODIxNzE1MzQwMTswMDsn\"",
        "no": "C10612",
        "name": "STA4kids textiles and toys",
        "eMail": "info@stadesign.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "1e Leeghwaterstraat 18",
        "postCode": "1018RC",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3699141,
        "longitude": 4.929393399999999,
        "customAddr": "1e Leeghwaterstraat 18, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgyMzk3NjcyNDY4Mzg4MjIwMjAxOzAwOyc=\"",
        "no": "C10613",
        "name": "Mens & Kinders",
        "eMail": "contact@mensenkinders.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Assendorperstraat 66",
        "postCode": "8012CA",
        "city": "Zwolle",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.50742109999999,
        "longitude": 6.099963,
        "customAddr": "Assendorperstraat 66, Zwolle, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNDkxOTM4MzYwMjU4NjcwMDA0MTswMDsn\"",
        "no": "C10614",
        "name": "Baby Spa Laren ",
        "eMail": "info@babyspalaren.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Zutphenseweg 32",
        "postCode": "7245 NS",
        "city": "Laren",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-15",
        "homepage": "https://babyspalaren.nl/",
        "latitude": 52.18467709999999,
        "longitude": 6.357873499999999,
        "customAddr": "Zutphenseweg 32, Laren, NL"
      },
      {
        "@odata.etag": "W/\"JzE4Ozc5NTEzNjgzMDA5MTc4MjE3MTE7MDA7Jw==\"",
        "no": "C10615",
        "name": "Gekaapt Mini",
        "eMail": "info@gekaapt.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kinkerstraat 316",
        "postCode": "1053 GD",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://gekaapt.nl/",
        "latitude": 52.3650931,
        "longitude": 4.8632121,
        "customAddr": "Kinkerstraat 316, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzI0Nzc1OTA3MTM4NzQ2MTk2MDYxOzAwOyc=\"",
        "no": "C10616",
        "name": "Yellow Birds Conceptstore",
        "eMail": "Info@yellowbirds.nl",
        "customerGroup": "PHYSICAL",
        "address": "Julianaplein 96",
        "postCode": "1404 DP",
        "city": "Bussum",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.2757502,
        "longitude": 5.1606127,
        "customAddr": "Julianaplein 96, Bussum, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU4NDM3NDQ3MTA0Nzg2MzY2MzIxOzAwOyc=\"",
        "no": "C10617",
        "name": "Tien! ",
        "eMail": "info@doortien.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Burg Nieuwenhuijzenstr 3",
        "postCode": "5241TA",
        "city": "Rosmalen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.7152211,
        "longitude": 5.363759,
        "customAddr": "Burg Nieuwenhuijzenstr 3, Rosmalen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzkwNDM0ODMwOTEyNDM1OTk0NDAxOzAwOyc=\"",
        "no": "C10618",
        "name": "Lotje Bergen op Zoom",
        "eMail": "isabelleholster@outlook.com",
        "customerGroup": "PHYSICAL",
        "address": "Vogelaar 35A",
        "postCode": "4617 LG",
        "city": "Bergen op Zoom",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.4797032,
        "longitude": 4.2814616,
        "customAddr": "Vogelaar 35A, Bergen op Zoom, NL"
      },
      {
        "@odata.etag": "W/\"JzE3OzMwNDc0MTQ2MzE0NTE1Nzk2MTswMDsn\"",
        "no": "C10619",
        "name": "Omoda B.V. Apparel",
        "eMail": "josje.rood@omoda.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Ruigendijkweg 1",
        "postCode": "4301 RX",
        "city": "Zierikzee",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.omoda.nl/",
        "latitude": 51.64093099999999,
        "longitude": 3.937163,
        "customAddr": "Ruigendijkweg 1, Zierikzee, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk4Njc4MTU3MzM5NDU5MjUzMDkxOzAwOyc=\"",
        "no": "C10620",
        "name": "Schaapskooi Mergelland",
        "eMail": "info@schaapskooimergelland.nl",
        "customerGroup": "PHYSICAL",
        "address": "Julianastraat 41B",
        "postCode": "6285AH",
        "city": "Epen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.schaapskooimergelland.nl/",
        "latitude": 50.7718289,
        "longitude": 5.8909754,
        "customAddr": "Julianastraat 41B, Epen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc4Mzg1NTIyMTg2Mzk4MDA3MDgxOzAwOyc=\"",
        "no": "C10621",
        "name": "MINECIM",
        "eMail": "contact@minecim-store.com",
        "customerGroup": "ONLINE",
        "address": "132 chemin des bleuets",
        "postCode": "73550",
        "city": "Les Allues",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.3734901,
        "longitude": 6.579574699999999,
        "customAddr": "132 chemin des bleuets, Les Allues, FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MDk0NzYxNzczNDA3OTcwMTc1MTswMDsn\"",
        "no": "C10622",
        "name": "Cuts for Glory",
        "eMail": "cutsforglory@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Huigbrouwerstraat 24",
        "postCode": "1811 BJ",
        "city": "Alkmaar",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.6299309,
        "longitude": 4.7490047,
        "customAddr": "Huigbrouwerstraat 24, Alkmaar, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2MjUwMjE2NTcwMDI5NTQwNDE3MTswMDsn\"",
        "no": "C10623",
        "name": "Fanfan la tulipe (la Feline bv)",
        "eMail": "info@fanfan.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Veldpoortstraat 1",
        "postCode": "3961BK",
        "city": "Wijk bij Duurstede ",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9733548,
        "longitude": 5.3453978,
        "customAddr": "Veldpoortstraat 1, Wijk bij Duurstede , NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1ODU5NDQ4NTY0MzI5NjE4OTM5MTswMDsn\"",
        "no": "C10624",
        "name": "SEEN Haren. B.V",
        "eMail": "info@jointheseen.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Brinkhorst 10",
        "postCode": "9751 AT",
        "city": "Haren",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-13",
        "homepage": "",
        "latitude": 53.1731212,
        "longitude": 6.604638500000001,
        "customAddr": "Brinkhorst 10, Haren, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzE2ODI3NTkyNDA1NzU0NjE5NjIxOzAwOyc=\"",
        "no": "C10625",
        "name": "Sample + Stock Sale Babystore",
        "eMail": "info@samplestocksale.nl",
        "customerGroup": "PHYSICAL",
        "address": "Burg. Nieuwenhuijzenstraat 3",
        "postCode": "5241TA",
        "city": "Rosmalen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.7152211,
        "longitude": 5.363759,
        "customAddr": "Burg. Nieuwenhuijzenstraat 3, Rosmalen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNDMyMjYyNTg3MDY4NDM3OTUwMTswMDsn\"",
        "no": "C10626",
        "name": "The Human Fabrique ",
        "eMail": "info@thehumanfabrique.nl",
        "customerGroup": "PHYSICAL",
        "address": "Henk van Turnhoutpad 2",
        "postCode": "2034 MP",
        "city": "Haarlem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3679233,
        "longitude": 4.6398722,
        "customAddr": "Henk van Turnhoutpad 2, Haarlem, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzM1MTI4Mjk3ODIxNzc1OTc2MTE7MDA7Jw==\"",
        "no": "C10627",
        "name": "Ferudath BV",
        "eMail": "calmakids@telenet.be",
        "customerGroup": "PHYSICAL",
        "address": "Keerbaan 13",
        "postCode": "2160",
        "city": "Wommelgem",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.2088796,
        "longitude": 4.5312636,
        "customAddr": "Keerbaan 13, Wommelgem, BE"
      },
      {
        "@odata.etag": "W/\"JzE4OzMwMDA0MzA2ODAwMjQ3MTQ4OTE7MDA7Jw==\"",
        "no": "C10628",
        "name": "Kvinna Vintage",
        "eMail": "kvinnakledingadvies@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Langstraat 117",
        "postCode": "3771BD",
        "city": "Barneveld",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.1379131,
        "longitude": 5.5891063,
        "customAddr": "Langstraat 117, Barneveld, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzExNzc1MjUxMjUzOTY4NjM1MjcxOzAwOyc=\"",
        "no": "C10629",
        "name": "Louise, Acupunctuur en massagetherapie ",
        "eMail": "louisevdbergh@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Vijverlaan 419",
        "postCode": "2923TM",
        "city": "Krimpen Aan Den IJssel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9135405,
        "longitude": 4.6152978,
        "customAddr": "Vijverlaan 419, Krimpen Aan Den IJssel, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMDQ3MjkxMTAxMzA1Njk5ODQ4MTswMDsn\"",
        "no": "C10630",
        "name": "Petit dot",
        "eMail": "jolienpetitdot@outlook.com",
        "customerGroup": "PHYSICAL",
        "address": "Kokkestraat 18",
        "postCode": "5081CN",
        "city": "Hilvarenbeek",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.48503059999999,
        "longitude": 5.1378732,
        "customAddr": "Kokkestraat 18, Hilvarenbeek, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1NzM4ODI0NDY3NzU2MTA1ODc0MTswMDsn\"",
        "no": "C10631",
        "name": "Moreforkidz",
        "eMail": "info@moreforkidz.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Julianastraat 61",
        "postCode": "3161AJ",
        "city": "Rhoon",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8559821,
        "longitude": 4.418809299999999,
        "customAddr": "Julianastraat 61, Rhoon, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzM1MTQ2NTY3MjY5NDI0MDE1MDIxOzAwOyc=\"",
        "no": "C10632",
        "name": "Mishkaa GmbH",
        "eMail": "hello@mishkaa.de",
        "customerGroup": "ONLINE",
        "address": "Im Hesselter 8",
        "postCode": "52080",
        "city": "Aachen",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.7950454,
        "longitude": 6.154909,
        "customAddr": "Im Hesselter 8, Aachen, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2OTY4OTc5NzcxNjk5NjkwMTMzMTswMDsn\"",
        "no": "C10633",
        "name": "Seen Roden B.V.",
        "eMail": "karlien@jointheseen.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Heerestraat 108",
        "postCode": "9301 AH",
        "city": "Roden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.jointheseen.nl/",
        "latitude": 53.13829519999999,
        "longitude": 6.429356599999999,
        "customAddr": "Heerestraat 108, Roden, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMzIxNDkzNjUzMTU2OTcwMDk5MTswMDsn\"",
        "no": "C10634",
        "name": "Just Boeffies",
        "eMail": "info@justboeffies.nl",
        "customerGroup": "PHYSICAL",
        "address": "Zuiderpoort 4a",
        "postCode": "6101 KA",
        "city": "Echt",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.10337089999999,
        "longitude": 5.865177699999999,
        "customAddr": "Zuiderpoort 4a, Echt, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0OTAwNjIwNTMyNjg5ODEyODg5MTswMDsn\"",
        "no": "C10635",
        "name": "Tiny Tribe",
        "eMail": "info@tinytribe.nl",
        "customerGroup": "PHYSICAL",
        "address": "Hoofdstraat 236",
        "postCode": "2171 BP",
        "city": "Sassenheim",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://tinytribe.nl/",
        "latitude": 52.2266551,
        "longitude": 4.5228046,
        "customAddr": "Hoofdstraat 236, Sassenheim, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg2MjEyNjkxODYyNzE3NDA1ODgxOzAwOyc=\"",
        "no": "C10636",
        "name": "Goudkind",
        "eMail": "info@yamore.nl",
        "customerGroup": "ONLINE",
        "address": "Van’t hoffstraat 14",
        "postCode": "2912BJ",
        "city": "Nieuwerkerk aan den ijssel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9648113,
        "longitude": 4.6022625,
        "customAddr": "Van’t hoffstraat 14, Nieuwerkerk aan den ijssel, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzkxMDMwNDUwMzM5NjA0NTA2OTcxOzAwOyc=\"",
        "no": "C10637",
        "name": "Little Department Store",
        "eMail": "info@little-department-store.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Wasserburger Landstraße 186",
        "postCode": "81827",
        "city": "München",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://little-department-store.de/",
        "latitude": 48.1150002,
        "longitude": 11.6956323,
        "customAddr": "Wasserburger Landstraße 186, München, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzcxNDEyMDY3NzkxNTM0Nzg3NjgxOzAwOyc=\"",
        "no": "C10638",
        "name": "De Grote Wolf",
        "eMail": "info@degrotewolf.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Vincent van Goghstraat 12",
        "postCode": "5671 GX",
        "city": "Nuenen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://degrotewolf.com/",
        "latitude": 51.4745828,
        "longitude": 5.550514499999999,
        "customAddr": "Vincent van Goghstraat 12, Nuenen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMzNDY3MTg4NzIwNDczMTAwMjQxOzAwOyc=\"",
        "no": "C10639",
        "name": "Coco Loco",
        "eMail": "alwero@cocoloco.nl",
        "customerGroup": "PHYSICAL",
        "address": " Celsiusplein 49 ",
        "postCode": "5621 BN",
        "city": "Eindhoven",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-13",
        "homepage": "",
        "latitude": 51.4548935,
        "longitude": 5.4540182,
        "customAddr": " Celsiusplein 49 , Eindhoven, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg1MDc1MDAzMDgyNDA5MDg0OTQxOzAwOyc=\"",
        "no": "C10640",
        "name": "Kekkedinge stoer wonen & lifestyle",
        "eMail": "info@kekkedinge.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Raadhuisstraat 21",
        "postCode": "7001 EW",
        "city": "Doetinchem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9641039,
        "longitude": 6.2917143,
        "customAddr": "Raadhuisstraat 21, Doetinchem, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NzU1Njg1Mjk3NzQ3MjYxNjk1MTswMDsn\"",
        "no": "C10641",
        "name": "Pand 21",
        "eMail": "gerrienbrouwer@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Havenplein 12",
        "postCode": "8281EV",
        "city": "Genemuiden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.62353359999999,
        "longitude": 6.040454899999999,
        "customAddr": "Havenplein 12, Genemuiden, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg1MjYzNjE4NjM2NTgzNTg0NzUxOzAwOyc=\"",
        "no": "C10642",
        "name": "C&C",
        "eMail": "info@casa-cotton.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Merwestraat 7",
        "postCode": "4361 HK",
        "city": "Sliedrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8188229,
        "longitude": 4.7690286,
        "customAddr": "Merwestraat 7, Sliedrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzY3MTk2NDIxMzE1MjYwMzEzMTQxOzAwOyc=\"",
        "no": "C10643",
        "name": "Kris# interieuradvies ",
        "eMail": "info@krisvanlangen.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kerkstraat 6",
        "postCode": "7091CH",
        "city": "Dinxperlo",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8620418,
        "longitude": 6.487578399999999,
        "customAddr": "Kerkstraat 6, Dinxperlo, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExOTIxNzA2MTQzODU4MzgyMzY4MTswMDsn\"",
        "no": "C10644",
        "name": "Händlerkonditionen ",
        "eMail": "info@sonnenkinder-showroom.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Westerberg 3",
        "postCode": "27419",
        "city": "Sittensen",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-20",
        "homepage": "",
        "latitude": 53.2705199,
        "longitude": 9.499771200000001,
        "customAddr": "Westerberg 3, Sittensen, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NTQ3ODQ2OTIyMjA4MDE3Njg4MTswMDsn\"",
        "no": "C10645",
        "name": "Chez Brindilles ",
        "eMail": "Chezbrindilles1@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "12 bis rue jeanne d’arc",
        "postCode": "59420",
        "city": "Mouvaux",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.6986064,
        "longitude": 3.1328854,
        "customAddr": "12 bis rue jeanne d’arc, Mouvaux, FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NjYxMDc4Njg2MjI2NTYwMjg5MTswMDsn\"",
        "no": "C10646",
        "name": "Zichzach",
        "eMail": "stolle.karen@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Gelkingestraat 43",
        "postCode": "9711NB",
        "city": "Groningen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://zichzachgroningen.com/",
        "latitude": 53.2164364,
        "longitude": 6.568871199999999,
        "customAddr": "Gelkingestraat 43, Groningen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc0NzkwODc3NzA4MDg2MzM4MTYxOzAwOyc=\"",
        "no": "C10647",
        "name": "LexNaturalis",
        "eMail": "kellymostard@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Hooischelf 12",
        "postCode": "6581SM",
        "city": "Malden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.7795111,
        "longitude": 5.862108099999999,
        "customAddr": "Hooischelf 12, Malden, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMjkzOTA1OTg5NDMyODI3MDkzMTswMDsn\"",
        "no": "C10648",
        "name": "Antonia Pantoffelwinkel",
        "eMail": "info@depantoffelwinkel.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Gasthuismolensteeg 16",
        "postCode": "1016AN",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "www.depantoffelwinkel.nl",
        "latitude": 52.37230479999999,
        "longitude": 4.8875061,
        "customAddr": "Gasthuismolensteeg 16, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNDkxMjA5MjE1MjA0OTI2NDYwMTswMDsn\"",
        "no": "C10649",
        "name": "WeekendMode",
        "eMail": "info@weekendmode.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Strandlaan 313",
        "postCode": "8670",
        "city": "KOKSIJDE",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-12",
        "homepage": "https://weekendmode.be/nl/",
        "latitude": 51.1094805,
        "longitude": 2.6119357,
        "customAddr": "Strandlaan 313, KOKSIJDE, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1OTU0Nzc1NDg4NDMxMzc0NzE0MTswMDsn\"",
        "no": "C10650",
        "name": "Buuf Jelly - Leukste winkel aan het ijsselmeer",
        "eMail": "info@buufjelly.nl",
        "customerGroup": "PHYSICAL",
        "address": "Hellingspad 24",
        "postCode": "8715HT",
        "city": "STAVOREN",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.8852921,
        "longitude": 5.3599602,
        "customAddr": "Hellingspad 24, STAVOREN, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3ODE1OTY0NTUxNDc3MTMyMzI5MTswMDsn\"",
        "no": "C10651",
        "name": "GURUS",
        "eMail": "info@g-u-r-u-s.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Twijnstraat 69",
        "postCode": "3511ZJ",
        "city": "Utrecht",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.g-u-r-u-s.com/",
        "latitude": 52.0822411,
        "longitude": 5.123516299999999,
        "customAddr": "Twijnstraat 69, Utrecht, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzI3MTE5NTcxNjIyODMyMTA3MTExOzAwOyc=\"",
        "no": "C10652",
        "name": "The Wild Babies",
        "eMail": "hello@thewildbabies.com",
        "customerGroup": "ONLINE",
        "address": "Lokhorstweg 12",
        "postCode": "3851SE",
        "city": "Ermelo",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.thewildbabies.com/",
        "latitude": 52.31934039999999,
        "longitude": 5.6206739,
        "customAddr": "Lokhorstweg 12, Ermelo, NL"
      },
      {
        "@odata.etag": "W/\"JzE4Ozk5MDYyMzA0MjY2MjcyODYxODE7MDA7Jw==\"",
        "no": "C10653",
        "name": "Fenouillet",
        "eMail": "anika.jacobs@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Lindenstraat 80 huis",
        "postCode": "1015 KZ",
        "city": "Amsterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3793942,
        "longitude": 4.8832828,
        "customAddr": "Lindenstraat 80 huis, Amsterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU1MjMzODc0NTc3MDk4NzEwNDgxOzAwOyc=\"",
        "no": "C10654",
        "name": "Struin Fair Fashion & Living",
        "eMail": "struinfairfashion@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Boliestraat 22",
        "postCode": "7001BC",
        "city": "Doetinchem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://struin.shop/",
        "latitude": 51.9644661,
        "longitude": 6.288751899999999,
        "customAddr": "Boliestraat 22, Doetinchem, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzI3NDk2NzQ0OTMxMzAwMzc2NDExOzAwOyc=\"",
        "no": "C10655",
        "name": "Sweet Closet",
        "eMail": "sweet-closet@outlook.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Passage 25-27",
        "postCode": "4701AN",
        "city": "Roosendaal",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://sweetycloset.fr/",
        "latitude": 51.5319957,
        "longitude": 4.4570195,
        "customAddr": "Passage 25-27, Roosendaal, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNTE5MTU5MDQ3NTg1NzA5NTgyMTswMDsn\"",
        "no": "C10656",
        "name": "Tinyreshopper",
        "eMail": "info@tinyreshopper.com",
        "customerGroup": "PHYSICAL",
        "address": "Sønder boulevard 39",
        "postCode": "1720",
        "city": "Copenhagen V",
        "countryRegionCode": "DK",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 55.667421,
        "longitude": 12.554922,
        "customAddr": "Sønder boulevard 39, Copenhagen V, DK"
      },
      {
        "@odata.etag": "W/\"JzE5OzI4NTg3NjQwNzUwNzE1NjU4MDIxOzAwOyc=\"",
        "no": "C10657",
        "name": "Little Stork",
        "eMail": "liziedendauw@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Arthur coussensstraat 86",
        "postCode": "8480",
        "city": "Ichtegem",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.littlestork.be/",
        "latitude": 51.08612979999999,
        "longitude": 3.0192781,
        "customAddr": "Arthur coussensstraat 86, Ichtegem, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzNDY3OTYyOTA2NTcxNjc3ODU4MTswMDsn\"",
        "no": "C10658",
        "name": "Bloem Mini Store",
        "eMail": "ga_lorenzo@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Van Hogendorpstraat 65",
        "postCode": "2242KX",
        "city": "Wassenaar",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.145183,
        "longitude": 4.3945069,
        "customAddr": "Van Hogendorpstraat 65, Wassenaar, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNDgzNTk2NzM5MTQ1NTUzNTczMTswMDsn\"",
        "no": "C10659",
        "name": "It's Countless General Trading Company",
        "eMail": "info@itscountless.com",
        "customerGroup": "PHYSICAL",
        "address": "Hawalli Al Plaza Mall Mezannine Floor ",
        "postCode": "30000",
        "city": "Kuwait",
        "countryRegionCode": "KW",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 29.3377518,
        "longitude": 48.0235107,
        "customAddr": "Hawalli Al Plaza Mall Mezannine Floor , Kuwait, KW"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzOTMyNDIzNzY4NjM0MDQ1NDY2MTswMDsn\"",
        "no": "C10660",
        "name": "Jananna",
        "eMail": "info@jananna.com",
        "customerGroup": "ONLINE",
        "address": "Nieuwstraat 12",
        "postCode": "1381 BC",
        "city": "weesp",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.30794969999999,
        "longitude": 5.0412818,
        "customAddr": "Nieuwstraat 12, weesp, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MjMxMTY4ODk1NzMxMDgzNTU5MTswMDsn\"",
        "no": "C10661",
        "name": "Kvinna Vintage ",
        "eMail": "wilmakoudijs68@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Langstraat 117",
        "postCode": "3771BD",
        "city": "Barneveld",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.1379131,
        "longitude": 5.5891063,
        "customAddr": "Langstraat 117, Barneveld, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MDUzODUyOTM3NTg4Mjk5Mzk1MTswMDsn\"",
        "no": "C10662",
        "name": "Little Heroes-Wiesbaden GmbH (leaf fabrics)",
        "eMail": "leonie@leaf-fabrics.com",
        "customerGroup": "PHYSICAL",
        "address": "Webergasse 37",
        "postCode": "65183",
        "city": "Wiesbaden",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.0854377,
        "longitude": 8.2406499,
        "customAddr": "Webergasse 37, Wiesbaden, DE"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg3NDU3MTIxMzUxMTA5MjQ1NTQxOzAwOyc=\"",
        "no": "C10663",
        "name": "Binnen bij Catoos",
        "eMail": "susan@catoos.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kerkplein 82",
        "postCode": "6641BH",
        "city": "Beuningen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8625675,
        "longitude": 5.7722726,
        "customAddr": "Kerkplein 82, Beuningen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk3MTE0MjEyODE0ODI4NzU4NjYxOzAwOyc=\"",
        "no": "C10664",
        "name": "Dushi second hand",
        "eMail": "info@dushisecondhand.nl",
        "customerGroup": "PHYSICAL",
        "address": "Junusstraat 45",
        "postCode": "6701 AX",
        "city": "Wageningen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-07-20",
        "homepage": "https://www.dushisecondhand.nl/",
        "latitude": 51.96603,
        "longitude": 5.6618379,
        "customAddr": "Junusstraat 45, Wageningen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU0NDg5ODMyOTAwNTI2NzM5MzMxOzAwOyc=\"",
        "no": "C10665",
        "name": "Bijzonder Eigen",
        "eMail": "nathalie@bijzondereigen.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Proost de Beaufortstraat 22",
        "postCode": "6231 EB",
        "city": "Meerssen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.8841931,
        "longitude": 5.7466097,
        "customAddr": "Proost de Beaufortstraat 22, Meerssen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4NDI3OTcxNTY1NjUyNDYyNTg5MTswMDsn\"",
        "no": "C10666",
        "name": "Give a pon",
        "eMail": "hello@giveapon.nl",
        "customerGroup": "ONLINE",
        "address": "Marcelisstraat 86",
        "postCode": "2586RZ",
        "city": "Den Haag",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.1060568,
        "longitude": 4.2788743,
        "customAddr": "Marcelisstraat 86, Den Haag, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3Njg0ODQwNjMzMDE2Nzk4ODMwMTswMDsn\"",
        "no": "C10667",
        "name": "WOOD",
        "eMail": "store@woodwassenaar.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Langstraat 27",
        "postCode": "2242KJ",
        "city": "Wassenaar",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.woodwassenaar.nl/",
        "latitude": 52.14452720000001,
        "longitude": 4.392860499999999,
        "customAddr": "Langstraat 27, Wassenaar, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MjA3NzkwNTk4Mjk3MzM5NTE4MTswMDsn\"",
        "no": "C10668",
        "name": "Yulin Du",
        "eMail": "sophiedu4869@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "205/6 Mooltan Ave",
        "postCode": "2113",
        "city": "Macquarie Park",
        "countryRegionCode": "AU",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": -33.7801379,
        "longitude": 151.1130763,
        "customAddr": "205/6 Mooltan Ave, Macquarie Park, AU"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk3NzM1NTU2MDUwODQ0Nzk1ODgxOzAwOyc=\"",
        "no": "C10669",
        "name": "Sunny Yuan",
        "eMail": "letuansunny6@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "502 Room502, Unit2, Building 1, Long Xi Yuan Er Qu, Hui Long Guan, Changping District",
        "postCode": "102208",
        "city": "Beijing",
        "countryRegionCode": "CN",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 40.084775,
        "longitude": 116.338238,
        "customAddr": "502 Room502, Unit2, Building 1, Long Xi Yuan Er Qu, Hui Long Guan, Changping District, Beijing, CN"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMzg3MjIyODY2NjU3ODE0MzQzMTswMDsn\"",
        "no": "C10670",
        "name": "LA Goodies Group",
        "eMail": "lagoodiesgroup@gmail.com",
        "customerGroup": "ONLINE",
        "address": "142 S Turner ave",
        "postCode": "91791",
        "city": "LA",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.lagoodiesgroup.com/",
        "latitude": 30.5190775,
        "longitude": -91.5208624,
        "customAddr": "142 S Turner ave, LA, US"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNzk5Mzc4MjM1MjI2NDA2ODc1MTswMDsn\"",
        "no": "C10671",
        "name": "Heerlijkheid Marienwaerdt Landgoedwinkel",
        "eMail": "nathalie@marienwaerdt.nl",
        "customerGroup": "PHYSICAL",
        "address": "Marienwaerdt, Oude Waag 21",
        "postCode": "4153 RC",
        "city": "Beesd",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.marienwaerdt.nl/",
        "latitude": 51.89430429999999,
        "longitude": 5.1984194,
        "customAddr": "Marienwaerdt, Oude Waag 21, Beesd, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzUxMTkyNzYxOTE1Nzk3NTczNjUxOzAwOyc=\"",
        "no": "C10672",
        "name": "Lepelie",
        "eMail": "info@lepelie.nl",
        "customerGroup": "PHYSICAL",
        "address": "Parelduiker 24",
        "postCode": "2681VH",
        "city": "Monster",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.lepelie.nl/",
        "latitude": 52.0291989,
        "longitude": 4.1700691,
        "customAddr": "Parelduiker 24, Monster, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzkyMTUzMzE1NTQ4NTkwNTQ5ODUxOzAwOyc=\"",
        "no": "C10673",
        "name": "Lifestyle en wol/dock16",
        "eMail": "info@lifestyleenwol.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Henri dunantstraat 16",
        "postCode": "6691EK",
        "city": "Gendt",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8749151,
        "longitude": 5.944744099999999,
        "customAddr": "Henri dunantstraat 16, Gendt, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzE3NzQ5NTEzOTUxNTkwNDYwMTE7MDA7Jw==\"",
        "no": "C10674",
        "name": "Frank & Charlie BV",
        "eMail": "winkel@frankencharlie.nl",
        "customerGroup": "PHYSICAL",
        "address": "Windbrugstraat 12",
        "postCode": "7511HR",
        "city": "Enschede",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.21882799999999,
        "longitude": 6.895803099999999,
        "customAddr": "Windbrugstraat 12, Enschede, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgxNDc0MjE4MTMxMjYyMTU2MDMxOzAwOyc=\"",
        "no": "C10675",
        "name": "Made By keet",
        "eMail": "info@madebykeet.nl",
        "customerGroup": "PHYSICAL",
        "address": "Hogestraat 11",
        "postCode": "6651 BD",
        "city": "Druten",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.891188,
        "longitude": 5.608898099999999,
        "customAddr": "Hogestraat 11, Druten, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMjc0MDMzNjAyOTMyMzI3NTYwMTswMDsn\"",
        "no": "C10676",
        "name": "De Zingel",
        "eMail": "kira@dezingel.be",
        "customerGroup": "PHYSICAL",
        "address": "Plaatsstraat 95",
        "postCode": "1570",
        "city": "Tollembeek",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.7455916,
        "longitude": 3.9920321,
        "customAddr": "Plaatsstraat 95, Tollembeek, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ5NTUzODk2OTc4MjY0MTY4OTExOzAwOyc=\"",
        "no": "C10677",
        "name": "Vierseizoenen (Pics by Riks)",
        "eMail": "vbeekvoortman@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Haarstraat 9 14",
        "postCode": "7462 AK",
        "city": "Rijssen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://vierseizoenen.nl/",
        "latitude": 52.3077231,
        "longitude": 6.5200055,
        "customAddr": "Haarstraat 9 14, Rijssen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1NjI4MDcyNzkzMzg5ODIzNjMzMTswMDsn\"",
        "no": "C10678",
        "name": "mjot",
        "eMail": "christiane@mjot.de",
        "customerGroup": "PHYSICAL",
        "address": "Friesenstraße 5",
        "postCode": "10965",
        "city": "Berlin",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://mjot.de/",
        "latitude": 52.4880354,
        "longitude": 13.3941829,
        "customAddr": "Friesenstraße 5, Berlin, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzIyNTc3MDYyMDkxMTE1NDgxNzExOzAwOyc=\"",
        "no": "C10679",
        "name": "Studio Jules",
        "eMail": "contact@studio-jules.nl",
        "customerGroup": "ONLINE",
        "address": "Wieldraaierstraat 4",
        "postCode": "2645JN",
        "city": "Delfgauw",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.0020771,
        "longitude": 4.390264699999999,
        "customAddr": "Wieldraaierstraat 4, Delfgauw, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzIzNDA5MTg0MTM2NDY5MzczMTQxOzAwOyc=\"",
        "no": "C10681",
        "name": "Drogisterij van der Wielen",
        "eMail": "nadine@drogisterijvanderwielen.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Grotestraat 10c",
        "postCode": "6653 BL",
        "city": "Deest",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.8884142,
        "longitude": 5.6664476,
        "customAddr": "Grotestraat 10c, Deest, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzcxNDU2NTkwMzUxNDM4Mzk1NzE7MDA7Jw==\"",
        "no": "C10682",
        "name": "Cato Home",
        "eMail": "hellocatohome@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Industrierondweg 19",
        "postCode": "8321EB",
        "city": "Urk",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-29",
        "homepage": "",
        "latitude": 52.658328,
        "longitude": 5.6085435,
        "customAddr": "Industrierondweg 19, Urk, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMTc2OTM3MzczNDk4NTE4Nzg3MTswMDsn\"",
        "no": "C10683",
        "name": "t Nestje",
        "eMail": "info@tnestje.nl",
        "customerGroup": "PHYSICAL",
        "address": "dorpsstraat 117a",
        "postCode": "2712AE",
        "city": "Zoetermeer",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://tnestje.nl/",
        "latitude": 52.0551845,
        "longitude": 4.4977547,
        "customAddr": "dorpsstraat 117a, Zoetermeer, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2MjM4MjE5MDM0NDc2MzY0ODU3MTswMDsn\"",
        "no": "C10684",
        "name": "Snowflake Lifestyle AG",
        "eMail": "sara@mysnowflake.ch",
        "customerGroup": "PHYSANDDIG",
        "address": "Hangenmoosstrasse 8",
        "postCode": "8820",
        "city": "Wädenswil, Zürich",
        "countryRegionCode": "CH",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 47.2335564,
        "longitude": 8.6568623,
        "customAddr": "Hangenmoosstrasse 8, Wädenswil, Zürich, CH"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzOTE5ODU5NjE2MDIwNDY3MDUzMTswMDsn\"",
        "no": "C10685",
        "name": "Pear concept store",
        "eMail": "malika@margae.nl",
        "customerGroup": "ONLINE",
        "address": "Vendelier 59-a u4.03",
        "postCode": "3905PD",
        "city": "Veenendaal",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://pearconceptstore.nl/",
        "latitude": 52.0412774,
        "longitude": 5.552050899999999,
        "customAddr": "Vendelier 59-a u4.03, Veenendaal, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyODcxNjc1NjcxNTA0MjI2ODgwMTswMDsn\"",
        "no": "C10686",
        "name": "Bambini Amore",
        "eMail": "info@bambiniamore.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "De Sterreschans 39",
        "postCode": "6584HC",
        "city": "Molenhoek",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://bambiniamore.nl/",
        "latitude": 51.7623365,
        "longitude": 5.871446600000001,
        "customAddr": "De Sterreschans 39, Molenhoek, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyODY4ODc1NjQ4NzAyODQ2OTE4MTswMDsn\"",
        "no": "C10687",
        "name": "La maison de Sophie",
        "eMail": "sophieverdaasdonk@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Westerstraat 77",
        "postCode": "1015 LW",
        "city": "",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3784388,
        "longitude": 4.8845393,
        "customAddr": "Westerstraat 77, , NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMTM5Njg5NzA1MTUxNzY1MzM2MTswMDsn\"",
        "no": "C10688",
        "name": "Tokkelientje",
        "eMail": "info@tokkelientje.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Maarsmansteeg 12",
        "postCode": "2311 EE",
        "city": "Leiden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-15",
        "homepage": "https://www.tokkelientje.nl/",
        "latitude": 52.1585929,
        "longitude": 4.4904586,
        "customAddr": "Maarsmansteeg 12, Leiden, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzUxNTQ4MzI2NjQxOTYyOTUyMDQxOzAwOyc=\"",
        "no": "C10689",
        "name": "Binnenste BUITEN concept store",
        "eMail": "an@diantis.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Provincieweg 449",
        "postCode": "9550",
        "city": "Hillegem",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-23",
        "homepage": "https://binnenstebuitenshop.be/nl",
        "latitude": 50.8963727,
        "longitude": 3.85744,
        "customAddr": "Provincieweg 449, Hillegem, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzU1NDQzNzQ0MTExOTA3MjgyMTkxOzAwOyc=\"",
        "no": "C10690",
        "name": "babyparkmacau",
        "eMail": "info@babyparkmacau.com",
        "customerGroup": "ONLINE",
        "address": "AV. COMENDADOR HO YIN BL. 1, FL 32, FLAT J ED",
        "postCode": "999078",
        "city": "CHENG CHONG",
        "countryRegionCode": "CN",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": null,
        "longitude": null,
        "customAddr": "AV. COMENDADOR HO YIN BL. 1, FL 32, FLAT J ED, CHENG CHONG, CN"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc4OTcyODA3OTc2Mzg5MzcyMTQxOzAwOyc=\"",
        "no": "C10691",
        "name": "BESS",
        "eMail": "bess_mode@hotmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Poelestraat 37",
        "postCode": "9711 PJ",
        "city": "Groningen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.21810989999999,
        "longitude": 6.571472399999999,
        "customAddr": "Poelestraat 37, Groningen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExODMyMzcxODc5MjUxNzg3NjI2MTswMDsn\"",
        "no": "C10692",
        "name": "The World is Your Stage",
        "eMail": "info@twys.nl",
        "customerGroup": "PHYSICAL",
        "address": "Grindweg 262",
        "postCode": "8483 JP",
        "city": "Scherpenzeel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.twys.nl/",
        "latitude": 52.82766460000001,
        "longitude": 5.8749747,
        "customAddr": "Grindweg 262, Scherpenzeel, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzY1NzgzMjQ5NDA1OTg5NDI0NjQxOzAwOyc=\"",
        "no": "C10693",
        "name": "PEPPERMINT CANDY LLC",
        "eMail": "info@peppermintcandyboutique.com",
        "customerGroup": "ONLINE",
        "address": "HIGHLAND AVE 428",
        "postCode": "80302",
        "city": "LONGMONT",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 40.1758117,
        "longitude": -105.0798902,
        "customAddr": "HIGHLAND AVE 428, LONGMONT, US"
      },
      {
        "@odata.etag": "W/\"JzE5OzM1MjY5MDkwNzgyNTc0NzIzNjcxOzAwOyc=\"",
        "no": "C10694",
        "name": "Duurzaam Spelen",
        "eMail": "info@duurzaam-spelen.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "De Wieber 27",
        "postCode": "7122 WP",
        "city": "Aalten",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.duurzaam-spelen.nl/",
        "latitude": 51.92367729999999,
        "longitude": 6.565314,
        "customAddr": "De Wieber 27, Aalten, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ4NjM3MTk3MTg2ODIyNjA0MjMxOzAwOyc=\"",
        "no": "C10695",
        "name": "Meerwärts GbR",
        "eMail": "info@meerwaerts.de",
        "customerGroup": "ONLINE",
        "address": "Heiligengeiststraße 6-8",
        "postCode": "26121",
        "city": "Oldenburg",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-18",
        "homepage": "https://meerwaerts.de/",
        "latitude": 53.1444869,
        "longitude": 8.2135948,
        "customAddr": "Heiligengeiststraße 6-8, Oldenburg, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1MTc4OTM4NDE2OTI3MjI2NjU2MTswMDsn\"",
        "no": "C10696",
        "name": "InMiddels Conceptstores",
        "eMail": "info@inmiddels.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Segeerstraat 24",
        "postCode": "4331JP",
        "city": "Middelburg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.inmiddels.com/",
        "latitude": 51.4980442,
        "longitude": 3.6155692,
        "customAddr": "Segeerstraat 24, Middelburg, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MjMzMDA0NDE4NzI0NTMzNTQxMTswMDsn\"",
        "no": "C10697",
        "name": "Draag je Trots",
        "eMail": "info@draagjetrots.nl",
        "customerGroup": "PHYSICAL",
        "address": "St. Bernardusstraat 64",
        "postCode": "4741 RT",
        "city": "Hoeven",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://draagjetrots.nl/",
        "latitude": 51.5872115,
        "longitude": 4.568792699999999,
        "customAddr": "St. Bernardusstraat 64, Hoeven, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMyMjg1NzEzMzgxNTc0OTUwMDIxOzAwOyc=\"",
        "no": "C10698",
        "name": "Coco's Kidsfashion",
        "eMail": "info@cocoskidsfashion.nl",
        "customerGroup": "ONLINE",
        "address": "Fortunalaan 74",
        "postCode": "7311 GM",
        "city": "Apeldoorn",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.2108913,
        "longitude": 5.984358299999999,
        "customAddr": "Fortunalaan 74, Apeldoorn, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NTYyMzY4MTEyNTk3MDczNjIyMTswMDsn\"",
        "no": "C10699",
        "name": "Bludd",
        "eMail": "info@bludd.nl",
        "customerGroup": "ONLINE",
        "address": "Trientje Timmerstraat 49",
        "postCode": "3882 KN",
        "city": "Putten",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.bludd.nl/",
        "latitude": 52.261486,
        "longitude": 5.578888999999999,
        "customAddr": "Trientje Timmerstraat 49, Putten, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNjQxMTk3NDY5NTUwMjUwOTM0MTswMDsn\"",
        "no": "C10701",
        "name": "Happy Koters",
        "eMail": "info@happykoters.nl",
        "customerGroup": "PHYSICAL",
        "address": "Jensemaheerd 104",
        "postCode": "9743 CL",
        "city": "Groningen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.2531204,
        "longitude": 6.6056608,
        "customAddr": "Jensemaheerd 104, Groningen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzI1MzE2ODMzODI0NjEyNTk0NDQxOzAwOyc=\"",
        "no": "C10702",
        "name": "La Vanil",
        "eMail": "contact@la-vanil.com",
        "customerGroup": "ONLINE",
        "address": "Heikneuter 1",
        "postCode": "5428LJ",
        "city": "Venhorst",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.la-vanil.com/fashion/",
        "latitude": 51.6108678,
        "longitude": 5.736718199999999,
        "customAddr": "Heikneuter 1, Venhorst, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMDI3OTg4MjcyOTQ4Mjc5MjcwMTswMDsn\"",
        "no": "C10705",
        "name": "Babbels & Bubbels",
        "eMail": "info@babbelsenbubbels.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Dorpsstraat 10",
        "postCode": "2381 EL",
        "city": "Zoeterwoude",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.1215635,
        "longitude": 4.496374299999999,
        "customAddr": "Dorpsstraat 10, Zoeterwoude, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzkxODQyMDE5Mzc5NTg0NTQ0MTQxOzAwOyc=\"",
        "no": "C10706",
        "name": "VANWINI",
        "eMail": "Bergsmawini@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Schrans 81",
        "postCode": "8932 NB",
        "city": "Leeuwarden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.vanwini.nl/",
        "latitude": 53.1951781,
        "longitude": 5.7988578,
        "customAddr": "Schrans 81, Leeuwarden, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzY5NDY0NDA4OTkxODAxODE4MTgxOzAwOyc=\"",
        "no": "C10707",
        "name": "Teehaus Teuner ",
        "eMail": "elisa.schoenbrunn@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Steubenstrasse 12",
        "postCode": "99423",
        "city": "Weimar",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.9775437,
        "longitude": 11.3260484,
        "customAddr": "Steubenstrasse 12, Weimar, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNjcwODc4NDIyNTIxNjAxMzg2MTswMDsn\"",
        "no": "C10708",
        "name": "Sasika",
        "eMail": "mevrouwmendez@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Bakkerstraat 22",
        "postCode": "1825 CR",
        "city": "Alkmaar",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.6522596,
        "longitude": 4.750445,
        "customAddr": "Bakkerstraat 22, Alkmaar, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzE4MjM1MjYwNTg2MjMxMTI0MzUxOzAwOyc=\"",
        "no": "C10709",
        "name": "The Birth Bear",
        "eMail": "info@birthbear.com",
        "customerGroup": "ONLINE",
        "address": "Jan Steenlaan 5",
        "postCode": "3723BS",
        "city": "Bilthoven",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.130891,
        "longitude": 5.2047858,
        "customAddr": "Jan Steenlaan 5, Bilthoven, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzNTIxODY0Njc3NTY5Nzg4NDM2MTswMDsn\"",
        "no": "C10710",
        "name": "Toffe Tantes",
        "eMail": "info@toffetantes.nl",
        "customerGroup": "PHYSICAL",
        "address": "Korte achterzijde 10c",
        "postCode": "8302DZ",
        "city": "Emmeloord",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.7107393,
        "longitude": 5.756250199999999,
        "customAddr": "Korte achterzijde 10c, Emmeloord, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQwMDg5MjMyNjUwNzEwNzEyNzMxOzAwOyc=\"",
        "no": "C10711",
        "name": "Choose",
        "eMail": "hsiao-anne@appchoose.io",
        "customerGroup": "ONLINE",
        "address": "rue Pleyel 5",
        "postCode": "93200",
        "city": "Saint Denis",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 48.9193444,
        "longitude": 2.3454641,
        "customAddr": "rue Pleyel 5, Saint Denis, FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1MDI5ODc4MTMwMzEzOTg0NDkyMTswMDsn\"",
        "no": "C10712",
        "name": "Patschefuß Kinderschuhe",
        "eMail": "scm@patschefuss.de",
        "customerGroup": "PHYSICAL",
        "address": "Pariser Straße 54",
        "postCode": "10719",
        "city": "Berlijn",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "http://patschefuss.de/",
        "latitude": 52.4964247,
        "longitude": 13.3261631,
        "customAddr": "Pariser Straße 54, Berlijn, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0OTc2NjA3NjA1NTA5Njk5NTU4MTswMDsn\"",
        "no": "C10713",
        "name": "Maart31",
        "eMail": "info@maart31.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Rijksweg 45",
        "postCode": "6271 AC",
        "city": "Gulpen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://maart31.nl/",
        "latitude": 50.8155505,
        "longitude": 5.8936079,
        "customAddr": "Rijksweg 45, Gulpen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzEwOTYzNTk5MDk5NDM2MjUyMDgxOzAwOyc=\"",
        "no": "C10714",
        "name": "Plek ameland",
        "eMail": "info@plek-ameland.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Kerkstraat 5",
        "postCode": "9163HA",
        "city": "Nes Ameland",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.4459981,
        "longitude": 5.772327199999999,
        "customAddr": "Kerkstraat 5, Nes Ameland, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzYyMTYxMTgyMTk3MTE3MDk3NjQxOzAwOyc=\"",
        "no": "C10715",
        "name": "Safi Essentials",
        "eMail": "info@safi-essentials.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Hofstraat 21",
        "postCode": "8261 BW",
        "city": "Kampen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.55586590000001,
        "longitude": 5.918495099999999,
        "customAddr": "Hofstraat 21, Kampen, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3NzgxMTExMzM0OTQ2NzE3MTM4MTswMDsn\"",
        "no": "C10716",
        "name": "The Blind Spot",
        "eMail": "chantal@theblindspot.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Korte kerkstraat 15",
        "postCode": "4461JE",
        "city": "Goes",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-23",
        "homepage": "https://theblindspot.nl/",
        "latitude": 51.5035951,
        "longitude": 3.8901239,
        "customAddr": "Korte kerkstraat 15, Goes, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMzkxNjU0MDQ4ODY4MTA5NDI0MTswMDsn\"",
        "no": "C10717",
        "name": "VanZus",
        "eMail": "inkoop@vanzus.nl",
        "customerGroup": "ONLINE",
        "address": "Nieuwland parc 327",
        "postCode": "3353CP",
        "city": "Alblasserdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-05-14",
        "homepage": "https://vanzus.nl/",
        "latitude": 51.8416842,
        "longitude": 4.6731528,
        "customAddr": "Nieuwland parc 327, Alblasserdam, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzkxNDU0OTQ0NzY0NjUwNzQ5NzkxOzAwOyc=\"",
        "no": "C10718",
        "name": "Silvermode",
        "eMail": "info@silvermode.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Oudestraat 123",
        "postCode": "8261 CK",
        "city": "Kampen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.5584887,
        "longitude": 5.917045300000001,
        "customAddr": "Oudestraat 123, Kampen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzE5OTA0MDEyNzkwMjQ0NzYyOTExOzAwOyc=\"",
        "no": "C10719",
        "name": "BONNIE BONNIE",
        "eMail": "capucine@bonnie-bonnie.fr",
        "customerGroup": "PHYSANDDIG",
        "address": "403 rue felix dehau",
        "postCode": "59830",
        "city": "Bouvines",
        "countryRegionCode": "FR",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-09-04",
        "homepage": "https://www.bonnie-bonnie.fr/categorie-produit/bebes/",
        "latitude": 50.578661,
        "longitude": 3.1873922,
        "customAddr": "403 rue felix dehau, Bouvines, FR"
      },
      {
        "@odata.etag": "W/\"JzE5OzM0NzA5NzAwMjcyNTYyMDM0MTMxOzAwOyc=\"",
        "no": "C10721",
        "name": "Studiohabbekrats",
        "eMail": "info@studiohabbekrats.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Esschildersstraat 1A",
        "postCode": "2012BB",
        "city": "Haarlem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.3730784,
        "longitude": 4.637265999999999,
        "customAddr": "Esschildersstraat 1A, Haarlem, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMDMzMDUyMjQ0MTEwNTY0MzMxMTswMDsn\"",
        "no": "C10722",
        "name": "Crispy srl",
        "eMail": "paulinedelcorps@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Chaussée de Wavre 187",
        "postCode": "1360",
        "city": "Little Minouche",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.6365062,
        "longitude": 4.782032699999999,
        "customAddr": "Chaussée de Wavre 187, Little Minouche, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzkyMjEwNTI3NTU0Mjc0MTIxMzkxOzAwOyc=\"",
        "no": "C10723",
        "name": "mamuse",
        "eMail": "info@mamuse.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Rechtestraat 6 (shop)",
        "postCode": "2500",
        "city": "Lier",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.1301433,
        "longitude": 4.5719063,
        "customAddr": "Rechtestraat 6 (shop), Lier, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MTMwOTI1OTE3MjE3MDI3OTM3MTswMDsn\"",
        "no": "C10724",
        "name": "Kadeco bv",
        "eMail": "info@kadeco.be",
        "customerGroup": "ONLINE",
        "address": "Beverlosesteenweg 268",
        "postCode": "3583",
        "city": "Paal",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.kadeco.be/",
        "latitude": 51.0558438,
        "longitude": 5.196206099999999,
        "customAddr": "Beverlosesteenweg 268, Paal, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzkxNTcwOTUyNTAxMzg4MjQwODkxOzAwOyc=\"",
        "no": "C10725",
        "name": "CHOUCHOUS EIRL",
        "eMail": "boutiquechouchous@gmail.com",
        "customerGroup": "ONLINE",
        "address": "70 Route du Pissot",
        "postCode": "85270",
        "city": "Saint Hilaire de Riez",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.chouchous.fr/",
        "latitude": 46.7361989,
        "longitude": -1.9510643,
        "customAddr": "70 Route du Pissot, Saint Hilaire de Riez, FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0MDcwNDE5NzUxNDM1Mjc5OTI1MTswMDsn\"",
        "no": "C10726",
        "name": "Beautify by Laura",
        "eMail": "laura_schellekens@hotmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Vrijgezellenstraat 4",
        "postCode": "2169",
        "city": "Wommelgem",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.2005748,
        "longitude": 4.5193427,
        "customAddr": "Vrijgezellenstraat 4, Wommelgem, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NzA3NjQ4OTQ0OTQzODk1Mzg5MTswMDsn\"",
        "no": "C10727",
        "name": "Kadowinkel Ter-Sted",
        "eMail": "h.kramer36@kpnplanet.nl",
        "customerGroup": "PHYSICAL",
        "address": "Ljouwerterdyk 13",
        "postCode": "9172PD",
        "city": "Ferwert",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.3322489,
        "longitude": 5.8089039,
        "customAddr": "Ljouwerterdyk 13, Ferwert, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzQwODUzNzQ4NzAyOTcwNzE5MzkxOzAwOyc=\"",
        "no": "C10728",
        "name": "Baby bubble spa",
        "eMail": "info@babybubblespa.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Knapheideweg 83",
        "postCode": "6562 DS",
        "city": "Groesbeek",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-07",
        "homepage": "",
        "latitude": 51.7554161,
        "longitude": 5.9357538,
        "customAddr": "Knapheideweg 83, Groesbeek, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg2NzU3MTE1MjUyNDE4ODE3NDcxOzAwOyc=\"",
        "no": "C10730",
        "name": "Tuincentrum de Bosrand Wassenaar",
        "eMail": "kantoorwassenaar@bosrand.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Rijksstraatweg 361b",
        "postCode": "2245AB",
        "city": "Wassenaar",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-14",
        "homepage": "https://www.bosrand.nl/winkels/wassenaar",
        "latitude": 52.1390479,
        "longitude": 4.412069,
        "customAddr": "Rijksstraatweg 361b, Wassenaar, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU3MzUzODM3MDUzMDYxMzk4MTUxOzAwOyc=\"",
        "no": "C10731",
        "name": "Amelou BV",
        "eMail": "boogaerts.caroline@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Nieuwbaan 81",
        "postCode": "1785",
        "city": "Merchtem",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.9844011,
        "longitude": 4.222950099999999,
        "customAddr": "Nieuwbaan 81, Merchtem, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMDQ1MzQwMDU1ODcxMDgwMzA3MTswMDsn\"",
        "no": "C10732",
        "name": "Studio Bebe",
        "eMail": "info@studiobebe.be",
        "customerGroup": "ONLINE",
        "address": "Belseledorp 45",
        "postCode": "9111",
        "city": "Belsele",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-14",
        "homepage": "",
        "latitude": 51.1464884,
        "longitude": 4.0927411,
        "customAddr": "Belseledorp 45, Belsele, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzIxMDc5NTg1ODM3ODM4NTE3ODUxOzAwOyc=\"",
        "no": "C10733",
        "name": "Les durables",
        "eMail": "ilona@lesdurables.nl",
        "customerGroup": "PHYSICAL",
        "address": "Dam 11",
        "postCode": "4391 JA",
        "city": "Zierikzee",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-04",
        "homepage": "",
        "latitude": 51.6503215,
        "longitude": 3.9194325,
        "customAddr": "Dam 11, Zierikzee, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzY4NTE4NjQ1MTg1MTc1OTk4NjIxOzAwOyc=\"",
        "no": "C10735",
        "name": "Lins Fashion",
        "eMail": "info@lins-fashion.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Herenweg 21",
        "postCode": "3602AM",
        "city": "Maarssen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.1442509,
        "longitude": 5.06766,
        "customAddr": "Herenweg 21, Maarssen, NL"
      },
      {
        "@odata.etag": "W/\"JzE4Ozk4NTE5MDk2MTAzMDIzMzk5OTE7MDA7Jw==\"",
        "no": "C10736",
        "name": "Ambachtelijke schoenmakerij lakeman",
        "eMail": "Fritslakeman@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Kerkweg 74",
        "postCode": "1961JE",
        "city": "Heemskerk",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.51122909999999,
        "longitude": 4.667727,
        "customAddr": "Kerkweg 74, Heemskerk, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NjY4MTI1NjczMjYzMTQ3MDI0MTswMDsn\"",
        "no": "C10737",
        "name": "Fast Wool",
        "eMail": "erik@fastwool.nl",
        "customerGroup": "ONLINE",
        "address": "Nederwoudseweg 49",
        "postCode": "3770 AA",
        "city": "Barneveld",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.127743,
        "longitude": 5.582059,
        "customAddr": "Nederwoudseweg 49, Barneveld, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzkzMjk5MDY0ODc2OTQxNjYyNjExOzAwOyc=\"",
        "no": "C10738",
        "name": "MARRIN fashion & art",
        "eMail": "marijke@marrinfashion.nl",
        "customerGroup": "PHYSICAL",
        "address": "Markt 32 B",
        "postCode": "5521 AN",
        "city": "Eersel",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.marrinfashion.nl/",
        "latitude": 51.35894219999999,
        "longitude": 5.3088475,
        "customAddr": "Markt 32 B, Eersel, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMzQ4Njc5MDY3NzE3NzA1NTAwMTswMDsn\"",
        "no": "C10739",
        "name": "Zouterik",
        "eMail": "info@zouterik.nl",
        "customerGroup": "PHYSICAL",
        "address": "Middenstreek 11",
        "postCode": "9166 LL",
        "city": "Schiermonnikoog",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.4781061,
        "longitude": 6.1594276,
        "customAddr": "Middenstreek 11, Schiermonnikoog, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3ODU4NjgyMDgyMDI1NDI3NTQzMTswMDsn\"",
        "no": "C10740",
        "name": "Studio pure",
        "eMail": "riemy.streekstra@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Kleine breedstraat 5",
        "postCode": "9101 LB",
        "city": "Dokkum",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 53.32571429999999,
        "longitude": 5.9995331,
        "customAddr": "Kleine breedstraat 5, Dokkum, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg3MDc4NTQ0ODA0NzI0ODA5MTIxOzAwOyc=\"",
        "no": "C10741",
        "name": "Bibabubbel Babywinkel en Babyspa",
        "eMail": "info@bibabubbel.nl",
        "customerGroup": "PHYSICAL",
        "address": "Wilhelminaplein 8",
        "postCode": "3262 SW",
        "city": "Oud beijerland,",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.825957,
        "longitude": 4.4126765,
        "customAddr": "Wilhelminaplein 8, Oud beijerland,, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc4ODYzMjQ5OTE0OTE0NDA2NDcxOzAwOyc=\"",
        "no": "C10742",
        "name": "MARCHE COMMUN",
        "eMail": "manon@marche-commun.com",
        "customerGroup": "ONLINE",
        "address": "Avenue des Tourterelles 90",
        "postCode": "40150",
        "city": "SOORTS-HOSSEGOR",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://marche-commun.com/",
        "latitude": 43.6664782,
        "longitude": -1.437525,
        "customAddr": "Avenue des Tourterelles 90, SOORTS-HOSSEGOR, FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMDQ1ODk1MjA2OTU4ODYwODQ5MTswMDsn\"",
        "no": "C10743",
        "name": "Mulinu Concept store",
        "eMail": "sophie@mulinu.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Zeughausstr 10",
        "postCode": "50667",
        "city": "Koln",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.9413248,
        "longitude": 6.948018299999999,
        "customAddr": "Zeughausstr 10, Koln, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMTQ2NDU4MjQ1MTgzNjY5MTYyMTswMDsn\"",
        "no": "C10744",
        "name": "Dallas",
        "eMail": "dallasgambetta@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "rue Gambetta 1",
        "postCode": "57000",
        "city": "Metz ",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 49.111129,
        "longitude": 6.1728267,
        "customAddr": "rue Gambetta 1, Metz , FR"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg4NjQ5NjYyNzUyODIzNzYzMTYxOzAwOyc=\"",
        "no": "C10745",
        "name": "Tuincentrum de Bosrand Oegstgeest",
        "eMail": "kantooroegstgeest@tcdebosrand.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "De Boeg 10",
        "postCode": "2343HK",
        "city": "Oegstgeest",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-14",
        "homepage": "https://www.bosrand.nl/winkels/oegstgeest",
        "latitude": 52.2004396,
        "longitude": 4.477766799999999,
        "customAddr": "De Boeg 10, Oegstgeest, NL"
      },
      {
        "@odata.etag": "W/\"JzE4OzY5NjAxODkzMDYxNDk2NDM2NzE7MDA7Jw==\"",
        "no": "C10746",
        "name": "Bibi & Papou",
        "eMail": "fatima.zao@bibipapou.com",
        "customerGroup": "PHYSICAL",
        "address": "Rte de Saint-Brice 4",
        "postCode": "95160",
        "city": "Montmorency",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 48.9930961,
        "longitude": 2.3329169,
        "customAddr": "Rte de Saint-Brice 4, Montmorency, FR"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk4ODg4NzQ1NDgyMDA0MDg5NDcxOzAwOyc=\"",
        "no": "C10747",
        "name": "HOST - House of Sweets & Things",
        "eMail": "eva@host-concept.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Statiestraat 56",
        "postCode": "2600",
        "city": "Berchem",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-29",
        "homepage": "https://host-concept.com/",
        "latitude": 51.1981717,
        "longitude": 4.4255607,
        "customAddr": "Statiestraat 56, Berchem, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3OTcwNDYxNTQyMjI1MTIwNTY5MTswMDsn\"",
        "no": "C10748",
        "name": "TITOLANDIA - KARIS DECO",
        "eMail": "karis.titolandia@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "CARRER VENDA DE CAN LLÀTZER, 9",
        "postCode": "07814",
        "city": "IBIZA",
        "countryRegionCode": "ES",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-26",
        "homepage": "",
        "latitude": 38.9979554,
        "longitude": 1.4299175,
        "customAddr": "CARRER VENDA DE CAN LLÀTZER, 9, IBIZA, ES"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk2MTE3NzE0OTc1NTgwNDA2NDYxOzAwOyc=\"",
        "no": "C10749",
        "name": "YBM",
        "eMail": "Info@yoga-body-mind.nl",
        "customerGroup": "PHYSICAL",
        "address": "Kloosterstraat 7",
        "postCode": "6369AA",
        "city": "Simpelveld",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-07-16",
        "homepage": "",
        "latitude": 50.8338739,
        "longitude": 5.9828261,
        "customAddr": "Kloosterstraat 7, Simpelveld, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzI0NTQ0Nzc3NTY2OTc4OTE1NjUxOzAwOyc=\"",
        "no": "C10750",
        "name": "SOFlien",
        "eMail": "evelienwillemsen@outlook.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Nieuwstraat 42",
        "postCode": "2910",
        "city": "Essen",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.4672414,
        "longitude": 4.46934,
        "customAddr": "Nieuwstraat 42, Essen, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzcxNDI1NjIwMzQyMjk4NjAyNTgxOzAwOyc=\"",
        "no": "C10751",
        "name": "Lieve mijn",
        "eMail": "info@lievemijn.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Steenstraat 57",
        "postCode": "5831JB",
        "city": "Boxmeer",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.lievemijn.com/",
        "latitude": 51.64742280000001,
        "longitude": 5.9517279,
        "customAddr": "Steenstraat 57, Boxmeer, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzcxNDc4ODM2Mzk4MjY2ODQ2MzIxOzAwOyc=\"",
        "no": "C10752",
        "name": "Kleiderzimmer",
        "eMail": "kleiderzimmerbonn@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Hermannstraße 20",
        "postCode": "53225",
        "city": "Bonn",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-11",
        "homepage": "https://www.kleiderzimmer-bonn.de/",
        "latitude": 50.7378285,
        "longitude": 7.1165012,
        "customAddr": "Hermannstraße 20, Bonn, DE"
      },
      {
        "@odata.etag": "W/\"JzE4OzM4NzYyNDUxNTY1MTAxMzM0NjE7MDA7Jw==\"",
        "no": "C10753",
        "name": "Emerald trading bv",
        "eMail": "john@emeraldtrading.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "josephine Bakerstraat 7c",
        "postCode": "1311GB",
        "city": "Almere",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-22",
        "homepage": "https://www.maritiemhoorn.nl/",
        "latitude": 52.3662576,
        "longitude": 5.172081299999999,
        "customAddr": "josephine Bakerstraat 7c, Almere, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNDk1MzQyOTcyMjQ3OTQ0MTc5MTswMDsn\"",
        "no": "C10754",
        "name": "Artie women's Wear",
        "eMail": "info@artiemode.nl",
        "customerGroup": "PHYSICAL",
        "address": "Laan 8",
        "postCode": "8071 BX",
        "city": "Nunspeet",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.379425,
        "longitude": 5.785519,
        "customAddr": "Laan 8, Nunspeet, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMyMjk1NzYzNDg5OTU1NjgyODExOzAwOyc=\"",
        "no": "C10755",
        "name": "Texelse Schapenboet",
        "eMail": "info@texelseschapenboet.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Weverstraat 12",
        "postCode": "1791AD",
        "city": "Den Burg",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-14",
        "homepage": "https://www.texelseschapenboet.nl/",
        "latitude": 53.05543890000001,
        "longitude": 4.7973886,
        "customAddr": "Weverstraat 12, Den Burg, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MTY3NDA3NDI2NzYwMDU0NzI2MTswMDsn\"",
        "no": "C10756",
        "name": "Benjamine kinderschoenen",
        "eMail": "lore@benjaminebylore.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Pieter Reypenslei 30",
        "postCode": "2640",
        "city": "Mortsel ",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.benjaminebylore.be/",
        "latitude": 51.16966129999999,
        "longitude": 4.4529628,
        "customAddr": "Pieter Reypenslei 30, Mortsel , BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzM1NzEyMzE1OTQ5MDExMjg5MzcxOzAwOyc=\"",
        "no": "C10757",
        "name": "Sequoia D’AUTAN",
        "eMail": "evi@dautan.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Dorpsstraat 21",
        "postCode": "2950",
        "city": "Kapellen",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.dautan.be/",
        "latitude": 51.31565759999999,
        "longitude": 4.4285831,
        "customAddr": "Dorpsstraat 21, Kapellen, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzI5NzUzNTYzMTA0NTcwMDcwMDAxOzAwOyc=\"",
        "no": "C10759",
        "name": "Schaapmaatje",
        "eMail": "info@schaapmaatje.nl",
        "customerGroup": "ONLINE",
        "address": "Tesselschadestraat 143",
        "postCode": "2026 ST",
        "city": "Haarlem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.4211762,
        "longitude": 4.6487598,
        "customAddr": "Tesselschadestraat 143, Haarlem, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzU2OTgyNTM4Mzg4ODc5MzMyMTYxOzAwOyc=\"",
        "no": "C10760",
        "name": "Chérie Chéri",
        "eMail": "hello@cherie-cheri.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Rue hoche 15",
        "postCode": "35000",
        "city": "Rennes",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 48.1142112,
        "longitude": -1.6774503,
        "customAddr": "Rue hoche 15, Rennes, FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NTgwOTgzODY3MTgwMjQ1NTQyMTswMDsn\"",
        "no": "C10762",
        "name": "Diezijner",
        "eMail": "info@diezijner.eu",
        "customerGroup": "PHYSANDDIG",
        "address": "Zwanestraat 29",
        "postCode": "9743 CL",
        "city": "Groningen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-11",
        "homepage": "https://diezijner.eu/",
        "latitude": 53.2183528,
        "longitude": 6.5638197,
        "customAddr": "Zwanestraat 29, Groningen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzcxOTk5NzQ5MDI3MzIxNTIxNzYxOzAwOyc=\"",
        "no": "C10763",
        "name": "SARALI",
        "eMail": "lilinappy@gmail.com",
        "customerGroup": "ONLINE",
        "address": "Chemin des granges 1",
        "postCode": "91530",
        "city": "Saint maurice montcouronne",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-27",
        "homepage": "https://www.lilinappy.fr/",
        "latitude": 48.582811,
        "longitude": 2.120146,
        "customAddr": "Chemin des granges 1, Saint maurice montcouronne, FR"
      },
      {
        "@odata.etag": "W/\"JzE4OzY3Njg0MzQ2NDMxMTEzODI5MjE7MDA7Jw==\"",
        "no": "C10764",
        "name": "GÅSUNGEN",
        "eMail": "post@gasungen.no",
        "customerGroup": "PHYSANDDIG",
        "address": "Thereses Gate46",
        "postCode": "0168",
        "city": "Oslo",
        "countryRegionCode": "NO",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 59.92647119999999,
        "longitude": 10.731586,
        "customAddr": "Thereses Gate46, Oslo, NO"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ0NjY4NTAxMDcxOTc0MzczNDUxOzAwOyc=\"",
        "no": "C10765",
        "name": "Coni Design BV",
        "eMail": "cora@coni-design.nl",
        "customerGroup": "ONLINE",
        "address": "Pastoor Vernooijstraat 5B",
        "postCode": "7071 BR",
        "city": "Ulft",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-07-16",
        "homepage": "https://alweroshop.nl/",
        "latitude": 51.8915883,
        "longitude": 6.382770499999999,
        "customAddr": "Pastoor Vernooijstraat 5B, Ulft, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzczMDMyMTQ0MTA5MTQ0MDM2NjgxOzAwOyc=\"",
        "no": "C10766",
        "name": "SEEA",
        "eMail": "seeaconceptstore@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Rue Alsace 66",
        "postCode": "17200",
        "city": "Royan",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.6241788,
        "longitude": -1.0450207,
        "customAddr": "Rue Alsace 66, Royan, FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwMjE2NDk3OTI2MDMyMDA5MjQ2MTswMDsn\"",
        "no": "C10769",
        "name": "Society SRL",
        "eMail": "kamikazepadova@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "riviera ponti romani 60",
        "postCode": "35121",
        "city": "Padova",
        "countryRegionCode": "IT",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-05",
        "homepage": "https://kamikaze-store.com/",
        "latitude": 45.4084843,
        "longitude": 11.8785857,
        "customAddr": "riviera ponti romani 60, Padova, IT"
      },
      {
        "@odata.etag": "W/\"JzE5Ozk1NjU2MTc2ODQ1NTIxMzQ0MTAxOzAwOyc=\"",
        "no": "C10770",
        "name": "Holistify",
        "eMail": "contact@holistify.se",
        "customerGroup": "ONLINE",
        "address": "Sandviksgatan 2",
        "postCode": "36542",
        "city": "HOVMANTORP",
        "countryRegionCode": "SE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 56.7833854,
        "longitude": 15.1452787,
        "customAddr": "Sandviksgatan 2, HOVMANTORP, SE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwODkyNTUzNzQ5NjQ3Njk4MjU0MTswMDsn\"",
        "no": "C10771",
        "name": "Celavi srl",
        "eMail": "tanguy@privejoke.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Rue marché au charbon 76-78",
        "postCode": "1000",
        "city": "Brussel",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 50.8457777,
        "longitude": 4.3484302,
        "customAddr": "Rue marché au charbon 76-78, Brussel, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzcwMTk0NTc0NjE4NTkwOTA3MzExOzAwOyc=\"",
        "no": "C10774",
        "name": "Natur-el",
        "eMail": "vera@natur-el.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Zwaanshals 376",
        "postCode": "3035 KT",
        "city": "Rotterdam",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.9328215,
        "longitude": 4.486028999999999,
        "customAddr": "Zwaanshals 376, Rotterdam, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMTY0MjUzMTU2OTc3NTI3MTAzMTswMDsn\"",
        "no": "C10775",
        "name": "Pedico",
        "eMail": "line@pedico.be",
        "customerGroup": "PHYSANDDIG",
        "address": "P. Van Mierlostraat 17",
        "postCode": "2300",
        "city": "Turnhout",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.3211841,
        "longitude": 4.9266261,
        "customAddr": "P. Van Mierlostraat 17, Turnhout, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyOTIwMjgwNzAyMTMyNDM4MzE3MTswMDsn\"",
        "no": "C10782",
        "name": "De Ommekeer Speelgoed",
        "eMail": "info@ommekeerspeelgoed.nl",
        "customerGroup": "PHYSICAL",
        "address": "Kleine Noord 39",
        "postCode": "1621 JE",
        "city": "Hoorn",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "www.ommekeerspeelgoed.nl",
        "latitude": 52.6433532,
        "longitude": 5.0529616,
        "customAddr": "Kleine Noord 39, Hoorn, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMDUxMDUxMTA1NDg2NjkwMzcxMTswMDsn\"",
        "no": "C10783",
        "name": "Ukkies en Pukkies",
        "eMail": "Info@ukkiesenpukkies.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Drooghe bol 1010B",
        "postCode": "1788VA",
        "city": "Julianadorp",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-07-24",
        "homepage": "Https://www.ukkiesenpukkies.nl",
        "latitude": 52.88524260000001,
        "longitude": 4.7407889,
        "customAddr": "Drooghe bol 1010B, Julianadorp, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMTczMTAwNTMxODUzMDM5MDAyMTswMDsn\"",
        "no": "C10784",
        "name": "Mevrouw Janne",
        "eMail": "info@mevrouwjanne.nl",
        "customerGroup": "PHYSICAL",
        "address": "Haverstraatpassage 38",
        "postCode": "7511 EX",
        "city": "Enschede",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-05",
        "homepage": "https://mevrouwjanne.nl/",
        "latitude": 52.22062529999999,
        "longitude": 6.8978702,
        "customAddr": "Haverstraatpassage 38, Enschede, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNjY1NzY0NTE5NjU1NzI1NDc0MTswMDsn\"",
        "no": "C10785",
        "name": "Godo",
        "eMail": "info@godo-hamburg.de",
        "customerGroup": "PHYSICAL",
        "address": "Alsterdorfer Str. 26",
        "postCode": "22299",
        "city": "Hamburg",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-06",
        "homepage": "https://godo-hamburg.de/",
        "latitude": 53.5961531,
        "longitude": 9.997869399999999,
        "customAddr": "Alsterdorfer Str. 26, Hamburg, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwODAyMDU3MzQwNDk3NjE2NjY5MTswMDsn\"",
        "no": "C10786",
        "name": "17;30",
        "eMail": "quinn@1730.de",
        "customerGroup": "PHYSICAL",
        "address": "Grusonstrasse 55",
        "postCode": "22113",
        "city": "Hamburg",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-06",
        "homepage": "www.1730.de",
        "latitude": 53.52914029999999,
        "longitude": 10.0765067,
        "customAddr": "Grusonstrasse 55, Hamburg, DE"
      },
      {
        "@odata.etag": "W/\"JzE4Ozg3MjQwMzcxMzk5ODU5ODEwNDE7MDA7Jw==\"",
        "no": "C10787",
        "name": "Unterhaltung Lieblingsstuecke",
        "eMail": "matthias@unterhaltung-lieblingsstuecke.de",
        "customerGroup": "PHYSICAL",
        "address": "Schillingstrasse 27a",
        "postCode": "44139",
        "city": "Dortmund",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-06",
        "homepage": "www.unterhaltung-lieblingsstuecke.de",
        "latitude": 51.504949,
        "longitude": 7.4547926,
        "customAddr": "Schillingstrasse 27a, Dortmund, DE"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg1OTA2MDMzMzQzODMzMTMxNDUxOzAwOyc=\"",
        "no": "C10788",
        "name": "Louloute SPRL",
        "eMail": "kusjeshop@gmail.com",
        "customerGroup": "PHYSICAL",
        "address": "Rue de la Paix 12",
        "postCode": "1050",
        "city": "Brussel",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-06",
        "homepage": "",
        "latitude": 50.83542629999999,
        "longitude": 4.3645147,
        "customAddr": "Rue de la Paix 12, Brussel, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzE0OTM1NTA5MTc2OTQ1ODI5MDQxOzAwOyc=\"",
        "no": "C10789",
        "name": "t Haagje",
        "eMail": "info@thaagje.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Achterbaan 27",
        "postCode": "1271 TX",
        "city": "Huizen",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-02",
        "homepage": "https://www.thaagje.nl/",
        "latitude": 52.29862019999999,
        "longitude": 5.2349494,
        "customAddr": "Achterbaan 27, Huizen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzgwMzczNzE1NDQ1MzcwNTAyMTYxOzAwOyc=\"",
        "no": "C10790",
        "name": "Noi Gbr",
        "eMail": "noi-shop@web.de",
        "customerGroup": "PHYSICAL",
        "address": "Hüttenallee 237",
        "postCode": "47800",
        "city": "Krefeld",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-02-06",
        "homepage": "https://www.noi-krefeld.de/",
        "latitude": 51.3562204,
        "longitude": 6.597374599999999,
        "customAddr": "Hüttenallee 237, Krefeld, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE0NDk5MTAzMzU1OTg5OTMyNzUwMTswMDsn\"",
        "no": "C10791",
        "name": "Tondeldoos",
        "eMail": "info@speelgoedwinkeldoetinchem.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Adelaarstraat 3",
        "postCode": "7001 AR",
        "city": "Doetinchem",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.speelgoedwinkeldoetinchem.nl/",
        "latitude": 51.9638577,
        "longitude": 6.289975699999999,
        "customAddr": "Adelaarstraat 3, Doetinchem, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyOTg3MjI5OTQxNDA1MDQ5ODI3MTswMDsn\"",
        "no": "C10792",
        "name": "Lazy Lama",
        "eMail": "info@lazylama.nl",
        "customerGroup": "ONLINE",
        "address": "Mariendonkstraat 25",
        "postCode": "5154 EG",
        "city": "Elshout,",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.7034312,
        "longitude": 5.1485892,
        "customAddr": "Mariendonkstraat 25, Elshout,, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MzMwNTUzNjgyMDIwMjkwNDEzMTswMDsn\"",
        "no": "C10793",
        "name": "Reiger en de Raaf",
        "eMail": "florrie@reigerenderaaf.nl",
        "customerGroup": "ONLINE",
        "address": "Klokkenberg 12",
        "postCode": "4836  AZ",
        "city": "Breda",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-11",
        "homepage": "https://reigerenderaaf.nl/",
        "latitude": 51.539677,
        "longitude": 4.778175,
        "customAddr": "Klokkenberg 12, Breda, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzMwNTc3NzEyNjkyMzczODM4MTkxOzAwOyc=\"",
        "no": "C10794",
        "name": "TragBar",
        "eMail": "mail@tragbar-kiel.de",
        "customerGroup": "PHYSICAL",
        "address": "Holtenauer Str. 174",
        "postCode": "24105",
        "city": "Kiel",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 54.3409078,
        "longitude": 10.1339862,
        "customAddr": "Holtenauer Str. 174, Kiel, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzExMDE1NjE0OTcwMjU2NDA0OTU0MTswMDsn\"",
        "no": "C10795",
        "name": "HEJ Store",
        "eMail": "info@hej-store.de",
        "customerGroup": "PHYSICAL",
        "address": "Kleine Beurhausstr. 6",
        "postCode": "44137",
        "city": "Dortmund",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 51.5083707,
        "longitude": 7.4529182,
        "customAddr": "Kleine Beurhausstr. 6, Dortmund, DE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2ODM2MzgxMTcyMzAzNjcxMDg2MTswMDsn\"",
        "no": "C10796",
        "name": "HAPPY MARMOTTE",
        "eMail": "info@happymarmotte.com",
        "customerGroup": "PHYSICAL",
        "address": "avenue du Prariond 554",
        "postCode": "73150",
        "city": "Val d'Isère, Savoie",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 45.44660529999999,
        "longitude": 6.986126199999999,
        "customAddr": "avenue du Prariond 554, Val d'Isère, Savoie, FR"
      },
      {
        "@odata.etag": "W/\"JzE5OzUxMzk0NTA3MjA1MjU5ODU1NzUxOzAwOyc=\"",
        "no": "C10797",
        "name": "Marinsel GmbH",
        "eMail": "info@marinsel.ch",
        "customerGroup": "ONLINE",
        "address": "Lothringerstrasse 23",
        "postCode": "4056",
        "city": "Basel-Stadt",
        "countryRegionCode": "CH",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 47.5666263,
        "longitude": 7.5787849,
        "customAddr": "Lothringerstrasse 23, Basel-Stadt, CH"
      },
      {
        "@odata.etag": "W/\"JzIwOzE1ODYzNjAzMTYyNTY3NDkwNjQzMTswMDsn\"",
        "no": "C10798",
        "name": "Little Moustache",
        "eMail": "info@littlemoustache.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Velduil 4",
        "postCode": "5854HN",
        "city": "Nieuw Bergen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-06",
        "homepage": "https://little-moustache.be/",
        "latitude": 51.597672,
        "longitude": 6.0588229,
        "customAddr": "Velduil 4, Nieuw Bergen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzEwNDMyODQ0OTI5MzE0NzcxMDcxOzAwOyc=\"",
        "no": "C10800",
        "name": "Tuincentrum de Bosrand Woerden",
        "eMail": "kantoorwoerden@tcdebosrand.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Rietveld 36a",
        "postCode": "3443 XC",
        "city": "Woerden",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-14",
        "homepage": "https://www.bosrand.nl/winkels/woerden",
        "latitude": 52.0885073,
        "longitude": 4.856022299999999,
        "customAddr": "Rietveld 36a, Woerden, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyNjI5NTY5NzA0NTMwNDI4NjY4MTswMDsn\"",
        "no": "C10801",
        "name": "De Bosrand Ecommerce",
        "eMail": "pim@tcdebosrand.nl",
        "customerGroup": "ONLINE",
        "address": "De Boeg 10",
        "postCode": "2343 HK",
        "city": "Oegstgeest",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-16",
        "homepage": "https://www.bosrand.nl/",
        "latitude": 52.2004396,
        "longitude": 4.477766799999999,
        "customAddr": "De Boeg 10, Oegstgeest, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEwNTMzMDAzNjY2NTg2MTMzNzI5MTswMDsn\"",
        "no": "C10804",
        "name": "JUULS Comm V",
        "eMail": "hello@juuls-store.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Stationsstraat 230",
        "postCode": "9880",
        "city": "Aalter",
        "countryRegionCode": "BE",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-15",
        "homepage": "https://www.juuls-store.be/nl/",
        "latitude": 51.0907682,
        "longitude": 3.4470413,
        "customAddr": "Stationsstraat 230, Aalter, BE"
      },
      {
        "@odata.etag": "W/\"JzE5OzQ1MTA3NjQwNzY4MTQ4NTMyMTcxOzAwOyc=\"",
        "no": "C10805",
        "name": "J&K samen",
        "eMail": "info@jksamen.nl",
        "customerGroup": "PHYSICAL",
        "address": "Zaanweg 100B",
        "postCode": "1521 DP",
        "city": "Wormerveer",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.4908933,
        "longitude": 4.7914884,
        "customAddr": "Zaanweg 100B, Wormerveer, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE4MjUzODI4NjM2MTc4MzU2NjEwMTswMDsn\"",
        "no": "C10806",
        "name": "ikbenmama",
        "eMail": "andrea@ikbenmama.nl",
        "customerGroup": "ONLINE",
        "address": "Kreitenmolenstraat 33D",
        "postCode": "5071BA",
        "city": "Udenhout",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.ikbenmama.nl/",
        "latitude": 51.61121809999999,
        "longitude": 5.143606699999999,
        "customAddr": "Kreitenmolenstraat 33D, Udenhout, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzM2OTAyOTc4MTc4MjA5MjMwNzgxOzAwOyc=\"",
        "no": "C10807",
        "name": "Babilo",
        "eMail": "info@babilo.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Brusselsesteenweg 9A",
        "postCode": "3080",
        "city": "Tervuren",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-06-05",
        "homepage": "www.babilo.be",
        "latitude": 50.8245601,
        "longitude": 4.512194099999999,
        "customAddr": "Brusselsesteenweg 9A, Tervuren, BE"
      },
      {
        "@odata.etag": "W/\"JzE5Ozc2NTIyNDc2NTYxOTEzMzMwNTIxOzAwOyc=\"",
        "no": "C10808",
        "name": "monacoo bv",
        "eMail": "info@momokids.be",
        "customerGroup": "PHYSANDDIG",
        "address": "Jan Breydellaan 19",
        "postCode": "8500",
        "city": "Kortrijk",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.momokids.be/",
        "latitude": 50.8281418,
        "longitude": 3.279299,
        "customAddr": "Jan Breydellaan 19, Kortrijk, BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MTQwMzUxMzY3NzE0NTM5MTE0MTswMDsn\"",
        "no": "C10810",
        "name": "mirander-made for kids",
        "eMail": "miran@schreef.nl",
        "customerGroup": "PHYSICAL",
        "address": "Lange Bisschopstraat 18",
        "postCode": "7411 KK",
        "city": "Deventer",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.25275120000001,
        "longitude": 6.1567292,
        "customAddr": "Lange Bisschopstraat 18, Deventer, NL"
      },
      {
        "@odata.etag": "W/\"JzE5OzE1NTkyMzg5MzIzNjEyOTQ2MDUxOzAwOyc=\"",
        "no": "C10811",
        "name": "Baboffel",
        "eMail": "post@baboffel.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Brinkhorst 20",
        "postCode": "9751AT",
        "city": "Haren",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-07-23",
        "homepage": "https://www.baboffel.nl/",
        "latitude": 53.1733201,
        "longitude": 6.6045244,
        "customAddr": "Brinkhorst 20, Haren, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzE3MjAwNDMzNzI5MDIxNzc0NDgxMTswMDsn\"",
        "no": "C10812",
        "name": "Côté Montagne",
        "eMail": "cotemontagne@orange.fr",
        "customerGroup": "PHYSANDDIG",
        "address": "43 rue vincent MIR",
        "postCode": "65170",
        "city": "SAINT LARY SOULAN",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://cote-montagne.fr/",
        "latitude": 42.8164307,
        "longitude": 0.3218502,
        "customAddr": "43 rue vincent MIR, SAINT LARY SOULAN, FR"
      },
      {
        "@odata.etag": "W/\"JzE5OzEwODg2NDAxNzg2MTIwNTgyNTIxOzAwOyc=\"",
        "no": "C10816",
        "name": "OH SVENI YEAH",
        "eMail": "svenja@ohsveniyeah.de",
        "customerGroup": "PHYSANDDIG",
        "address": "Steinweg 63",
        "postCode": "52222",
        "city": "Stolberg",
        "countryRegionCode": "DE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://ohsveniyeah.de/",
        "latitude": 50.7685386,
        "longitude": 6.2311006,
        "customAddr": "Steinweg 63, Stolberg, DE"
      },
      {
        "@odata.etag": "W/\"JzE5OzQwODYwMjIxMTY3NzMyOTQxNjgxOzAwOyc=\"",
        "no": "C10818",
        "name": "By Mölle B.V.",
        "eMail": "marianne@bymolle.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Koesteeg 9",
        "postCode": "7722 RM",
        "city": "Dalfsen",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://bymolle.com/",
        "latitude": 52.5157969,
        "longitude": 6.2591632,
        "customAddr": "Koesteeg 9, Dalfsen, NL"
      },
      {
        "@odata.etag": "W/\"JzE5Ozg1NTE1NzAzOTY2NDMxNDQ1NTgxOzAwOyc=\"",
        "no": "C10821",
        "name": "Grandir Family Store",
        "eMail": "marineszabo@gmail.com",
        "customerGroup": "PHYSANDDIG",
        "address": "Rue de la Samme 9",
        "postCode": "7181",
        "city": "Arquennes ( Seneffe)",
        "countryRegionCode": "BE",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-08-12",
        "homepage": "",
        "latitude": 50.56730760000001,
        "longitude": 4.2738223,
        "customAddr": "Rue de la Samme 9, Arquennes ( Seneffe), BE"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNTU2ODM4Mjk5OTc5ODQ3NjI4MTswMDsn\"",
        "no": "C10823",
        "name": "Twee21",
        "eMail": "info@twee21.nl",
        "customerGroup": "PHYSANDDIG",
        "address": "Van Weedestraat 88",
        "postCode": "3761 CH",
        "city": "Soest",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://www.twee21.nl/",
        "latitude": 52.1866138,
        "longitude": 5.2947511,
        "customAddr": "Van Weedestraat 88, Soest, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMzg2NDQ1MzczNjM4MjM1MjUyMTswMDsn\"",
        "no": "C10824",
        "name": "Unknown Stories",
        "eMail": "marit@unknown-stories.com",
        "customerGroup": "ONLINE",
        "address": "Koldijksterraklaan 165",
        "postCode": "3544 PK",
        "city": "",
        "countryRegionCode": "NL",
        "noOfQuotes": 1,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-09-03",
        "homepage": "https://www.unknown-stories.com/",
        "latitude": 52.0858096,
        "longitude": 5.0647585,
        "customAddr": "Koldijksterraklaan 165, , NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEzMTI5MDAwMDU1OTE3MDI4MjQ2MTswMDsn\"",
        "no": "C10825",
        "name": "Home of Joy",
        "eMail": "sales@enjoykidsus.com",
        "customerGroup": "ONLINE",
        "address": "1428 241st Pl SE ",
        "postCode": "98021-5063",
        "city": "Bothell, Washington",
        "countryRegionCode": "US",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-09-03",
        "homepage": "https://enjoykidsus.com/",
        "latitude": 47.7786405,
        "longitude": -122.213496,
        "customAddr": "1428 241st Pl SE , Bothell, Washington, US"
      },
      {
        "@odata.etag": "W/\"JzIwOzExNjU5NDc0Mjc2MzY0MjI1ODA5MTswMDsn\"",
        "no": "C10826",
        "name": "Schaapskudde exloo shop",
        "eMail": "shop@schaapskuddeexloo.nl",
        "customerGroup": "PHYSICAL",
        "address": "Zuiderhoofdstraat 8",
        "postCode": "7875 BX",
        "city": "Exloo",
        "countryRegionCode": "NL",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "",
        "latitude": 52.88139,
        "longitude": 6.864024499999999,
        "customAddr": "Zuiderhoofdstraat 8, Exloo, NL"
      },
      {
        "@odata.etag": "W/\"JzIwOzEyMTcwODk5OTkxMzc2NjA1MjE3MTswMDsn\"",
        "no": "C10827",
        "name": "DREAMABLE SAS, At Wework",
        "eMail": "i.langlet@smallable.com",
        "customerGroup": "PHYSANDDIG",
        "address": "40 rue du Colisée",
        "postCode": "75008",
        "city": "Paris",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 1,
        "noOfInvoices": 0,
        "lastOrderDate": "2024-03-05",
        "homepage": "https://www.smallable.com/",
        "latitude": 48.8716518,
        "longitude": 2.3110872,
        "customAddr": "40 rue du Colisée, Paris, FR"
      },
      {
        "@odata.etag": "W/\"JzIwOzE2NDM5NjMzODQ5OTg5ODYyOTgwMTswMDsn\"",
        "no": "C10828",
        "name": "Vent d'Ailleurs",
        "eMail": "ventdailleurs@orange.fr",
        "customerGroup": "ONLINE",
        "address": "Boulevard Kellermann 42-44",
        "postCode": "28200",
        "city": "CHÂTEAUDUN",
        "countryRegionCode": "FR",
        "noOfQuotes": 0,
        "noOfOrders": 0,
        "noOfInvoices": 0,
        "lastOrderDate": "0001-01-01",
        "homepage": "https://ventdailleurs.eu/",
        "latitude": 48.07213480000001,
        "longitude": 1.3422833,
        "customAddr": "Boulevard Kellermann 42-44, CHÂTEAUDUN, FR"
      }
    ]
  }
]